// AUTO-GENERATED by scripts/generate-locales.ts. Do not edit directly.

export type Locale = "ca" | "en" | "es"

export const SOURCE_LOCALE: Locale = "en"

export const SUPPORTED_LOCALES: readonly Locale[] = [
  "ca",
  "en",
  "es",
] as const

export const NATIVE_NAMES: Readonly<Record<Locale, string>> = {
  "ca": "Català",
  "en": "English",
  "es": "Español",
}

/**
 * Per-locale translation coverage (fraction of source keys
 * translated, 0..1). Source locale is always 1.0. Computed at
 * codegen time; gate for the public picker is 0.8.
 */
export const LOCALE_COVERAGE: Readonly<Record<Locale, number>> = {
  "ca": 1.0000,
  "en": 1.0000,
  "es": 1.0000,
}

/**
 * Subset of SUPPORTED_LOCALES that meets the picker visibility
 * threshold (`coverage >= 0.8`). Below-threshold locales stay
 * reachable via `?lang=<code>` for testing; they only disappear
 * from the public language picker. Source locale is always
 * included regardless of coverage.
 */
export const PICKER_LOCALES: readonly Locale[] = [
  "ca",
  "en",
  "es",
] as const

/** English source bundle — always available synchronously. */
const enLiteral = {
  "account.banner.ok": "OK",
  "account.banner.yourPlan": "Your plan",
  "account.delete.body": "This deletes your account and everything kept for it. A licence on it is taken off and its seat given back; the licence itself is not cancelled. To confirm, type your email address.",
  "account.delete.confirm": "Delete my account",
  "account.delete.done": "Your account was deleted.",
  "account.delete.label": "Your email address",
  "account.delete.mismatch": "That is not this account's email address.",
  "account.delete.notConfirmed": "The account was not deleted: it needs a confirmation (a passkey or an emailed code). Try again.",
  "account.delete.subscription": "Cancel your subscription first (Your plan → Manage subscription). Once it has ended you can delete the account.",
  "account.delete.title": "Delete account",
  "account.menu.about": "About AYNI XR",
  "account.menu.delete": "Delete account",
  "account.menu.inUse": "In use: {plan}",
  "account.menu.language": "Language",
  "account.menu.manual": "User manual",
  "account.menu.passkeys": "Passkeys",
  "account.menu.plan": "Your plan",
  "account.menu.plans": "Plans and pricing",
  "account.menu.privacy": "Privacy policy",
  "account.menu.signIn": "Sign in",
  "account.menu.signOut": "Sign out",
  "account.menu.signedIn": "Signed in",
  "account.menu.signedOutBody": "Sign in with your free account to use AYNI XR and your licence on any device. Joining a room or a meeting never needs an account.",
  "account.menu.switch": "Switch",
  "account.menu.terms": "Terms of use",
  "account.menu.title": "Account",
  "account.notice.ended": "Your {plan} licence (key ending {hint}) has ended.",
  "account.notice.nowNone": "None of your other licences is current.",
  "account.notice.nowUsing": "You are now using your {plan} licence.",
  "account.notice.refused": "Your {plan} licence (key ending {hint}) was taken off your account. {reason}",
  "account.signIn.devLink": "Open the sign-in link (local server)",
  "account.signIn.done": "You are signed in.",
  "account.signIn.emailLabel": "Email",
  "account.signIn.emailSend": "Email me a sign-in link",
  "account.signIn.error.challengeFailed": "The check did not pass. Please try the check again.",
  "account.signIn.error.googleDenied": "Google sign-in was cancelled.",
  "account.signIn.error.googleFailed": "Google sign-in did not work. Try again, or use an email link.",
  "account.signIn.error.googleUnavailable": "Google sign-in is not available yet. Use an email link.",
  "account.signIn.error.invalidEmail": "That does not look like an email address.",
  "account.signIn.error.linkExpired": "That sign-in link has expired: links work for 15 minutes. Ask for a new one.",
  "account.signIn.error.linkInvalid": "That sign-in link is not valid. Ask for a new one.",
  "account.signIn.error.linkUsed": "That sign-in link was already used. Ask for a new one.",
  "account.signIn.error.mailUnavailable": "Sign-in emails cannot be sent right now. Try again later.",
  "account.signIn.error.tooMany": "Three links were sent in the last 15 minutes. Use the newest one, or try again later.",
  "account.signIn.error.unreachable": "The site could not be reached. Check the connection and try again.",
  "account.signIn.google": "Continue with Google",
  "account.signIn.lead": "Sign in, or create an account: your first sign-in creates it. Your account holds your AYNI XR licence on every device you use.",
  "account.signIn.or": "or",
  "account.signIn.privacy": "What an account keeps, and for how long:",
  "account.signIn.sending": "Sending…",
  "account.signIn.sent": "Check your inbox: a sign-in link is on its way to {email}. It works once, for 15 minutes.",
  "account.signIn.title": "Sign in",
  "account.signIn.unavailable": "Signing in is not available yet.",
  "account.switch.closed": "You are now using your {plan} licence. Closed, as it is not included: {list}.",
  "account.switch.done": "You are now using your {plan} licence.",
  "accuracy.clipping": "{low} of cells below the range and {high} above, clipped to its ends; the furthest value was {furthest}.",
  "accuracy.clippingShare": "{share} of values fell outside the scale and show its end instead.",
  "accuracy.codec": "Mean {mean}; 99 % of cells within {p99}; largest {max}.",
  "accuracy.codec.bound": "Under 1 % of values arrive more than one step from the rounded values; the largest difference is {max}.",
  "accuracy.codec.lossless": "Every value arrives exactly as rounded.",
  "accuracy.codec.measured": "99 % of values arrive within {p99} of the rounded values; the largest difference is {max}.",
  "accuracy.codec.steps": "{n} steps",
  "accuracy.codec.unpublished": "Not stated for this release, so values can be off by more than the rounding.",
  "accuracy.differs": "These figures differ from the ones the processor reported when this release was reviewed. The figures shown are the published release’s own.",
  "accuracy.exact.none": "This release has no exact values beside the stream.",
  "accuracy.exact.stored": "The exact values are stored beside the stream, encrypted. Pins and Analyze read the stream for now; reading the exact values comes later.",
  "accuracy.frame.codec": "largest streaming difference in this frame: {max}",
  "accuracy.frame.files": "source files: {files}",
  "accuracy.frame.loading": "Reading this frame's record…",
  "accuracy.frame.none": "This release does not record its frames' sources.",
  "accuracy.frame.run": "{time}, from the {run} run",
  "accuracy.frame.time": "{time}",
  "accuracy.frameNumber": "frame {n}",
  "accuracy.intro": "Measured by reading the published stream back and comparing it, cell by cell and frame by frame, with the data it was made from.",
  "accuracy.noData": "{mean} of cells per frame on average, {max} at most.",
  "accuracy.notMeasured": "not measured",
  "accuracy.publicIntro": "How far a value read here can be from the provider's own number, and where it came from.",
  "accuracy.quantisation": "One step is {step}, so rounding moves a value by at most {half}.",
  "accuracy.quantisationClasses": "Classes: each class is kept exactly.",
  "accuracy.quantisationRelative": "One step is {percent} of the value, so rounding moves a value by at most half of that.",
  "accuracy.regrid": "{method}, from {from} to {to}: mean difference {mean}, 99 % within {p99}.",
  "accuracy.regridNative": "{method}; against the provider's own grid, 99 % within {p99}.",
  "accuracy.release.text": "{id}, published {date}",
  "accuracy.row.clipping": "Clipping",
  "accuracy.row.codec": "Streaming",
  "accuracy.row.frame": "This frame",
  "accuracy.row.noData": "No data",
  "accuracy.row.quantisation": "Rounding",
  "accuracy.row.regrid": "Regridding",
  "accuracy.row.release": "Release",
  "accuracy.row.source": "Source",
  "accuracy.row.time": "Time axis",
  "accuracy.source.classValue.midpoint": "midpoint",
  "accuracy.source.classValue.other": "representative value",
  "accuracy.source.classes": "The provider gives this variable only as classes; each value shown is its class's {how}.",
  "accuracy.source.image": "The values were recovered from the provider's coloured picture, not from its numbers.",
  "accuracy.table.caption": "Error budget: each source of error and what was measured",
  "accuracy.time": "{missing} missing, {repeated} repeated and {frozen} frozen frames.",
  "accuracy.title": "Accuracy",
  "accuracy.tolerance.fail": "Does not meet the tolerance you set: {rule}.",
  "accuracy.tolerance.failAchieved": "Does not meet the tolerance you set: {rule} (measured {achieved}).",
  "accuracy.tolerance.none": "No tolerance was set for this release.",
  "accuracy.tolerance.pass": "Meets the tolerance you set: {rule}.",
  "accuracy.tolerance.passAchieved": "Meets the tolerance you set: {rule} (measured {achieved}).",
  "accuracy.tolerance.unknown": "Tolerance: {rule}. Whether it is met has not been reported yet.",
  "accuracy.toleranceRule": "{quantile} of values within {abs}",
  "accuracy.valueRule": "A value read here is shown with its ±, for example {example}: 99 % of cells are within it (half a step of rounding plus the streaming’s 99th percentile). Regridding and clipping are listed separately below.",
  "accuracy.valueRuleRoundingOnly": "A value read here is shown with the ± of rounding, for example {example}. The streaming error is not stated for this release, so the real error can be larger.",
  "accuracy.worstFrame": "Worst frame: {frame}.",
  "activity.answerPin": "The answer",
  "activity.answered": "Answered: {n}",
  "activity.answers.back": "All activities",
  "activity.answers.count": "{n} answered",
  "activity.answers.east": "E",
  "activity.answers.kind.choice": "Choice",
  "activity.answers.kind.explore": "Explore",
  "activity.answers.kind.point": "Point",
  "activity.answers.kind.poll": "Poll",
  "activity.answers.km": "{km} km away",
  "activity.answers.loading": "Loading…",
  "activity.answers.nobody": "Nobody answered.",
  "activity.answers.none": "No activities yet.",
  "activity.answers.north": "N",
  "activity.answers.pins": "{n} pins",
  "activity.answers.pollAnon": "Polls are anonymous: only the totals are kept.",
  "activity.answers.south": "S",
  "activity.answers.west": "W",
  "activity.bar.aria": "Activity",
  "activity.choice.sent": "Answer sent. You can change it until the reveal.",
  "activity.drivers.giveBack": "Give it back",
  "activity.drivers.item": "{name} drives globe {n}",
  "activity.drivers.me": "You drive globe {n}: turn it, give it a dataset, set its date. Everyone sees it.",
  "activity.drivers.pill": "Globes: {n}",
  "activity.drivers.someone": "A participant",
  "activity.drivers.takeBack": "Take back",
  "activity.drivers.title": "Globes handed out",
  "activity.duration.label": "For how long?",
  "activity.duration.minutes": "{n} min",
  "activity.duration.none": "No limit",
  "activity.duration.seconds": "{n} s",
  "activity.end": "End",
  "activity.error.options": "Give at least two options.",
  "activity.error.prompt": "Write what you ask first.",
  "activity.exit.end": "End meeting",
  "activity.exit.endConfirm": "End the meeting for everyone? Everyone leaves it, the names and answers it kept are deleted, and its links stop working.",
  "activity.exit.leave": "Leave",
  "activity.exit.leaveConfirm": "Leave this meeting? You can come back with the same link while it lasts.",
  "activity.exit.title": "This meeting",
  "activity.explore.end": "Bring everyone back",
  "activity.explore.free": "The globe and Tools are yours until the time is up or the presenter brings everyone back.",
  "activity.explore.lead": "Exploring: {prompt}",
  "activity.explore.note.placeholder": "What did you find? (optional)",
  "activity.explore.pin": "Pin what you found",
  "activity.explore.pin.cancel": "Cancel",
  "activity.explore.pin.send": "Pin it",
  "activity.explore.pinTap": "Tap the globe where it is.",
  "activity.explore.pinned": "Pinned {n} of {max}",
  "activity.explore.pins": "Pins: {n}",
  "activity.explore.sent": "Pinned. The presenter can see it.",
  "activity.hand.lower": "Lower your hand",
  "activity.hand.raise": "Raise your hand",
  "activity.hands.give": "Give the globe",
  "activity.hands.giveGlobe": "Give globe {n}",
  "activity.hands.pill": "Hands: {n}",
  "activity.hands.someone": "Participant {n}",
  "activity.hands.title": "Raised hands",
  "activity.khipu.download": "Download (.zip)",
  "activity.khipu.downloaded": "Saved {filename}",
  "activity.khipu.info": "Moments noted so far: {n}. The Khipu keeps what was shown: datasets, views, the questions with their totals, and the pins (without names).",
  "activity.khipu.name": "Meeting, {date}",
  "activity.khipu.pill": "Save as Khipu",
  "activity.khipu.play": "Play it to the room",
  "activity.khipu.save": "Save to my account",
  "activity.khipu.title": "This meeting as a Khipu",
  "activity.kicked": "You were removed from this meeting.",
  "activity.kind.choice": "Ask: choose an answer",
  "activity.kind.choice.hint": "Everyone picks one of your options.",
  "activity.kind.explore": "Let them explore",
  "activity.kind.explore.hint": "Everyone gets their own globe and Tools for a while (datasets, layers, time) and can pin what they find.",
  "activity.kind.point": "Ask: point on the globe",
  "activity.kind.point.hint": "Everyone answers by tapping a place.",
  "activity.kind.poll": "Poll: ask their opinion",
  "activity.kind.poll.hint": "No right answer. Everyone sees the results as they come in, not who voted for what.",
  "activity.mine.note": "Kept until the meeting ends. Nothing leaves the meeting.",
  "activity.mine.pill": "My answers",
  "activity.mine.title": "My answers in this meeting",
  "activity.name.add": "Add your name",
  "activity.name.hello": "Shown as {name}",
  "activity.name.hint": "Optional. The presenter and moderators see it with your answers until the meeting ends.",
  "activity.name.label": "Your name (optional, shown to the presenter)",
  "activity.name.pill": "You: {name}",
  "activity.name.save": "Save",
  "activity.name.skip": "Not now",
  "activity.name.title": "Your name",
  "activity.options.add": "Add an option",
  "activity.options.label": "Options",
  "activity.options.placeholder": "Option {n}",
  "activity.people.drivesGlobe": "drives globe {n}",
  "activity.people.drivesMain": "has the globe",
  "activity.people.empty": "Nobody else is here yet.",
  "activity.people.guest": "Guest {n}",
  "activity.people.hand": "hand up",
  "activity.people.micOn": "mic on",
  "activity.people.moderator": "moderator",
  "activity.people.moderatorLabel": "Moderator",
  "activity.people.mute": "Mic off",
  "activity.people.pill": "People ({n})",
  "activity.people.remove": "Remove",
  "activity.people.removeConfirm": "Remove {name} from this meeting? They can't come back to it.",
  "activity.people.removeNo": "Cancel",
  "activity.people.removeYes": "Remove",
  "activity.people.tab.answers": "Answers",
  "activity.people.tab.people": "People",
  "activity.people.title": "People in this meeting",
  "activity.pin.anonymous": "Someone",
  "activity.pin.look": "Look",
  "activity.pin.show": "Show everyone",
  "activity.point.distance": "You were {km} km away.",
  "activity.point.missed": "You did not answer this one.",
  "activity.point.noAnswer": "Everyone’s answers are on the globe.",
  "activity.point.results": "Answers: {n}",
  "activity.point.send": "Send answer",
  "activity.point.sent": "Answer sent. Tap again to change it.",
  "activity.point.tap": "Tap the globe to answer.",
  "activity.poll.close": "Close poll",
  "activity.poll.closed": "The poll is closed.",
  "activity.poll.multi": "Let people pick more than one",
  "activity.poll.pickMany": "Pick one or more, then Vote.",
  "activity.poll.vote": "Vote",
  "activity.poll.voted": "Your vote is in. You can change it until the poll closes.",
  "activity.poll.votes": "Votes: {n}",
  "activity.prompt.label": "What do you ask?",
  "activity.prompt.placeholder.choice": "What will happen next?",
  "activity.prompt.placeholder.explore": "Take a few minutes: where is it highest?",
  "activity.prompt.placeholder.point": "Where is the ozone hole thinnest?",
  "activity.prompt.placeholder.poll": "Which dataset should we look at next?",
  "activity.reveal": "Reveal",
  "activity.reveal.noAnswer": "No single answer",
  "activity.reveal.tap": "Tap the right place on the globe to reveal, or choose “No single answer”.",
  "activity.sheet.close": "Close",
  "activity.sheet.move": "Move",
  "activity.sheet.title": "Do something together",
  "activity.spotlight.giveBack": "Give it back",
  "activity.spotlight.handBack": "Hand back",
  "activity.spotlight.me": "You have the globe: everyone sees what you do.",
  "activity.spotlight.other": "{name} has the globe",
  "activity.spotlight.overridden": "You have taken over from {name} for a moment.",
  "activity.spotlight.overriddenSomeone": "You have taken over the globe for a moment.",
  "activity.spotlight.paused": "The presenter has taken over for a moment. The globe comes back to you.",
  "activity.spotlight.someone": "A participant has the globe",
  "activity.spotlight.takeBack": "Take back",
  "activity.spotlight.takeOver": "Take over",
  "activity.start": "Start",
  "activity.start.button": "Start an activity",
  "activity.time.answersClosed": "Time is up: answers are closed. The presenter will show the results.",
  "activity.time.elapsed": "{time} so far",
  "activity.time.left": "{time} left",
  "activity.time.up": "Time's up",
  "adminFeedback.back": "Back to the app",
  "adminFeedback.capped": "Only the newest {shown} are listed here; Download CSV has all {total}.",
  "adminFeedback.csv": "Download CSV",
  "adminFeedback.csvHint": "All feedback of the chosen kind as a spreadsheet file, not only the entries listed here",
  "adminFeedback.docTitle": "Feedback · AYNI XR",
  "adminFeedback.error.body": "Check your connection and try again.",
  "adminFeedback.error.title": "The feedback could not be loaded",
  "adminFeedback.field.app": "App",
  "adminFeedback.field.browser": "Browser",
  "adminFeedback.field.contact": "Contact",
  "adminFeedback.field.country": "Country",
  "adminFeedback.field.dataset": "Dataset",
  "adminFeedback.field.details": "More details",
  "adminFeedback.field.from": "From",
  "adminFeedback.field.page": "Page",
  "adminFeedback.field.source": "Sent from",
  "adminFeedback.field.status": "Status",
  "adminFeedback.field.userAgent": "Full browser details",
  "adminFeedback.kind.all": "All kinds",
  "adminFeedback.kind.bug": "Bug",
  "adminFeedback.kind.content": "Content",
  "adminFeedback.kind.feature": "Feature request",
  "adminFeedback.kind.idea": "Idea",
  "adminFeedback.kind.label": "Kind",
  "adminFeedback.kind.other": "Other",
  "adminFeedback.lead": "What people sent through Help → Feedback, newest first.",
  "adminFeedback.loading": "Loading feedback…",
  "adminFeedback.next": "Next",
  "adminFeedback.noMatch": "Nothing matches this search.",
  "adminFeedback.none": "No feedback yet.",
  "adminFeedback.notAdmin.body": "{email} is signed in, but it is not an AYNI admin account. Ask the site owner if you should have access.",
  "adminFeedback.notAdmin.title": "This account cannot read feedback",
  "adminFeedback.page": "Page {page} of {pages}",
  "adminFeedback.pager": "Pages",
  "adminFeedback.prev": "Previous",
  "adminFeedback.rating": "Rated {rating} of 5",
  "adminFeedback.retry": "Try again",
  "adminFeedback.screenshot.close": "Close",
  "adminFeedback.screenshot.failed": "The screenshot could not be loaded.",
  "adminFeedback.screenshot.loading": "Loading the screenshot…",
  "adminFeedback.screenshot.open": "Screenshot",
  "adminFeedback.screenshot.stored": "This screenshot is kept as a file and cannot be shown here; the CSV names it.",
  "adminFeedback.screenshot.title": "Screenshot sent with feedback #{id}",
  "adminFeedback.search.label": "Search",
  "adminFeedback.search.placeholder": "Text, page, dataset, browser…",
  "adminFeedback.showing": "Showing {from}–{to} of {total}",
  "adminFeedback.signedInAs": "Signed in as {email}",
  "adminFeedback.signedOut.action": "Sign in",
  "adminFeedback.signedOut.body": "The feedback reader is for AYNI admin accounts. Sign in with yours and you will come back here.",
  "adminFeedback.signedOut.title": "Sign in to read feedback",
  "adminFeedback.title": "Feedback",
  "adminFeedback.total": "All feedback",
  "adminFeedback.unavailable.body": "This site has no feedback database set up.",
  "adminFeedback.unavailable.title": "Feedback is not available here",
  "adminFeedback.withScreenshot": "With a screenshot",
  "analyze.box.pickFirst": "Click one corner of the box on the globe.",
  "analyze.box.pickSecond": "Now click the opposite corner. Drag a corner afterwards to change the box.",
  "analyze.close": "Close analysis",
  "analyze.contour.clear": "Clear outline",
  "analyze.contour.draw": "Outline on globe",
  "analyze.contour.levelRow": "{level} — {km2} km² above",
  "analyze.contour.noLevels": "No round value falls inside the range the colour bar is isolating. Widen the threshold to get contour lines.",
  "analyze.contour.rangeCaption": "{count} lines across the full range, at the same values the colour bar labels.",
  "analyze.contour.scopedCaption": "{count} lines inside the range the colour bar is isolating, at the same values it labels.",
  "analyze.contour.staleCleared": "The globe moved to another frame, so the outline was removed rather than left describing data it was not measured from. Draw it again for the frame showing now.",
  "analyze.contour.staleNote": "Drawn from the colour bar as it was when you pressed the button. Move it and outline again to follow it.",
  "analyze.contour.title": "Where the line falls",
  "analyze.contour.unwatched": "This outline is pinned to one frame and can't tell when the globe moves on, so it won't clear itself. Draw it again after seeking.",
  "analyze.country.loading": "Loading the country outlines…",
  "analyze.country.outline": "The country is the dataset's cells whose centres fall inside its outline (Natural Earth 1:50m, the de facto boundaries the globe's borders show). A cell on the border counts whole or not at all.",
  "analyze.country.tiny": "This country is smaller than one of the dataset's cells: the one cell holding it stands for it, and its numbers are that cell's.",
  "analyze.coverage": "{percent}% of this region has data ({count} grid cells).",
  "analyze.empty.noDataset": "Load a dataset that carries values to analyze it. Older datasets are pictures, so there are no numbers to measure.",
  "analyze.empty.noValues": "No data in this region.",
  "analyze.empty.outsideDataset": "This region falls outside the dataset's coverage.",
  "analyze.empty.unavailable": "Analysis isn't available right now.",
  "analyze.empty.unknownRegion": "That region couldn't be located, so there's nothing to measure.",
  "analyze.export": "Download CSV",
  "analyze.frameTime": "Measured on the frame showing {time}.",
  "analyze.histogram.aria": "Distribution of values, coloured by the map's own palette",
  "analyze.histogram.caption": "Each bar covers about {width}.",
  "analyze.line.lat.antarctic": "Antarctic Circle (66.56° S), all the way round",
  "analyze.line.lat.arctic": "Arctic Circle (66.56° N), all the way round",
  "analyze.line.lat.cancer": "Tropic of Cancer (23.44° N), all the way round",
  "analyze.line.lat.capricorn": "Tropic of Capricorn (23.44° S), all the way round",
  "analyze.line.lat.choose": "Draw two points, or choose…",
  "analyze.line.lat.equator": "Equator (0°), all the way round",
  "analyze.line.lat.typed": "or type one",
  "analyze.line.lat.typedAria": "A latitude in degrees, north positive: the line goes all the way round it",
  "analyze.line.latitude": "Latitude",
  "analyze.line.path": "Path",
  "analyze.line.path.greatCircle": "Great circle (the shortest way)",
  "analyze.line.path.parallel": "Along a latitude",
  "analyze.precision": "Values are resolved to about {step}; treat smaller differences as noise.",
  "analyze.precisionMeasured": "Each value here is within ±{error} for 99 % of cells, as measured for this release (rounding and streaming).",
  "analyze.precisionRelative": "One step of this log scale is a fixed share of the value: rounding moves a value by at most {percent} of itself; treat smaller differences as noise.",
  "analyze.precisionRoundingOnly": "Rounding moves each value here by at most ±{error}. This release does not state its streaming error, so the real error can be larger.",
  "analyze.regionLocked": "Draw a Box on the globe to measure an area. Statistics over a whole region come with the Research and Education plans.",
  "analyze.scope.box": "The box you drew",
  "analyze.scope.chatBox": "Box from the chatbot ({s} to {n} latitude, {w} to {e} longitude)",
  "analyze.scope.dataset": "Whole globe",
  "analyze.scope.group.countries": "Countries (by their outline)",
  "analyze.scope.group.globe": "Globe",
  "analyze.scope.group.regions": "Regions",
  "analyze.scope.group.yours": "On screen",
  "analyze.scope.label": "Region",
  "analyze.scope.view": "What I can see",
  "analyze.stat.area": "Area with data",
  "analyze.stat.max": "Highest",
  "analyze.stat.mean": "Mean",
  "analyze.stat.median": "Median",
  "analyze.stat.min": "Lowest",
  "analyze.stat.none": "—",
  "analyze.stat.p10": "10th percentile",
  "analyze.stat.p90": "90th percentile",
  "analyze.stat.stdDev": "Spread",
  "analyze.tab.baseline": "Baseline",
  "analyze.tab.compare": "Compare",
  "analyze.tab.contours": "Contours",
  "analyze.tab.empty": "Nothing to show here for this region on this frame.",
  "analyze.tab.profiles": "Profiles",
  "analyze.tab.stats": "Statistics",
  "analyze.tabs.aria": "Analyze sections",
  "analyze.title": "Analyze",
  "analyze.transect.aria": "Value along the line, from one end to the other",
  "analyze.transect.cancel": "Cancel",
  "analyze.transect.caption": "Height is scaled to this line's own range.",
  "analyze.transect.clear": "Clear",
  "analyze.transect.coverage": "{withData} of {samples} points along the line have data, one every {spacing}.",
  "analyze.transect.draw": "Draw a line",
  "analyze.transect.export": "Download the line as CSV",
  "analyze.transect.hint": "Draw a line across the globe to see how the values change along it.",
  "analyze.transect.noData": "This line doesn't cross any data.",
  "analyze.transect.pickFirst": "Click where the line should start.",
  "analyze.transect.pickSecond": "Now click where it should end.",
  "analyze.transect.stat.length": "Length",
  "analyze.transect.title": "Along a line",
  "analyze.units.km": "km",
  "analyze.units.km2": "km²",
  "analyze.zonal.aria": "Average value at each latitude, coloured by the map's own palette",
  "analyze.zonal.caption": "North is at the top. Width is scaled to this profile's own range.",
  "analyze.zonal.coverage": "{withData} of {rows} latitude bands have data.",
  "analyze.zonal.export": "Download the profile as CSV",
  "analyze.zonal.narrow": "This region covers too few latitude bands to show a profile.",
  "analyze.zonal.stat.peak": "Highest band",
  "analyze.zonal.stat.peakValue": "Average there",
  "analyze.zonal.title": "By latitude",
  "analyze.zone.antarctic": "Antarctic (south of 66.6°S)",
  "analyze.zone.arctic": "Arctic (north of 66.6°N)",
  "analyze.zone.northern": "Northern hemisphere",
  "analyze.zone.southern": "Southern hemisphere",
  "analyze.zone.tropics": "Tropics (23.4°S to 23.4°N)",
  "anchor.alt": "AYNI XR anchor marker",
  "anchor.button.aria": "Show anchor",
  "anchor.close.aria": "Close the anchor",
  "anchor.hint": "Lay this screen flat, at full brightness, and leave it where it is once people have scanned. Scan the small code to join, then the large one in AR.",
  "anchor.join.caption": "Scan to join · {code}",
  "anchor.print": "Print",
  "anchor.print.aria": "Print the anchor on paper",
  "anchor.print.hint": "Lay this sheet flat where the globe should be, and leave it there once people have scanned. Scan the small code to join, then the large one in AR.",
  "anchor.title": "AYNI XR anchor",
  "app.globe.aria": "Globe visualization",
  "app.skipLink": "Skip to globe visualization",
  "app.title": "AYNI",
  "autorotate.speed.label": "Rotation speed",
  "autorotate.speed.value": "{rate}×",
  "autorotate.start": "Spin the globe",
  "autorotate.stop": "Stop spinning the globe",
  "ayniChat.bot": "Ayni",
  "ayniChat.close": "Close the chatbot",
  "ayniChat.error.busy": "I am still answering your last question.",
  "ayniChat.error.quota": "The chatbot has used today’s allowance. Try again tomorrow.",
  "ayniChat.error.rateLimited": "Lots of questions at once: wait a few seconds, then ask again.",
  "ayniChat.error.signIn": "Your session has ended. Sign in again to keep talking.",
  "ayniChat.error.timeout": "That took too long, so I stopped. Try a shorter question.",
  "ayniChat.error.unavailable": "The chatbot cannot answer right now. Try again in a moment.",
  "ayniChat.gate.plan": "The Ayni Chatbot comes with the AYNI XR plans.",
  "ayniChat.gate.plans": "See the plans",
  "ayniChat.gate.signIn": "Sign in",
  "ayniChat.gate.signedOut": "Sign in to talk to the Ayni Chatbot. It comes with the AYNI XR plans.",
  "ayniChat.input.label": "Your question",
  "ayniChat.input.placeholder": "Ask about the data on the globe…",
  "ayniChat.mic.start": "Talk to Ayni",
  "ayniChat.mic.stop": "Stop talking",
  "ayniChat.new": "New conversation",
  "ayniChat.send": "Send",
  "ayniChat.stop": "Stop",
  "ayniChat.stopped": "Stopped.",
  "ayniChat.thinking": "Thinking…",
  "ayniChat.title": "Ayni Chatbot",
  "ayniChat.trigger": "Ask Ayni Chatbot",
  "ayniChat.voice.listening": "Listening… ask, then pause. Tap the mic to send now.",
  "ayniChat.voice.micDenied": "The microphone is not available. Allow it in your browser’s settings.",
  "ayniChat.voice.quiet": "I didn’t hear anything, so the mic is off. Tap it to talk again.",
  "ayniChat.voice.speaking": "Speaking… tap the mic to interrupt.",
  "ayniChat.voice.transcribing": "Writing down what you said…",
  "ayniChat.welcome": "Ask me to find a dataset, to take you to a place or a date, or to read a value on the globe.",
  "ayniChat.you": "You",
  "browse.activeFilters.aria": "Active filters",
  "browse.activeFilters.bbox.region": "Region {ns}, {ew}",
  "browse.activeFilters.bbox.regionNamed": "Region: {name}",
  "browse.activeFilters.range.dataCoverage": "Coverage {start}–{end}",
  "browse.activeFilters.range.dateAdded": "Added {start}–{end}",
  "browse.activeFilters.remove.aria": "Remove filter: {label}",
  "browse.announce.closed": "Dataset browser closed",
  "browse.askOrbit.aria": "Open Ayni Chatbot, your digital docent",
  "browse.askOrbit.title": "Ask Ayni Chatbot",
  "browse.badge.free": "Free",
  "browse.card.catalogLink": "View in SOS catalog ↗",
  "browse.card.dataFrom": "Data from",
  "browse.card.dataFrom.notTracked": "{name} is not tracked, so it is not drawn on the globe.",
  "browse.card.dataFrom.retired": "{name}: retired {year}, not drawn on the globe.",
  "browse.card.dataFrom.tip": "The satellites this dataset is built from. Press one to see it on the globe.",
  "browse.card.keyword.aria": "Filter by {keyword}",
  "browse.card.load": "Load",
  "browse.card.load.aria": "Load {title}",
  "browse.card.meta.added": "Added:",
  "browse.card.meta.datasetDeveloper": "Dataset developer:",
  "browse.card.meta.modelYears": "Model years {start}–{end} (a simulation, not calendar dates)",
  "browse.card.meta.source": "Source:",
  "browse.card.meta.timeRange": "Time range:",
  "browse.card.meta.visualization": "Visualization:",
  "browse.card.scrubber.afterEnd": "now is after the series",
  "browse.card.scrubber.aria": "Frame timeline: {count} frames from {start} to {end}",
  "browse.card.scrubber.beforeStart": "now is before the series",
  "browse.card.scrubber.frames": "{count} frames",
  "browse.card.scrubber.framesOnly": "{count} frames",
  "browse.card.scrubber.now": "now",
  "browse.card.sourceLink": "Source page ↗",
  "browse.card.thumb.alt": "{title} thumbnail",
  "browse.category.all": "All",
  "browse.close.aria": "Close dataset browser",
  "browse.count.one": "1 dataset",
  "browse.count.other": "{count} datasets",
  "browse.count.related": "{count} related",
  "browse.docentHint": "Not sure what you need? Ask Ayni Chatbot →",
  "browse.filter.clearAll": "Clear filters",
  "browse.filter.clearAll.aria": "Clear all filters",
  "browse.filter.dataCoverage.fromLabel": "From year",
  "browse.filter.dataCoverage.label": "Data coverage",
  "browse.filter.dataCoverage.toLabel": "To year",
  "browse.filter.dateAdded.fromLabel": "From year",
  "browse.filter.dateAdded.label": "Date added",
  "browse.filter.dateAdded.toLabel": "To year",
  "browse.filter.format.aria": "Filter by format",
  "browse.filter.format.image": "Image",
  "browse.filter.format.label": "Format",
  "browse.filter.format.other": "Other",
  "browse.filter.format.story": "Story",
  "browse.filter.format.video": "Video",
  "browse.filter.free.help": "Show only what your free account opens: the catalogue and the free streams.",
  "browse.filter.free.label": "Free",
  "browse.filter.group.category": "Category & content",
  "browse.filter.group.format": "Format & medium",
  "browse.filter.group.kind": "Kind & theme",
  "browse.filter.group.quality": "Quality & availability",
  "browse.filter.group.time": "Time",
  "browse.filter.hasCaptions.label": "Has closed captions",
  "browse.filter.hasStory.label": "Has a story (Khipu)",
  "browse.filter.kind.aria": "Filter by kind of data",
  "browse.filter.kind.label": "Kind of data",
  "browse.filter.rail.aria": "Filter datasets",
  "browse.filter.recentlyViewed.help": "Show only datasets you've opened before.",
  "browse.filter.recentlyViewed.label": "Recently viewed",
  "browse.filter.satellite.aria": "Filter by the satellite the data comes from",
  "browse.filter.satellite.label": "Satellite",
  "browse.filter.tags.aria": "Filter by category",
  "browse.filter.tags.label": "Category",
  "browse.filter.tags.less": "Show fewer",
  "browse.filter.tags.more": "Show more",
  "browse.filter.theme.aria": "Filter by theme",
  "browse.filter.theme.label": "Theme",
  "browse.filters.toggle.aria": "Show or hide the filter panel",
  "browse.filters.toggle.label": "Filters",
  "browse.graph.empty": "No datasets match the current filters — adjust the chip rail to see the graph.",
  "browse.graph.legend.category": "Category",
  "browse.graph.legend.dataset": "Dataset",
  "browse.graph.legend.format": "Format",
  "browse.graph.legend.keyword": "Keyword",
  "browse.graph.loadError": "Could not load the graph view.",
  "browse.graph.loading": "Loading graph view…",
  "browse.graph.recenter": "Recenter",
  "browse.graph.recenter.aria": "Recenter the graph view",
  "browse.graph.region.aria": "Catalog graph view — {count} datasets, {edgeCount} connections",
  "browse.graph.showFormat.aria": "Show format-bucket nodes in the graph",
  "browse.graph.showFormat.label": "Show formats",
  "browse.graph.tooltip.coOccurrence": "Top co-occurring: {neighbours}",
  "browse.graph.tooltip.viewDetails": "Click to view details",
  "browse.kind.catalogue": "SOS catalogue",
  "browse.kind.forecast": "Forecast",
  "browse.kind.historical": "Historical",
  "browse.kind.projection": "Projection",
  "browse.kind.realTime": "Live",
  "browse.kind.reanalysis": "Reanalysis",
  "browse.map.banner.allGlobal.one": "1 dataset shown — it covers the entire globe. Most SOS datasets are worldwide today; regional bounding boxes will appear as distinct rectangles as publishers add them.",
  "browse.map.banner.allGlobal.other": "{count} datasets shown — all cover the entire globe. Most SOS datasets are worldwide today; regional bounding boxes will appear as distinct rectangles as publishers add them.",
  "browse.map.clearRegion.aria": "Clear the drawn region filter",
  "browse.map.clearRegion.label": "Clear region",
  "browse.map.draw.aria": "Toggle draw-rectangle mode — drag to filter datasets by geographic region",
  "browse.map.draw.label": "Draw region",
  "browse.map.empty": "No datasets match the current filters — adjust the chip rail to see the map.",
  "browse.map.empty.allGlobalHidden": "All matching datasets are global — toggle Include global to surface them.",
  "browse.map.empty.allUndated": "None of the matching datasets is a map of Earth — switch to Cards to see them.",
  "browse.map.hiddenGlobalFootnote.one": "1 global dataset hidden — toggle “Include global” to surface it.",
  "browse.map.hiddenGlobalFootnote.other": "{count} global datasets hidden — toggle “Include global” to surface them.",
  "browse.map.hint.regionClick": "Click a region to show only its datasets; click it again to show all.",
  "browse.map.includeGlobal.label": "Include global",
  "browse.map.legend.coverage": "Coverage",
  "browse.map.legend.realtime": "Real-time",
  "browse.map.loadError": "Could not load the map view.",
  "browse.map.loading": "Loading map view…",
  "browse.map.region.aria": "Catalog map view — {count} datasets with geographic coverage",
  "browse.map.tooltip.more": "+{count} more",
  "browse.map.tooltip.realtime": "real-time",
  "browse.map.undatedFootnote.one": "1 dataset is not a map of Earth (another world, the Sun, or a story) — switch to Cards to see it.",
  "browse.map.undatedFootnote.other": "{count} datasets are not maps of Earth (other worlds, the Sun, stories) — switch to Cards to see them.",
  "browse.newSince.badge": "{count} new since your last visit",
  "browse.noResults": "No datasets match your search.",
  "browse.overlay.aria": "Dataset browser",
  "browse.package.education": "Education",
  "browse.package.education.aria": "Education plans only: see the plans",
  "browse.package.education.title": "Shown on the Education plans only (Teacher, School and District): its provider allows it for teaching. Click to see the plans.",
  "browse.package.hazards": "Hazards & events",
  "browse.package.locked.aria": "{package} package, not in your plan: see the plans",
  "browse.package.locked.title": "Part of the {package} package, in AYNI XR plans. Click to see the plans.",
  "browse.package.title": "The AYNI XR data package this stream belongs to",
  "browse.recent.clear": "Clear history",
  "browse.recent.clear.confirm": "Clear the list of datasets you have opened in this browser?",
  "browse.recent.empty": "Datasets you open will appear here.",
  "browse.region.conus": "Contiguous United States",
  "browse.region.europe": "Europe",
  "browse.region.netherlands": "Netherlands",
  "browse.region.northAmerica": "North America",
  "browse.region.spain": "Spain",
  "browse.related.heading": "Related by meaning",
  "browse.search.clear.aria": "Clear search",
  "browse.search.label": "Search datasets",
  "browse.search.placeholder": "Search datasets…",
  "browse.search.placeholderCount": "Search {count} datasets…",
  "browse.sort.aria": "Sort datasets",
  "browse.sort.az": "A–Z",
  "browse.sort.newest": "Newest",
  "browse.sort.relevance": "Relevance",
  "browse.subtitle": "Browse environmental datasets from Pachamama Studios",
  "browse.tab.catalog": "Catalog",
  "browse.tab.lessons": "Khipus",
  "browse.tab.myData": "My data",
  "browse.tab.myData.locked": "My data: comes with the Situation Room plans, and soon as an add-on to Researcher and Lab",
  "browse.tab.recent": "Recent",
  "browse.tabs.aria": "Browse sections",
  "browse.target.banner": "Loading into globe {n}",
  "browse.target.cancel": "Back to globe 1",
  "browse.target.cancel.aria": "Stop loading into globe {n}; the next dataset goes to globe 1",
  "browse.target.compatible": "Shares dates with globe 1",
  "browse.target.incompatible": "No dates in common with globe 1",
  "browse.theme.atmosphere": "Atmosphere",
  "browse.theme.climate": "Climate",
  "browse.theme.fireAq": "Fire & air quality",
  "browse.theme.land": "Land & life",
  "browse.theme.ocean": "Ocean & water",
  "browse.theme.people": "People",
  "browse.theme.space": "Space",
  "browse.timeline.brush.aria": "Drag on the time axis to filter datasets by coverage range",
  "browse.timeline.brush.clear": "Clear range",
  "browse.timeline.brush.clear.aria": "Clear the brushed time range filter",
  "browse.timeline.brush.hint": "↔ Drag to filter by year",
  "browse.timeline.brush.summary": "Range: {start} – {end}",
  "browse.timeline.empty": "No datasets with temporal coverage match the current filters — adjust the chip rail to see the timeline.",
  "browse.timeline.legend.coverage": "Coverage",
  "browse.timeline.legend.realtime": "Real-time",
  "browse.timeline.loadError": "Could not load the timeline view.",
  "browse.timeline.loading": "Loading timeline view…",
  "browse.timeline.region.aria": "Catalog timeline view — {count} datasets sorted by start year",
  "browse.timeline.row.aria": "{title} — coverage {start} to {end}",
  "browse.timeline.undatedFootnote.one": "1 dataset has no calendar dates (no time coverage, or a model simulation) — switch to Cards to see it.",
  "browse.timeline.undatedFootnote.other": "{count} datasets have no calendar dates (no time coverage, or model simulations) — switch to Cards to see them.",
  "browse.viewMode.aria": "Switch between card grid, graph, timeline, and map views",
  "browse.viewMode.cards": "Cards",
  "browse.viewMode.cards.aria": "Show datasets as a card grid",
  "browse.viewMode.graph": "Graph",
  "browse.viewMode.graph.aria": "Show datasets as a network graph",
  "browse.viewMode.map": "Map",
  "browse.viewMode.map.aria": "Show datasets as bounding-box overlays on a flat world map",
  "browse.viewMode.timeline": "Timeline",
  "browse.viewMode.timeline.aria": "Show datasets as a horizontal timeline",
  "catalog.savedCopy": "The catalogue could not be loaded; showing a saved copy. Some streams may be missing or out of date.",
  "catalogTabs.aria": "Switch between catalog and sphere view",
  "catalogTabs.catalog": "Catalog",
  "catalogTabs.sphere": "Sphere",
  "cite.close": "Close",
  "cite.copied": "Citation copied",
  "cite.copy": "Copy",
  "cite.copyFailed": "Could not copy; select the text and copy it",
  "cite.copyLink": "Copy link",
  "cite.download": "Download",
  "cite.downloaded": "Saved {file}",
  "cite.format.bibtex": "BibTeX",
  "cite.format.ris": "RIS",
  "cite.format.text": "Text",
  "cite.formats": "Citation format",
  "cite.frame": "Frame {time}",
  "cite.link": "Link that reopens this dataset, frame and place",
  "cite.linkCopied": "Link copied",
  "cite.noDataset": "Load a dataset to cite it.",
  "cite.note": "The citation carries the data's credit and licence, as its publisher asks. It is written in English, like the CSV files.",
  "cite.open": "Cite this view",
  "cite.title": "Cite this view",
  "colorbar.aria": "Colour scale from {min} to {max}",
  "colorbar.ariaAdjust": "{name}. Tap to adjust colours.",
  "colorbar.ariaWithTitle": "{title} colour scale, from {min} to {max}",
  "colorbar.atOrAbove": "≥ {value}",
  "colorbar.atOrBelow": "≤ {value}",
  "colorbar.classes.aria": "Legend, {count} classes",
  "colorbar.classes.ariaWithTitle": "{title} legend, {count} classes",
  "colorbar.controls.close": "Close colour controls",
  "colorbar.controls.title": "Colour & range",
  "colorbar.palette.cividis": "Cividis",
  "colorbar.palette.coolwarm": "Cool–warm",
  "colorbar.palette.grayscale": "Grayscale",
  "colorbar.palette.inferno": "Inferno",
  "colorbar.palette.label": "Palette",
  "colorbar.palette.magma": "Magma",
  "colorbar.palette.plasma": "Plasma",
  "colorbar.palette.source": "Original",
  "colorbar.palette.turbo": "Turbo",
  "colorbar.palette.viridis": "Viridis",
  "colorbar.range.label": "Range shown",
  "colorbar.range.max": "Range high end",
  "colorbar.range.min": "Range low end",
  "colorbar.range.readout": "{min} to {max}",
  "colorbar.reset": "Reset colours",
  "colorbar.tapToAdjust": "Tap to adjust colours",
  "colorbar.threshold.above": "Only {value} and above",
  "colorbar.threshold.below": "Only {value} and below",
  "colorbar.threshold.between": "Only {min} to {max}",
  "colorbar.threshold.keeps": "{band} — keeps {percent}% of the data",
  "colorbar.threshold.label": "Hide values",
  "colorbar.threshold.max": "Hide above",
  "colorbar.threshold.min": "Hide below",
  "colorbar.threshold.none": "Showing everything",
  "credits.aboutLink": "About AYNI →",
  "credits.close.aria": "Close credits",
  "credits.desc": "Where the imagery and data on screen come from.",
  "credits.empty.basemap": "No basemap sources declared.",
  "credits.empty.dataset": "No dataset loaded.",
  "credits.section.basemap": "Basemap",
  "credits.section.loaded": "Loaded dataset",
  "credits.section.loadedPanel": "Loaded — Panel {n}",
  "credits.title": "Credits",
  "datasetMenu.addTo": "Add to {khipu}",
  "datasetMenu.addToExisting": "Add to a Khipu",
  "datasetMenu.addToNew": "Add to a new Khipu…",
  "datasetMenu.added.announce": "Added {title} to {khipu}",
  "datasetMenu.aria": "Actions for {title}",
  "datasetMenu.button.aria": "More for {title}: load, add to a Khipu, share",
  "datasetMenu.button.title": "Add to a Khipu, and more",
  "datasetMenu.cannotRemove": "It is in a step of {khipu} with your own words or settings: take it out in the Khipu editor.",
  "datasetMenu.details": "Details",
  "datasetMenu.editing": "{khipu} (being edited)",
  "datasetMenu.info.aria": "Add {title} to a Khipu",
  "datasetMenu.info.label": "Add to a Khipu",
  "datasetMenu.listFailed": "Your Khipus could not be loaded just now",
  "datasetMenu.load": "Load",
  "datasetMenu.loading": "Loading your Khipus…",
  "datasetMenu.newKhipu.cancel": "Cancel",
  "datasetMenu.newKhipu.create": "Create",
  "datasetMenu.newKhipu.label": "Name",
  "datasetMenu.newKhipu.notKept": "Your plan does not keep Khipus on your account: it opens in the Khipu editor, and Download (.zip) keeps it.",
  "datasetMenu.newKhipu.replaces": "The Khipu being edited has changes not saved or downloaded yet: a new one closes it.",
  "datasetMenu.newKhipu.title": "New Khipu",
  "datasetMenu.noKhipus": "No Khipus yet",
  "datasetMenu.openBeside": "Open beside",
  "datasetMenu.removeFrom": "Already in {khipu}: choose it to take it out",
  "datasetMenu.removed.announce": "Took {title} out of {khipu}",
  "datasetMenu.saveFailed": "{khipu} could not be saved just now.",
  "datasetMenu.savedNew": "Saved a new Khipu, {khipu}, with {title}. It is in Browse → Khipus.",
  "datasetMenu.saving": "Saving…",
  "datasetMenu.share": "Share link…",
  "disclosureBanner.allow": "Allow",
  "disclosureBanner.announce": "Privacy choice available. A shield button in the top-left opens it.",
  "disclosureBanner.aria": "Privacy notice",
  "disclosureBanner.badge.aria": "Privacy choice — tap to answer",
  "disclosureBanner.decline": "No thanks",
  "disclosureBanner.policy": "Read policy",
  "disclosureBanner.settings": "Privacy settings",
  "disclosureBanner.text": "May this app report usage and error events so we can keep it working? They carry no name or account. Nothing is sent unless you allow it, and you can change your mind any time in Tools → More → Privacy settings.",
  "disclosureBanner.visits.allow": "Remember",
  "disclosureBanner.visits.decline": "No thanks",
  "disclosureBanner.visits.text": "May the app remember which datasets you open, on this device only, for Browse’s Recent tab? Nothing is sent, and you can change this in Tools → More → Privacy settings.",
  "edit.add": "Add a step from the globe",
  "edit.added": "Step {n} added from the globe.",
  "edit.advance": "Moves on",
  "edit.advance.manual": "When Next is pressed",
  "edit.advance.seconds": "Seconds",
  "edit.advance.timer": "By itself, after",
  "edit.advance.unit": "seconds",
  "edit.aria": "Khipu editor",
  "edit.cannotSave": "Not saved yet:",
  "edit.close": "Close the editor",
  "edit.closeConfirm": "Close without saving? Press ✕ again.",
  "edit.datasetOpen": "Any dataset",
  "edit.delete": "Delete step",
  "edit.deleteConfirm": "Press again to delete",
  "edit.deleted": "Step deleted.",
  "edit.down": "Move the step down",
  "edit.earth": "The Earth",
  "edit.first": "first date",
  "edit.heading": "Edit Khipu",
  "edit.latest": "latest date",
  "edit.loop": "Start again after the last step",
  "edit.media": "Pictures and links",
  "edit.media.add": "Add a picture or link",
  "edit.media.image": "Picture",
  "edit.media.kind": "Kind",
  "edit.media.link": "Link",
  "edit.media.panorama": "360° picture",
  "edit.media.title": "Title",
  "edit.media.url": "Address (https)",
  "edit.media.video": "Clip",
  "edit.motion": "Moves and effects",
  "edit.motion.asBefore": "As before (a short glide)",
  "edit.motion.hold": "Moves and effects last (seconds)",
  "edit.motion.note": "These play in the Khipu player, and in a video made from this Khipu in the Studio. Effects never change the data inside the focus.",
  "edit.moved": "The step is now step {n}.",
  "edit.overlay": "overlay",
  "edit.pins.one": "1 pin",
  "edit.pins.other": "{count} pins",
  "edit.playing": "playing",
  "edit.preview": "Preview",
  "edit.problem.link": "a picture or link needs an address that starts with https://.",
  "edit.problem.quiz": "the quiz needs a question and two to four answers.",
  "edit.problem.quizAnswer": "mark the quiz's right answer.",
  "edit.problem.seconds": "a step that moves on by itself needs at least 1 second.",
  "edit.problem.title": "The Khipu needs a name.",
  "edit.problems": "What stops it being saved",
  "edit.quiz": "Quiz",
  "edit.quiz.add": "Add an answer",
  "edit.quiz.answer": "Answer {letter}",
  "edit.quiz.answers": "Answers (mark the right one)",
  "edit.quiz.hint": "Hint (optional)",
  "edit.quiz.on": "A question with answers",
  "edit.quiz.question": "Question",
  "edit.quiz.right": "{letter} is the right answer",
  "edit.region": "An area",
  "edit.remove": "Remove",
  "edit.satFollow": "Camera follows the satellite while the step holds",
  "edit.satFollowing": "(camera follows)",
  "edit.satellites": "Satellites",
  "edit.show": "Show on the globe",
  "edit.spin": "The globe spins",
  "edit.spinning": "spinning",
  "edit.step": "Step {n}",
  "edit.stepOf": "Step {n} of {total}",
  "edit.steps": "Steps",
  "edit.title": "Step title",
  "edit.up": "Move the step up",
  "edit.useGlobe": "Use the globe now",
  "edit.usedGlobe": "The step now shows what the globe shows.",
  "edit.words": "Words",
  "edit.words.add": "Add text",
  "edit.words.caption": "Caption",
  "edit.words.kind": "Kind of text",
  "edit.words.note": "Note for the presenter",
  "edit.words.question": "Question",
  "edit.words.task": "Task",
  "edit.words.text": "Text",
  "env.borders": "Borders",
  "env.clouds": "Clouds",
  "env.dayNight": "Day/night",
  "env.earth": "Earth",
  "env.stars": "Stars",
  "error.dismiss.aria": "Dismiss error",
  "game.board.empty": "Nobody has points yet.",
  "game.board.final": "Final board",
  "game.board.players": "Players",
  "game.board.size": "{n} at the table",
  "game.board.tables": "Tables",
  "game.board.title": "The board",
  "game.board.you": "You are number {place} of {total}, with {score} points.",
  "game.board.yourTable": "Your table is number {place} of {total}.",
  "game.driver.lost": "This game was started on another page: from here you can only end it.",
  "game.earth.cost": "{n} tokens",
  "game.earth.finale": "Warming by 2070: +{c} °C, close to the real scenario {scenario}.",
  "game.earth.lens": "Which system you look after",
  "game.earth.next": "Next decade",
  "game.earth.nextIn": "Next decade in {s} s",
  "game.earth.nothing": "Your table played no card this decade.",
  "game.earth.path.high": "A hot path: the planet kept warming.",
  "game.earth.path.low": "A cooler path: warming kept low.",
  "game.earth.path.middle": "A middle path.",
  "game.earth.planIn": "Planning starts in {s} s",
  "game.earth.planLeft": "{s} s to plan",
  "game.earth.played": "Your table played: {list}",
  "game.earth.pool": "Your table has {n} tokens this decade · {left} left on your cards",
  "game.earth.preview": "If the vote closed now: {list} ({n} of {of} tokens)",
  "game.earth.ready": "Ready",
  "game.earth.round": "Decade {n} of {of} · {year}",
  "game.earth.toPlan": "To the plan",
  "game.earth.warming": "+{c} °C",
  "game.end": "End the game",
  "game.khipu.counts": "The room answered: {list}",
  "game.khipu.download": "Download as a Khipu",
  "game.khipu.place": "It was {place}. {n} pins.",
  "game.khipu.save": "Save to my account",
  "game.kind.earth": "Team Earth",
  "game.kind.earth.hint": "Each table plans the decades to 2070 together: cards for air, water, fire and climate, and the planet answers. Up to four stars.",
  "game.kind.maypi": "Where on Earth?",
  "game.kind.maypi.hint": "Each round a clue: everyone pins the place on their own globe. The closer and quicker, the more points.",
  "game.kind.trivia": "Trivia",
  "game.kind.trivia.hint": "The questions of “{title}”: {n} rounds, the globe moving with each.",
  "game.kind.trivia.none": "Open a Khipu with questions first (Browse → Khipus).",
  "game.kind.wayra": "Wayra’s Adventures",
  "game.kind.wayra.hint": "Each table follows Wayra, a puppy, from clue to clue round the world and agrees on where she is. The fewer clues, the more treats.",
  "game.lobby.count": "{n} players at {tables} tables. Before the first round you can move a player to another table.",
  "game.lobby.move": "Table for {name}",
  "game.lobby.title": "Gathering",
  "game.lobby.wait": "Wait for the first round to start.",
  "game.lobby.waiting": "Waiting for players: everyone in the meeting joins by themselves.",
  "game.maypi.data.high": "Where is “{title}” highest right now? Tap the place.",
  "game.maypi.data.low": "Where is “{title}” lowest right now? Tap the place.",
  "game.maypi.where": "Where am I?",
  "game.next.final": "Show the final board",
  "game.next.first": "Start the first round",
  "game.next.round": "Next round",
  "game.panel.aria": "The game",
  "game.pill": "Games",
  "game.point.answer": "It was {place}.",
  "game.point.distance": "Your pin was {km} km away.",
  "game.point.pins": "{n} pins on the globe.",
  "game.point.placed": "Your pin is in. You can tap again to move it until time is up.",
  "game.point.tap": "Turn the globe and tap where you think it is.",
  "game.point.teacher": "The players are pinning the place on their globes.",
  "game.remove": "Close the game",
  "game.round.answered": "{n} of {of} have answered.",
  "game.round.close": "Close the round now",
  "game.round.late": "You came in during this round: you play from the next one.",
  "game.round.left": "{s} s left",
  "game.round.missed": "No answer this round.",
  "game.round.n": "Round {n}",
  "game.round.ofTotal": "Round {n} of {total}",
  "game.round.points": "+{n} points",
  "game.round.scoring": "Time’s up! Scoring…",
  "game.round.tablePoints": "your table +{n}",
  "game.sheet.close": "Close",
  "game.sheet.clueEvery": "A new clue every",
  "game.sheet.decades": "Rounds (decades)",
  "game.sheet.home": "Wayra’s home",
  "game.sheet.homeHint": "Wayra lives where your globe is looking when you start: turn it to your town first.",
  "game.sheet.noData": "Show a dataset with values on the globe to add data rounds too.",
  "game.sheet.planTime": "Time to plan each",
  "game.sheet.privacy": "Players sit at tables of four and get a funny name: nobody types a name, and nothing is kept after the meeting.",
  "game.sheet.rounds": "Rounds",
  "game.sheet.seconds": "{n} s",
  "game.sheet.start": "Start the game",
  "game.sheet.stops": "Stops before home",
  "game.sheet.time": "Time to answer",
  "game.sheet.title": "Start a game",
  "game.sheet.withData": "Add rounds on the data on the globe (“{title}”)",
  "game.stars": "{n} stars of {of}",
  "game.table": "Table {n}",
  "game.tables.done": "Finished",
  "game.tables.over": "Finished",
  "game.tables.ownEarth": "Your table finished with {stars} stars.",
  "game.tables.ownWayra": "Your table finished with {n} treats.",
  "game.tables.playing": "The tables are playing",
  "game.tables.round": "Decade {n} of {of}",
  "game.tables.start": "Start at every table",
  "game.tables.stop": "Stop {n} of {of}",
  "game.tables.treats": "{n} treats",
  "game.tables.waiting": "Waiting for the other tables.",
  "game.tables.watch": "Your table joined after the start: you play in the next game.",
  "game.title.maypi": "Where on Earth?",
  "game.title.trivia": "Trivia: {title}",
  "game.trivia.inGame": "This question is a round of the game.",
  "game.vr.placed": "Your pin is in. Press again to move it until time is up.",
  "game.vr.tables": "Your table plays on a phone or a computer.",
  "game.vr.tap": "Point at the globe where you think it is and press the trigger.",
  "game.wayra.clue": "Another clue",
  "game.wayra.final": "{n} treats of {of}",
  "game.wayra.finale": "Wayra is home!",
  "game.wayra.found": "You found Wayra in {place}! +{n} treats",
  "game.wayra.graceIn": "Last chance: {s} s",
  "game.wayra.home": "Wayra is heading home",
  "game.wayra.homeDefault": "our class",
  "game.wayra.kept": "You kept your treats.",
  "game.wayra.lockHint": "Pick another place to stop it.",
  "game.wayra.locking": "Locking in {s} s",
  "game.wayra.look": "Look at {place} on your globe",
  "game.wayra.lookShort": "Look",
  "game.wayra.next": "Next stop",
  "game.wayra.nextIn": "Next clue in {s} s",
  "game.wayra.para": "It was {place}. Para ate the treats.",
  "game.wayra.share": "Para, her brother, ate {n}. Share some of yours with him?",
  "game.wayra.shareNo": "Keep them ({n})",
  "game.wayra.shareYes": "Share ({n})",
  "game.wayra.shared": "You shared with Para. He is very happy.",
  "game.wayra.sniff": "Wayra is sniffing out her trail…",
  "game.wayra.stop": "Stop {n} of {of}",
  "game.wayra.trail": "Wayra’s trail: {list}",
  "game.wayra.travelIn": "Off again in {s} s",
  "game.wayra.treats": "Treats: {n} · answer now and get {now}",
  "game.wayra.voteHint": "When {n} at your table pick the same place, the answer locks.",
  "game.wayra.wrong": "Not {place}: it is crossed out, and here is another clue.",
  "game.you.full": "This game is full ({n} players). You can follow the board.",
  "game.you.is": "You are {name} · Table {table}",
  "game.you.isPlain": "You are {name} · Table {table}",
  "game.you.joining": "Joining the game…",
  "game.you.mates": "At your table: {list}",
  "game.you.reroll": "Another name, please",
  "geoMedia.action.mute": "Mute",
  "geoMedia.action.pause": "Pause",
  "geoMedia.action.resume": "Resume",
  "geoMedia.action.retry": "Try again",
  "geoMedia.action.stop": "Stop",
  "geoMedia.action.unmute": "Unmute",
  "geoMedia.count.cams.one": "1 camera",
  "geoMedia.count.cams.other": "{count} cameras",
  "geoMedia.count.stations.one": "1 radio station",
  "geoMedia.count.stations.other": "{count} radio stations",
  "geoMedia.credit.label": "Source:",
  "geoMedia.hint.listen": "Pick a dot on the globe to listen",
  "geoMedia.hint.watch": "Pick a dot on the globe to watch",
  "geoMedia.panel.aria": "Live stream",
  "geoMedia.status.connecting": "Connecting…",
  "geoMedia.status.live": "Live",
  "geoMedia.status.paused": "Paused",
  "geoMedia.status.still.minutes": "New picture every {count} min",
  "geoMedia.status.still.seconds": "New picture every {count} s",
  "geoMedia.status.unavailable": "Not answering right now",
  "globeView.announce.flat": "Flat map shown",
  "globeView.announce.globe": "Globe shown",
  "globeView.announce.reset": "View reset",
  "globeView.reset": "Reset the view",
  "globeView.toFlat": "Show a flat map (2D)",
  "globeView.toGlobe": "Show the globe (3D)",
  "help.button.label": "Help",
  "help.close.aria": "Close help",
  "help.feedback.contact.label": "Contact (optional)",
  "help.feedback.contact.placeholder": "Email or handle — only used to follow up if we have questions",
  "help.feedback.counter": "{count} / {max}",
  "help.feedback.kind.aria": "Feedback type",
  "help.feedback.kind.bug": "Bug report",
  "help.feedback.kind.feature": "Feature request",
  "help.feedback.kind.other": "Other",
  "help.feedback.message.label": "Describe what happened or what you'd like to see",
  "help.feedback.message.placeholder": "Tell us as much as you can — steps to reproduce, what you expected, and what actually happened.",
  "help.feedback.notice": "We store what you send here, with the page address and your browser type, to act on it.",
  "help.feedback.notice.link": "Privacy policy",
  "help.feedback.screenshot.label": "Attach a screenshot of the current view",
  "help.feedback.status.captureFailed": "Couldn't capture screenshot — sending text only…",
  "help.feedback.status.capturing": "Capturing screenshot…",
  "help.feedback.status.failed": "Couldn't send feedback",
  "help.feedback.status.failedReason": "Couldn't send feedback: {error}",
  "help.feedback.status.sending": "Sending…",
  "help.feedback.status.success": "Thanks! Your feedback was received.",
  "help.feedback.status.tooShort": "Please enter at least {min} characters.",
  "help.feedback.submit": "Send feedback",
  "help.guide.section.exploring": "<h3>Exploring datasets</h3><ul><li>Press <strong>Browse</strong> in the bottom-right. It has four tabs: <strong>Catalog</strong>, <strong>Recent</strong>, <strong>Khipus</strong> and <strong>My data</strong> (when it is switched on).</li><li><strong>Khipus</strong>: open a Khipu file or one you saved, and, with an Education plan, the lessons: pick a lesson and press <strong>Start the lesson</strong>. Each step loads its dataset and shows the students' questions; the camera, the date and the pins are yours. <strong>Keep this view for this step</strong> remembers yours, and <strong>Download my lesson</strong> saves your version. With Tools open, the lesson panel stands above Tools at the right edge, and each scrolls in its part when both do not fit.</li><li><strong>My data</strong> (Researcher and Lab plans, once own data is switched on for this site): upload a file of your own (NetCDF, GeoTIFF, Zarr, HDF5 or GRIB). It is encrypted in your browser, checked, and after you choose the variable, range and accuracy it becomes a private dataset that only you and your lab can open. Each value then shows its ±, and the information panel has an <strong>Accuracy</strong> section. <strong>Share</strong> invites someone by email or makes a link (at most 30 days) to view it in AYNI XR, without its exact values; <strong>Shared with me</strong> lists what others shared with you, on any plan; <strong>Continuous sources</strong> reads a bucket of yours on a schedule. Sharing, deleting and other risky steps ask you to confirm with a passkey (add one under Account → Passkeys) or a code we email you. Your original file and exact values are encrypted; the stream on the globe is protected by access tokens only.</li><li>Search in your own words: typos are forgiven, related words count (\"wildfires\", \"SST\"), and so does the kind of data (\"live fires\", \"future sea level\"). Titles that start with what you type come first, A to Z, then titles with it further on, then datasets found by their keywords and topics. Datasets related by meaning appear under the matches.</li><li><strong>Filters</strong> (beside the results) holds <strong>Kind &amp; theme</strong> and the rest; the icons beside it switch to the Map, Timeline or Graph view. On the Map, click a region to show only its datasets; click it again, or the filter's ×, to show everything.</li><li>With a free account, or signed out, <strong>Free</strong> beside Filters shows only what your account opens: the catalogue and the free streams. Press it again to see everything.</li><li>Each card shows what kind of data it is and its package, or <strong>Free</strong> for the catalogue. A lock means the package is not in your plan: click it to see the plans.</li><li>The catalogue, thumbnails and legends are open to everyone; playing a live stream needs your free account and a plan that includes it. Once the stream host checks this, a stream you cannot play says so: sign in, or see the plans.</li><li>Click a card to read more about it; press <strong>Load</strong> to put it on the globe.</li><li>Right-click a card, press and hold it on a touch screen, or press its <strong>+</strong> to add it to a new or existing Khipu, or share it.</li><li>The bar at the top left plays a dataset that moves at 0.25×, 0.5×, 1×, 2× or 5×; away from 1×, a green button beside ▶ shows the speed and takes it back to 1×. With a real-time stream on, the speeds it cannot keep up with are greyed.</li><li>The <strong>✕</strong> beside the dataset's name in the playback controls returns you to the plain Earth.</li><li>A value read from a dataset shows its ±: the rounding, plus the streaming error when the dataset states it. <em>(rounding only)</em> means it does not, so the real error can be larger. The information panel's <strong>Accuracy</strong> section names the source, the release and each error, and exports carry the same.</li><li><strong>Ringed planets:</strong> a dataset of Saturn, Jupiter, Uranus or Neptune shows the planet's rings around the globe — in the browser, in the headset and in AR on a phone (not on the flat map).</li></ul>",
  "help.guide.section.khipus": "<h3>Khipus</h3><ul><li>A Khipu records what is shown on the globe, step by step: a story, a lesson or the record of a session.</li><li>Some NOAA datasets open with their Khipu: their view, date and borders, or a story with captions, pictures and links in the Khipu panel.</li><li>In Browse, open the <strong>Khipus</strong> tab and press <strong>Open a Khipu file…</strong>; your saved ones are under <strong>My Khipus</strong>.</li><li><strong>Record a Khipu</strong>, in the same place, records your own: in <strong>Automatic</strong> each view you stay on becomes a step (with the way it is turned and tilted, the spin if the globe turns, the playback speed, and your pins), in <strong>Manual</strong> only <strong>Record this view</strong> makes one; <strong>Add a note</strong> writes its caption, and <strong>Stop</strong> lets you name it, play it, save it or download it.</li><li><strong>New Khipu</strong>, or <strong>Edit</strong> on a story, opens the editor: add steps from the globe, reorder them, write their texts and quiz, add pictures and links, give a step its <strong>Moves and effects</strong> (how it is reached, an orbit or push while it is shown, a spotlight, vignette, title card or callouts), then <strong>Preview</strong>, save or download. The player plays the moves and effects on the globe (at once for someone who asked for less motion).</li><li>Each step loads its dataset, moves the globe (or frames an area) and can set the date, the colours and up to six pins; it shows its captions, pictures and links. <strong>Next</strong> and <strong>Previous</strong> move through it; <strong>Pause</strong> holds steps that move on by themselves.</li><li>A step with a quiz takes one answer and then shows the right one; in a meeting you present, <strong>Ask the room</strong> puts it to everyone.</li><li>Opening or closing a Khipu or a lesson takes every pin off the globe.</li><li>In a meeting, the room sees the step and its captions in a card of its own.</li><li>In a lesson, some steps offer live variables to add over the dataset one at a time, such as cloud, then rain, then lightning over the sea's temperature: each press plays one on the same date and shows what to look for.</li><li><strong>Download</strong> saves it as a .zip; <strong>Save to my account</strong> keeps it on plans that keep Khipus.</li><li><strong>Add to a Khipu:</strong> right-click a dataset (press and hold it on a touch screen, or press its <strong>+</strong>, or <strong>Add to a Khipu</strong> in its information) and choose <strong>Add to a new Khipu…</strong> or one of your Khipus. A tick shows where it already is; choosing a ticked one takes it out again. On plans that keep Khipus each change is saved to <strong>My Khipus</strong>; otherwise the new Khipu opens in the editor, the menu adds to it while it is open, and <strong>Download</strong> keeps it.</li><li>In the editor, <strong>Start again after the last step</strong> makes a Khipu loop.</li><li>Playlists are Khipus now: the ones you had appear under <strong>My Khipus</strong>, or, on a plan that does not keep Khipus, under <strong>Your playlists, now Khipus</strong>, to open in the editor and download. An old playlists file (.json) opens with <strong>Open a Khipu file…</strong>.</li></ul>",
  "help.guide.section.manual": "<p>This is the short guide. The <a href=\"/manual\" target=\"_blank\" rel=\"noopener\">AYNI XR user manual</a> explains everything in detail: pins and the graph, meetings, VR and AR, accounts and plans, and buying a plan online, managing or cancelling it.</p>",
  "help.guide.section.meetings": "<h3>Meetings</h3><ul><li>In a meeting the presenter drives the globe and everyone else follows. <strong>Start an activity</strong> opens a window you can drag by its title.</li><li>Everyone sees the presenter’s colours (palette, invert, colour range) and pins. When the presenter’s pin graph is on their screen, it opens on yours too: ✕ closes it. In a class you can add your own pins beside the presenter’s.</li><li><strong>Let them explore</strong> gives everyone their own globe and the whole Tools panel until the time is up or <strong>Bring everyone back</strong>. <strong>Ask</strong> questions answered on the globe or with options, or run a <strong>Poll</strong>: no right answer, everyone sees the counts, nobody sees who voted for what.</li><li>Participants can give a name (optional). The meeting keeps their name and answers until it ends; <strong>My answers</strong> lists one's own, and a reload loses nothing.</li><li>The presenter and moderators open <strong>People</strong>: who is in, raised hands, <strong>Give the globe</strong>, <strong>Take back</strong>, <strong>Mic off</strong>, <strong>Remove</strong>, and each activity's answers by name. Remove holds for that browser until the meeting ends: someone who clears their cookies or comes from another browser is a new person. While someone has the globe, the presenter can <strong>Take over</strong> and <strong>Hand back</strong>.</li><li>In a headset, the dock says when the presenter has the controls, is live or ends the meeting, and its speaker button turns the meeting’s sound on and off. In a class your own pins work there too (A or X), and a Where on Earth? round is answered with the trigger. While you follow, the globe grows up to 2× (more only if the presenter’s globe is bigger).</li><li><strong>End meeting</strong> ends it for everyone and deletes what it kept; everyone else can <strong>Leave</strong>.</li></ul>",
  "help.guide.section.multiglobe": "<h3>Several globes</h3><ul><li>In <strong>Tools → View → Layout</strong> choose two or four globes, or pick <strong>Open beside</strong> in a dataset card's menu to put it on a second globe.</li><li>Each globe has a row at its top-left: its <strong>number</strong> (press it to make that globe the main one, whose date and transport the others follow), its <strong>dataset</strong> or <strong>+ Add a dataset</strong> (opens Browse loading into that globe; the cards say whether they share dates with globe 1), its <strong>date rule</strong> (same date, 1, 10 or 30 years earlier, 3 or 6 months later, another offset, or a fixed date) and the <strong>date it shows</strong>.</li><li>Turning one globe turns them all. Playback follows the real date on globe 1; the others follow through their rule. A globe with no data for its date is dimmed; streams follow frame by frame.</li><li>Pins are shared: a pin is drawn on every globe with that globe's reading, and the graph draws the other globes' readings dashed, against globe 1's dates.</li><li>Point at any globe and the box under its row shows the place and, for a dataset that carries its values, that globe's value.</li><li>The link you copy carries every globe's dataset and date rule.</li><li>With a Research or Situation Room plan, <strong>Analyze → Compare → Another globe</strong> subtracts another globe from the main one.</li><li>With a Media Desk or Newsroom plan, a <strong>Studio</strong> stop added while several globes show keeps them all: the video shows them side by side, each labelled with its own date, and credits every dataset.</li><li><strong>Tools → More → Open a sphere output (2:1)</strong> shows the main globe as one flat 2:1 picture of the whole Earth, with its layers and pins, following this window: the format Science On a Sphere and other spherical displays play. Capture that window on the sphere's computer.</li></ul>",
  "help.guide.section.navigating": "<h3>Navigating the globe</h3><ul><li>Drag to rotate the Earth.</li><li>Scroll or pinch to zoom.</li><li>Over Catalonia and the Netherlands you can zoom in until you see the streets, on aerial photos (about 4 m a pixel); over Barcelona and Rotterdam closer still (about 1 m). With <strong>3D terrain</strong> on (Tools → More) the hills rise at their real height, with the dataset lying on them. You can tilt the view up to 85°; close over steep hills a little less, so the camera stays above the ground.</li><li>Double-click (or double-tap) the globe to go back to the starting view.</li><li>Some datasets draw shapes on the globe, such as earthquakes as circles that grow and fade, or tropical cyclones as tracks with a box giving each storm's name and wind (in km/h). Click or tap a shape for its details and a link to its source; click elsewhere to close them.</li></ul>",
  "help.guide.section.orbit": "<h3>Talking to Ayni Chatbot</h3><ul><li>Ayni Chatbot finds datasets, takes you to places and dates, and reads the values on the globe. It comes with the AYNI XR plans.</li><li>Open it from <strong>Ask Ayni Chatbot</strong> (bottom left) or the speech-bubble button in the Browse panel.</li><li>Ask it to place pins to follow the data over time; if you do not say where, it asks. Let the dataset play, then ask how the values changed.</li><li>Ask for statistics (\"the average in the Arctic\", \"where is it highest?\", \"how does it change with latitude?\"): it answers with the Analyze panel's numbers and opens Analyze on that region.</li><li>On a dataset that draws records, such as the earthquakes, ask about them (\"the biggest earthquake on this day\", \"quakes deeper than 300 km this month\"): it reads each one's own values (magnitude, depth, place), not the colours.</li><li>With a Research or Situation Room plan it also gives the pins' trend, emergence and correlation, holds a baseline, compares, measures the area over a threshold and writes the methods paragraph, with every caution; it opens the figure or points at Bundle for you to press, and never exports or records anything itself. While you record a session, its numbers go in marked \"via the chatbot\".</li><li>It answers in your language (English, Spanish or Catalan) and never guesses a number: values come from the data on screen.</li></ul>",
  "help.guide.section.privacy": "<h3>Privacy</h3><p>The app reports usage events &mdash; which layers load, how long they're viewed, whether anything errored &mdash; only if you allow it. There is no tracking cookie and no third-party analytics service. The datasets and maps come from AYNI&rsquo;s own servers, so NOAA and the map services never see your address. Feedback you submit is stored with your browser's user agent and the page URL; attaching a screenshot is opt-in.</p><p><strong>Recently viewed</strong> (Browse&rsquo;s Recent tab) remembers the datasets you open only if you say yes when the app first asks, and only on this device. Saying no, or switching it off later, deletes what it kept.</p><p>You can switch between Essential, Research, and Off, and turn Recently viewed on or off, under <strong>Tools &rarr; More &rarr; Privacy settings…</strong>; the change takes effect immediately. <a href=\"/privacy\" target=\"_blank\" rel=\"noopener\">Read the full privacy policy &rarr;</a></p>",
  "help.guide.section.shortcuts": "<h3>Keyboard shortcuts</h3><ul><li><kbd>Esc</kbd> — close the active panel</li><li><kbd>Enter</kbd> — send a chat message</li><li><kbd>Space</kbd> — toggle playback when a video dataset is loaded</li></ul>",
  "help.guide.section.tools": "<h3>Tools &amp; settings</h3><ul><li>The sliders button next to Browse opens <strong>Tools</strong>. On a computer it stays open until you close it. The buttons at the top right move aside only if Tools would reach them; on a tall screen they stay where they are.</li><li><strong>Layers</strong> — up to two overlays at a time (a third replaces the first), each overlay in its own colour. Country borders are an overlay; streams that cover the Earth with colour, and streams that come with borders listed (climate zones, many projections), get them automatically. The Overlay card also has NOAA's teaching overlays: plate boundaries and names, rivers, place and ocean names, time zones, roads and railroads. The real-time list can be searched and shows only streams with dates in common with your dataset, each marked with its kind (Live, Forecast, Reanalysis, Historical or Projection); the list remembers the streams' dates on this device, so it opens at once; up to four can play at once on a computer (two on a phone or headset; one with Plus), each with a yellow track above the date track showing its dates; the eye beside a track's name hides that stream and shows it again, and its ✕ takes it off. Hold the ⠿ left of a track and drag it up or down to change the order the streams are drawn in (the top one on top); the palette button beside it changes that stream's palette (<strong>Invert</strong> turns it round) and its minimum and maximum, and its <strong>Transparency</strong>, beside Done, makes it see-through (every stream, even one whose colours cannot change). The green track of the dataset has an eye and a ✕ too: the eye hides the dataset and leaves the streams on the Earth, the ✕ closes the dataset and every stream, with <strong>Undo</strong> for a few seconds. <strong>Satellites</strong>, under the layer cards, shows every tracked satellite where it is now, with a fading trail: choose which, colour them by orbit, country or purpose, play time faster or move up to a day either way, and click one for its card. The <strong>Space events</strong> box on the globe lists launches, re-entries and notable events: press one to see what happened and, for a re-entry, the orbit it last flew and where it came down. When the data on the globe comes from satellites (GeoColor: GOES-19, GOES-18, Himawari-9, Meteosat-12 and Meteosat-9), those pulse with a halo and the card lists them under <strong>Data from</strong>; press a name to follow it. <strong>With datasets</strong>, under Show, marks every satellite that provides data for a dataset in the catalog; a satellite’s card lists those datasets, each with <strong>Load</strong>. <strong>Field of view</strong> draws the circle each of them can see out to its horizon, and a thin strip on the date track shows which satellite supplied each period (rest the pointer on it). In AR, Sky above me names the next of them to pass over you, with Load; Browse’s filters have a <strong>Satellite</strong> chip. They are drawn only on a dataset of the Earth: with Saturn, the Moon or the Sun on the globe the card says so and draws none. In VR and AR they fly around the globe at their height, and in AR <strong>Sky above me</strong> draws those over your head on the real sky, and <strong>Fully VR</strong> hides the room behind the night sky: the Milky Way, the stars and the Sun where they stand from your place, turning with the clock. There the globe and the sky are one: turn the globe and the sky turns with it, grab the sky and the globe turns, and the globe's day side always faces the Sun.</li><li><strong>Data</strong> — <strong>Pin on globe</strong> (up to six pins, two with Plus, each with its value beside it on the globe; click a pin's name to rename it) with a graph of their values over time (drag the graph, or press its ⇱, to take it out onto the globe, where it moves and resizes; ✕ or a drop on Tools puts it back), <strong>Mark highest &amp; lowest</strong> (two pins that follow the highest and lowest values as the data changes, looked for <strong>Everywhere</strong>, on <strong>Land only</strong> or at <strong>Sea only</strong>; lakes, rivers and the shore count as neither; <strong>Follow as the data changes</strong> off leaves them where they are, and <strong>Show track</strong> draws the path each one took), and <strong>Measure</strong>: a <strong>Line</strong>, a <strong>Box</strong>, or <strong>Statistics</strong> over the whole globe, the tropics, a hemisphere, the Arctic, the Antarctic or what you can see. <strong>Clear pins, lines and boxes</strong> removes it all. On the Research and Education plans, <strong>Analyze</strong> beside Browse opens the statistics in one click. Analyze is in tabs: Statistics, Profiles, Contours, Baseline and Compare; Compare (Research and Situation Room) subtracts a real-time overlay or another globe from the dataset, on the same date and grid, with bias, RMS difference and pattern correlation, the region read on both side by side, the difference drawn while playing, and, for amounts such as rain, the difference as a % of B. On the graph a green line shows where playback is; click the graph to play from that date. While paused, pointing at the graph shows each pin's value at that date beside it on the globe. <strong>Download CSV</strong> saves the pins' values, and every Analyze result has its own download. With an Education plan the download is the pins'. Plus reads values and pins, without Line, Box or downloads. On the Research and Situation Room plans, <strong>Trend</strong>, <strong>Emergence</strong> and <strong>Correlation</strong> under the graph test the pins' series: a trend both tests agree on, the year values leave a baseline's natural range, and how two pins vary together; the manual explains each. Some datasets draw <strong>reference lines</strong>, dashed on the pin graph and marked on the legend: the Paris Agreement’s 1.5 °C and 2 °C on the temperature projections (limits on the global average, not on one place) and Ω = 1 on aragonite saturation, below which seawater dissolves shells. <strong>Reference lines</strong>, under the graph or in View, hides them.</li><li><strong>View</strong> — the colours of a dataset that carries values (palette, <strong>Invert palette</strong>, colour limits), kept for that dataset and, signed in, on your account. Temperature datasets of air, sea and land all open in the same colours (Turbo, −25 to 50 °C) so they compare at a glance; <strong>Reset colours</strong> goes back to them. Then the layout (one, two or four globes; one with a free account or Plus, up to two with an Education plan) and sun glint. At the foot, <strong>Legend</strong>: the ✕ on a legend, or dragging it onto Tools, parks it here; ⇱, or dragging it out onto the globe, puts it back.</li><li><strong>More</strong> — labels, 3D terrain, dataset info, legend, UI size, language, Ayni Chatbot settings, credits, privacy settings and the user manual.</li><li>With a Research or Situation Room plan, <strong>Area over a threshold</strong> at the bottom of Analyze's Statistics tab measures how much of the region is above or below a value (or, with a baseline held, a change or a σ change), in true km² with the data's step given as a range; on a stream it fills a graph frame by frame as the dataset plays, and downloads as CSV, naming the frames where the area was largest and smallest.</li><li>With a Research or Situation Room plan, <strong>Region through time</strong> under it follows the region (the whole globe, the Tropics, a country, a box) frame by frame: its mean, highest and lowest, and when the records were (the highest and lowest value and where, the highest and lowest mean), each date a button that plays from that frame. Countries are measured by their outline, not a box. The pins' graph and the Line over time also name when (and where) they were highest and lowest, and a Line can run along a latitude: the Equator, a tropic, a polar circle or any latitude, all the way round.</li><li>With a Research or Situation Room plan, <strong>Hold as baseline</strong> under Analyze statistics keeps a frame; every other frame then shows its change from it, and <strong>On the globe</strong> draws that change (or the % change) on the globe, while playing or when paused; <strong>Colour range</strong> under its colour bar sets the lowest and highest change it shows, and <strong>Automatic</strong> goes back to the range set from the data; the button left of the bar chooses its palette and <strong>Invert</strong>, as a stream’s palette button does. Compare’s difference has the same two. The pointer, the pins and their graph then read the change too, and <strong>Mark highest &amp; lowest</strong> finds the largest rise and fall (or % change) rather than the highest and lowest values. Choose <strong>A period</strong> instead to compare with the average of many years (1991–2020 by default), each month with its own month: press <strong>Start reading</strong>, play the period through (or press <strong>Read the missing frames</strong>), and once every frame is read (or 80 % of each month's, with <strong>Use the frames read</strong>), <strong>σ change</strong> shows how unusual each place is for that month. Data a few hours apart is compared hour by hour, so the daily cycle is not read as change.</li><li>With a Research or Situation Room plan, <strong>Line over time</strong> under a line in Analyze's Profiles tab records a Hovmöller diagram as the dataset plays: distance along the line across, time downward, in the dataset's colours. Point at it to read a value, click a row to play from that frame, and download it as CSV or PNG. With a baseline held it shows the change from it; with a period, each row against its own frame's month, in σ too.</li><li>With a Research or Situation Room plan, <strong>Record this session</strong> (Tools &rarr; Data) keeps a record of your work: each view you stop on, with its link and citation, the pins and their values, statistics, baselines, comparisons and trends, figures, methods paragraphs and areas over a threshold, and every file you export with its SHA-256 fingerprint. Nothing is recorded until you switch it on; a red <strong>Recording</strong> mark shows while it is on, and the record has no name on it unless you tick <strong>Put my name on the record</strong>. Save it to your account or download it as a .zip; <strong>Open</strong> a saved one to walk its views again and see whether the data has changed since.</li><li>With a Lab or Department plan (or a Situation Room team), <strong>Lab space</strong> (Tools &rarr; Data) shares your work with everyone who holds a seat of the same licence: <strong>Share this view</strong>, <strong>Share these pins</strong>, <strong>Share the baseline</strong> (what it is, not its numbers: whoever opens it measures the frame or reads the period again from the data) and a research record saved to your account. <strong>Open</strong> puts it on your globe; <strong>Copy as mine</strong> keeps your own copy. Your name is shown on what you share, to the lab only; a record with your name on it asks whether to share it with your name or without names. The lab’s owner sees who holds a seat and is told when someone new joins. It is kept while the licence runs and 30 days after; someone who gives back their seat loses access at once.</li><li><strong>Cite this view</strong> (in the information panel under Data credit, and under Analyze results) gives a citation as text, BibTeX or RIS, and a link that reopens the same dataset, frame and place. CSV files carry the same details in their first rows.</li><li>With a Research or Situation Room plan, <strong>Figure</strong> under the Analyze tabs saves a 300 dpi figure (the globe as shown, or an Equal Earth map) with its colour bar and the citation, as PNG or SVG; <strong>Methods</strong> writes a methods paragraph with references from what you did; <strong>Bundle (.zip)</strong> saves all of it in one file: the citation, the link, the methods, every CSV you can export, the figure and your research record, with a list of each file's SHA-256 to check it by.</li><li>With a Media Desk or Newsroom plan, <strong>Studio</strong> beside Browse makes a video of the globe: set the shape, resolution and file (MP4, H.265, ProRes 4444 with transparent space on Newsroom, a GIF or a still image), then add <strong>stops</strong> from the current view, date and dataset (or start from a template, or open one of your Khipus; <strong>Make a video of this Khipu</strong> in the Khipu player does the same). While the Studio is open, playing the data is recorded: the date it starts from and the date you pause on become stops, and the video runs through those dates for as long as it played. Each stop holds for some seconds (drag its end on the timeline) and says how the camera gets there (fly, glide, cut or along a path), what the data does on the way (change at once, crossfade, wipe, run through the dates, or through the plain Earth), what the camera does while it holds (orbit, push in, pull out), and its effects: a spotlight, depth blur, vignette, grain, a title card, callouts that read the data, arrows, a value counter, and the same data at another date beyond a moving line. <strong>Finishing</strong> adds motion blur (twice the credits), an end card with every data credit, an animated logo and lower third, and a voice-over of your own (you confirm its rights; it is kept 30 days). A brand kit puts your logo and lower third on it. <strong>Preview</strong> plays it on the globe, <strong>Save and get a quote</strong> gives its price in credits (a stop with several globes costs once per globe), and <strong>Order the video</strong> has it rendered on a server, with the data credit in the picture; a finished video can be downloaded for 30 days, or kept until your licence’s term ends with <strong>Keep</strong> (1 credit). A finished video also has a poster and <strong>Embed code</strong> for your own site. On Newsroom, editors can require their approval before a member’s order is rendered. Rendering is not open yet.</li><li><strong>Share</strong> is on the home screen, top-left under Show anchor. <strong>Spin the globe</strong> (⟳) is top-right under Help; while it spins, its slider sets the speed. Under it, <strong>Reset the view</strong> (⌖) turns the globe back to where it started. <strong>2D</strong> under it shows a flat map, twice as wide as it is high; <strong>3D</strong> brings the globe back. On it, <strong>Labels</strong> shows place names and, without a dataset, it shows day and night.</li><li>Press <kbd>Esc</kbd>, ✕ or the Tools button to close it.</li></ul>",
  "help.panel.title": "Help",
  "help.tab.feedback": "Feedback",
  "help.tab.guide": "Guide",
  "help.tablist.aria": "Help sections",
  "help.trigger.aria": "Open help and feedback",
  "help.trigger.title": "Help and feedback",
  "info.panel.aria": "Dataset information",
  "info.picker.aria": "Select dataset to view",
  "info.picker.label": "Showing info for",
  "infoPanel.captionsAvailable": "Captions available",
  "infoPanel.catalogLink": "View in SOS catalog ↗",
  "infoPanel.dateAdded": "Added",
  "infoPanel.description.showLess": "Show less",
  "infoPanel.description.showMore": "Show more",
  "infoPanel.developedBy": "Developed by",
  "infoPanel.relatedDatasets": "Related datasets",
  "infoPanel.section.credits": "Credits",
  "infoPanel.section.dataCredit": "Data credit",
  "infoPanel.section.links": "Links",
  "infoPanel.source": "Source",
  "infoPanel.thumbnail.alt": "{title} thumbnail",
  "infoPanel.thumbnail.download": "Download thumbnail",
  "infoPanel.visualizationBy": "Visualization by",
  "khipu.kind.briefing": "Briefing",
  "khipu.kind.lesson": "Lesson",
  "khipu.kind.research": "Research record",
  "khipu.kind.session": "Session record",
  "khipu.kind.story": "Story",
  "khipu.player.announce": "Step {n}: {title}",
  "khipu.player.aria": "Khipu: {title}",
  "khipu.player.close": "Close the Khipu",
  "khipu.player.collapse": "Fold the Khipu panel",
  "khipu.player.credit": "Credit: {credit}",
  "khipu.player.download": "Download (.zip)",
  "khipu.player.edit": "Edit",
  "khipu.player.ended": "The Khipu has ended.",
  "khipu.player.expand": "Open the Khipu panel",
  "khipu.player.film": "Make a video of this Khipu",
  "khipu.player.licence": "Licence: {licence}",
  "khipu.player.mediaCredit": "Credit: {credit}",
  "khipu.player.moment": "Moment {n} of {total}",
  "khipu.player.move": "Move the Khipu panel (drag, or use the arrow keys)",
  "khipu.player.newTab": "{title} (opens in a new tab)",
  "khipu.player.next": "Next",
  "khipu.player.notes": "Presenter notes",
  "khipu.player.panorama": "360° picture",
  "khipu.player.pause": "Pause",
  "khipu.player.paused": "Paused.",
  "khipu.player.play": "Play",
  "khipu.player.playing": "Playing.",
  "khipu.player.scrub": "Moment in the record",
  "khipu.player.step": "Step {n} of {total}",
  "khipu.player.untitledStep": "Step {n}",
  "khipu.quiz.aria": "Quiz question",
  "khipu.quiz.askRoom": "Ask the room",
  "khipu.quiz.asked": "Asked the room",
  "khipu.quiz.hint": "Show a hint",
  "khipu.quiz.kind": "Quiz",
  "khipu.quiz.right": "Right!",
  "khipu.quiz.wrong": "Not quite: the answer is {answer}.",
  "khipu.record.aria": "Recording a Khipu",
  "khipu.record.capture": "Record this view",
  "khipu.record.captured": "Step {n} recorded.",
  "khipu.record.close": "Close",
  "khipu.record.closeConfirm": "Close without saving? Press ✕ again.",
  "khipu.record.defaultName": "My Khipu, {date}",
  "khipu.record.discard": "Discard",
  "khipu.record.done": "Your Khipu",
  "khipu.record.edit": "Edit it",
  "khipu.record.full": "the most steps a Khipu keeps",
  "khipu.record.hint": "A draft: nothing leaves this page until you save or download it.",
  "khipu.record.hintDownload": "A draft: nothing leaves this page until you download it. Your plan does not keep Khipus on your account.",
  "khipu.record.mode": "Recording mode",
  "khipu.record.mode.auto": "Automatic",
  "khipu.record.mode.autoHint": "Each view you stay on for two seconds becomes a step",
  "khipu.record.mode.autoOn": "Automatic: each view you stay on becomes a step.",
  "khipu.record.mode.manual": "Manual",
  "khipu.record.mode.manualHint": "A step only when you press Record this view",
  "khipu.record.mode.manualOn": "Manual: press Record this view to make a step.",
  "khipu.record.name": "Name",
  "khipu.record.note": "Add a note",
  "khipu.record.noteAdd": "Add",
  "khipu.record.noteCancel": "Cancel",
  "khipu.record.noteLabel": "A note for this step",
  "khipu.record.notePlaceholder": "What should people see here?",
  "khipu.record.noted": "Note added to this step.",
  "khipu.record.play": "Play it",
  "khipu.record.recording": "Recording a Khipu",
  "khipu.record.started": "Recording a Khipu. Each view you stay on for two seconds becomes a step.",
  "khipu.record.steps.one": "1 step",
  "khipu.record.steps.other": "{n} steps",
  "khipu.record.stop": "Stop",
  "khipu.record.stopped": "Recording stopped: {steps}.",
  "khipu.record.untitled": "My Khipu",
  "khipu.step.globes.failed": "Globe {n} could not show {title}",
  "khipu.story.unavailable": "{title} has no Khipu in AYNI.",
  "khipus.converted.saved.one": "Your playlist is now a Khipu, saved under My Khipus.",
  "khipus.converted.saved.other": "Your {count} playlists are now Khipus, saved under My Khipus.",
  "khipus.lessons.heading": "Lessons",
  "khipus.open.file": "Open a Khipu file…",
  "khipus.open.heading": "Khipus",
  "khipus.open.hint": "A Khipu records a story, a lesson or a session on the globe, step by step. Open a .kpu file, or the .zip AYNI downloads, or record your own.",
  "khipus.open.new": "New Khipu",
  "khipus.open.notKhipu": "{name} is not a Khipu AYNI can open.",
  "khipus.open.playlistsSaved.one": "The playlist in that file is now a Khipu, saved under My Khipus.",
  "khipus.open.playlistsSaved.other": "The {count} playlists in that file are now Khipus, saved under My Khipus.",
  "khipus.open.playlistsWaiting.one": "The playlist in that file is now a Khipu: see “Your playlists, now Khipus” above.",
  "khipus.open.playlistsWaiting.other": "The {count} playlists in that file are now Khipus: see “Your playlists, now Khipus” above.",
  "khipus.open.record": "Record a Khipu",
  "khipus.open.recordBusy": "Recording… (see the top of the page)",
  "khipus.open.recordInRoom": "In a meeting, the presenter saves the meeting as a Khipu instead.",
  "khipus.open.tooLarge": "{name} is too large to open (16 MB at most).",
  "khipus.waiting.away": "Put away",
  "khipus.waiting.awayConfirm": "Press again to put it away",
  "khipus.waiting.heading": "Your playlists, now Khipus",
  "khipus.waiting.hint": "Playlists are Khipus now. Your plan does not keep Khipus on your account: open one in the Khipu editor and download it (.zip) to keep it, or put it away.",
  "khipus.waiting.hintKeep": "These could not be saved to your account yet. Open one in the Khipu editor and save it, or put it away.",
  "khipus.waiting.open": "Open in the editor",
  "legal.termsUrl": "/terms",
  "legend.close": "Close the legend (it goes to Tools → View)",
  "legend.dock.away": "The legend is on the globe. Close it with ✕, or drag it here, to park it.",
  "legend.dock.awayVr": "The legend is beside the globe. Its ✕ parks it here.",
  "legend.dock.backAnnounce": "Legend back on the globe",
  "legend.dock.dropHere": "Drop it here to park it",
  "legend.dock.globe": "Globe {n}",
  "legend.dock.park": "Park it here",
  "legend.dock.parkedAnnounce": "Legend parked in Tools → View",
  "legend.dock.parkedNote": "Drag it onto the globe, or press ⇱, to show it there again.",
  "legend.dock.picture": "Dataset legend",
  "legend.dock.popOut": "Put the legend back on the globe",
  "legend.dock.title": "Legend",
  "legend.dock.unparkVr": "Beside the globe",
  "legend.moveHint": "Drag to move · drag the corner to resize · double-click the corner to put it back",
  "lessons.back.aria": "Back to the lessons",
  "lessons.canvas.hint": "A lesson is a canvas: each step loads its dataset and leaves the camera, the date and the pins to you.",
  "lessons.card.grade": "Grade {grade}",
  "lessons.card.kept": "Your views kept",
  "lessons.card.minutes": "{minutes} min",
  "lessons.card.steps.one": "1 step",
  "lessons.card.steps.other": "{count} steps",
  "lessons.count.one": "1 lesson",
  "lessons.count.other": "{count} lessons",
  "lessons.detail.correction": "What is actually true",
  "lessons.detail.exitTicket": "Exit ticket",
  "lessons.detail.misconception": "Common misconception",
  "lessons.detail.overlays": "Overlay: {list}",
  "lessons.detail.question": "Driving question",
  "lessons.detail.saved.one": "You kept your view for 1 step in this browser.",
  "lessons.detail.saved.other": "You kept your views for {count} steps in this browser.",
  "lessons.detail.steps": "Steps",
  "lessons.detail.teacherNotes": "Teacher notes",
  "lessons.detail.unavailable": "not in the app yet",
  "lessons.empty": "No lesson matches.",
  "lessons.error": "The lessons could not be loaded.",
  "lessons.filter.grade.all": "All grades",
  "lessons.filter.grade.aria": "Grade",
  "lessons.filter.grade.option": "Grade {grade}",
  "lessons.filter.unit.all": "All topics",
  "lessons.filter.unit.aria": "Topic",
  "lessons.flagship": "Flagship",
  "lessons.loading": "Loading the lessons…",
  "lessons.locked.plan": "Your plan does not include the lessons. They come with the Education plans (Teacher, School and District).",
  "lessons.locked.signedOut": "The lessons come with the Education plans (Teacher, School and District). Sign in with an account that has one.",
  "lessons.mine.confirmDelete": "Delete for good",
  "lessons.mine.delete": "Delete",
  "lessons.mine.deleted": "Khipu deleted.",
  "lessons.mine.download": "Download",
  "lessons.mine.edit": "Edit",
  "lessons.mine.empty": "Khipus you save to your account appear here.",
  "lessons.mine.ended": "Your plan no longer keeps Khipus. Download the ones you want before the date shown; after it they are deleted.",
  "lessons.mine.error": "Your saved Khipus could not be loaded.",
  "lessons.mine.heading": "My Khipus",
  "lessons.mine.meta": "Saved {saved} · kept until {kept}",
  "lessons.mine.open": "Open",
  "lessons.notice": "AYNI lesson by Pachamama Studios B.V., CC BY-NC-SA 4.0. Not for commercial use, and not for use in promotion by any company or organisation, without permission.",
  "lessons.open.aria": "Open the lesson {title}",
  "lessons.plans": "See the plans",
  "lessons.player.announce": "Step {n}: {title}",
  "lessons.player.aria": "Lesson",
  "lessons.player.close": "Close the lesson",
  "lessons.player.collapse": "Fold the lesson panel",
  "lessons.player.dataset.again": "Load again",
  "lessons.player.dataset.failed": "{title} could not be loaded.",
  "lessons.player.dataset.loading": "Loading {title}…",
  "lessons.player.dataset.locked": "{title} is not in your plan ({package}).",
  "lessons.player.dataset.none": "This step shows the Earth with no dataset.",
  "lessons.player.dataset.unavailable": "{title} is not in the app yet.",
  "lessons.player.download": "Download my lesson (.zip)",
  "lessons.player.downloaded": "Saved {filename}",
  "lessons.player.expand": "Open the lesson panel",
  "lessons.player.extraBack": "Back to this step's dataset",
  "lessons.player.extras": "More to show",
  "lessons.player.finish": "Finish",
  "lessons.player.forget": "Forget",
  "lessons.player.keep": "Keep this view for this step",
  "lessons.player.keepAgain": "Keep the view as it is now",
  "lessons.player.kept": "Kept in this browser: {what}",
  "lessons.player.kept.both": "the camera and the date",
  "lessons.player.kept.time": "the date",
  "lessons.player.kept.view": "the camera",
  "lessons.player.move": "Move the lesson panel (drag, or use the arrow keys)",
  "lessons.player.next": "Next step",
  "lessons.player.openData": "Read values",
  "lessons.player.overlayMissing": "{title} is not available here.",
  "lessons.player.overlayOff": "{title} taken off the globe.",
  "lessons.player.overlayOn": "{title} on the globe.",
  "lessons.player.overlays": "Overlay for this step:",
  "lessons.player.prev": "Previous",
  "lessons.player.prompt.caption": "Caption",
  "lessons.player.prompt.note": "Note",
  "lessons.player.prompt.question": "Question",
  "lessons.player.prompt.task": "Task",
  "lessons.player.rt.clear": "Take off what this step added",
  "lessons.player.rt.cleared": "This step’s variables are off the globe.",
  "lessons.player.rt.failed": "{title} could not be played over the dataset here.",
  "lessons.player.rt.label": "Add a variable, one at a time:",
  "lessons.player.rt.look": "Look for",
  "lessons.player.rt.moved": "Moved to {date}, the latest date the dataset and these variables share.",
  "lessons.player.rt.noDates": "{title} has no dates in common with this dataset, so it does not show.",
  "lessons.player.rt.off": "{title} taken off the globe.",
  "lessons.player.rt.on": "{title} plays over the dataset, on the same date.",
  "lessons.player.save": "Save to my account",
  "lessons.player.saveFailed": "It could not be saved. Download it instead.",
  "lessons.player.saveFull": "Your saved Khipus use all the space your account has. Delete one under My Khipus first.",
  "lessons.player.saveTooMany": "You keep 200 Khipus already. Delete one under My Khipus first.",
  "lessons.player.saveUnavailable": "Saving to your account is not available here yet. Download it instead.",
  "lessons.player.saved": "Saved to your account, kept until {date}.",
  "lessons.player.saving": "Saving…",
  "lessons.player.step": "Step {n} of {total}",
  "lessons.player.students": "For the students",
  "lessons.player.teacherNotes": "Teacher notes",
  "lessons.retry": "Try again",
  "lessons.search.aria": "Search the lessons",
  "lessons.search.placeholder": "Search titles, NGSS codes, datasets",
  "lessons.signIn": "Sign in",
  "lessons.start": "Start the lesson",
  "lessons.worksheet.dataset": "Dataset",
  "lessons.worksheet.date": "Date",
  "lessons.worksheet.name": "Name",
  "lessons.worksheet.print": "Print worksheet",
  "lessons.worksheet.printTeacher": "Print teacher copy",
  "lessons.worksheet.teacherTitle": "Teacher copy",
  "lessons.worksheet.title": "Worksheet",
  "lessons.worksheet.variables": "Add these over the dataset, one at a time",
  "lessons.worksheet.why": "Why this dataset",
  "loading.progress.aria": "Loading progress",
  "loading.status.initializing": "Initializing…",
  "loading.subtitle": "Pachamama Studios",
  "mapControls.fullscreen.enter": "Enter fullscreen",
  "mapControls.fullscreen.exit": "Exit fullscreen",
  "meeting.chip.audience": "Meeting {code} · watching · {count} here",
  "meeting.chip.driving": "Meeting {code} · you drive globe {n} · {count} here",
  "meeting.chip.moderator": "Meeting {code} · moderating · {count} here",
  "meeting.chip.presenter": "Meeting {code} · you present · {count} here",
  "meeting.chip.spotlight": "Meeting {code} · you have the globe · {count} here",
  "meeting.chip.waiting": "Meeting {code} · waiting for the presenter · {count} here",
  "meeting.driverMic.aria": "Your microphone in the meeting",
  "meeting.driverMic.consent": "Your microphone goes live to everyone in the meeting through Cloudflare Realtime, which relays it and keeps nothing. Nothing is recorded. It stops when you press Stop, give the globe back or leave.",
  "meeting.driverMic.denied": "The browser did not allow the microphone. Allow it in the address bar and try again.",
  "meeting.driverMic.failed": "The microphone could not go live. Try again.",
  "meeting.driverMic.live": "MIC LIVE",
  "meeting.driverMic.mute": "Mute",
  "meeting.driverMic.start": "Microphone on: everyone hears you",
  "meeting.driverMic.stop": "Stop",
  "meeting.driverMic.turnedOff": "Your microphone was turned off by the presenter or a moderator.",
  "meeting.driverMic.unmute": "Unmute",
  "meeting.drivers.audio.label": "Drivers speaking",
  "meeting.drivers.audio.listen": "Listen to the drivers",
  "meeting.drivers.audio.one": "Globe {n}",
  "meeting.drivers.audio.spot": "{name}, with the globe",
  "meeting.drivers.audio.spotSomeone": "The participant with the globe",
  "meeting.invite.audience.body": "You're invited to an AYNI XR meeting.\n\nOpen this link to join: {link}\n\nOr go to {site} and type the code {typed}.\n\nYou'll see the globe exactly as the presenter moves it, on a phone, a computer or a headset. The meeting runs until {time}.",
  "meeting.invite.audience.bodyOpen": "You're invited to an AYNI XR meeting.\n\nOpen this link to join: {link}\n\nOr go to {site} and type the code {typed}.\n\nYou'll see the globe exactly as the presenter moves it, on a phone, a computer or a headset.",
  "meeting.invite.audience.heading": "Invite participants",
  "meeting.invite.audience.note": "Anyone with this link can watch. They cannot change anything.",
  "meeting.invite.audience.subject": "Join my AYNI XR meeting ({code})",
  "meeting.invite.codeAria": "Code: {code}",
  "meeting.invite.codeLine": "Or go to {site} and type this code:",
  "meeting.invite.moderator.body": "You're the moderator of my AYNI XR meeting.\n\nOpen this link to take your seat: {link}\n\nPlease don't forward it: the link is your seat. The meeting runs until {time}.",
  "meeting.invite.moderator.bodyOpen": "You're the moderator of my AYNI XR meeting.\n\nOpen this link to take your seat: {link}\n\nPlease don't forward it: the link is your seat.",
  "meeting.invite.moderator.heading": "Invite a moderator",
  "meeting.invite.moderator.note": "This link is the moderator's seat. Send it only to your moderator.",
  "meeting.invite.moderator.subject": "Moderate my AYNI XR meeting ({code})",
  "meeting.live.badge": "Live",
  "meeting.live.camera.off": "Camera off",
  "meeting.live.camera.on": "Camera on",
  "meeting.live.devices": "Devices",
  "meeting.live.devices.camera": "Camera",
  "meeting.live.devices.mic": "Microphone",
  "meeting.live.devices.unnamed": "Device {n}",
  "meeting.live.error.denied": "The camera or microphone was blocked. Allow them for this site, then try again.",
  "meeting.live.error.device": "That camera or microphone could not be opened.",
  "meeting.live.error.unavailable": "Going live did not work. Try again in a moment.",
  "meeting.live.mic.mute": "Mute mic",
  "meeting.live.mic.unmute": "Unmute mic",
  "meeting.live.preview.aria": "Your camera, as everyone sees it",
  "meeting.live.quality.poor": "Your connection is struggling: people may lose your picture.",
  "meeting.live.quality.weak": "Your connection is weak: people may get a smaller picture.",
  "meeting.live.reconnecting": "Connection lost. Reconnecting…",
  "meeting.live.start": "Go live: camera and mic",
  "meeting.live.starting": "Starting your camera and mic…",
  "meeting.live.stop": "Stop",
  "meeting.over.close": "Close",
  "meeting.over.ended": "The meeting has ended.",
  "meeting.over.left": "You left the meeting.",
  "meeting.panel.close.aria": "Close",
  "meeting.panel.copied": "Copied",
  "meeting.panel.create": "Create meeting",
  "meeting.panel.creating": "Creating the meeting…",
  "meeting.panel.error.planCannotHost": "Your plan does not include hosting meetings. See the plans to add it.",
  "meeting.panel.error.unauthorized": "This browser is not allowed to host meetings.",
  "meeting.panel.error.unavailable": "The meeting could not be created. Try again in a moment.",
  "meeting.panel.intro": "A meeting is a session only you drive. Everyone else watches. You can send the invitations now, and again later from the meeting line at the top left.",
  "meeting.panel.lasts": "The meeting and its links last until {time}.",
  "meeting.panel.lendsData": "Everyone in this meeting can read values, drop their own pins, see the graph and measure with Line and Box on their own device, for as long as the meeting lasts. Nothing about them is kept.",
  "meeting.panel.present": "Start presenting",
  "meeting.panel.title": "Start a meeting",
  "meeting.presenter.hide": "Fold the presenter away",
  "meeting.presenter.label": "Presenter",
  "meeting.presenter.listen": "Tap to hear the presenter",
  "meeting.presenter.reconnecting": "Presenter · reconnecting…",
  "meeting.presenter.show": "Show the presenter",
  "meeting.presenter.showVideo": "Show video",
  "meeting.presenter.soundOnly": "Sound only",
  "meeting.presenter.soundOnlyLabel": "Presenter · sound only",
  "meeting.qr.audienceAria": "QR code of the participants' link",
  "meeting.qr.audienceCaption": "Scan to join with a phone. You can show it on the projector.",
  "meeting.qr.hide": "Hide QR code",
  "meeting.qr.moderatorAria": "QR code of the moderator's link",
  "meeting.qr.show": "Show QR code (only for your moderator)",
  "meeting.share.copy": "Copy link",
  "meeting.share.email": "Email",
  "meeting.share.gmail": "Gmail",
  "meeting.share.more": "Share…",
  "meeting.share.outlook": "Outlook",
  "meeting.share.roomTitle": "Invite people to this session",
  "meeting.share.title": "Invite people",
  "meeting.share.whatsapp": "WhatsApp",
  "myData.back.aria": "Back to My data",
  "myData.bytes.b": "{n} bytes",
  "myData.bytes.gb": "{n} GB",
  "myData.bytes.kb": "{n} kB",
  "myData.bytes.mb": "{n} MB",
  "myData.bytes.tb": "{n} TB",
  "myData.choices.badRange": "Give both ends of the range, the first lower than the second.",
  "myData.choices.badRegion": "Give the region as west, south, east and north in degrees, west lower than east and south lower than north.",
  "myData.choices.badTime": "The end of the time span must not be before its start.",
  "myData.choices.badTolerance": "Give the tolerance as a number above zero.",
  "myData.choices.east": "East (degrees)",
  "myData.choices.max": "Highest value",
  "myData.choices.min": "Lowest value",
  "myData.choices.north": "North (degrees)",
  "myData.choices.palette": "Palette",
  "myData.choices.range": "Value range",
  "myData.choices.rangeHint": "Filled in with the 0.1 and 99.9 percentiles of your data. Values outside the range are clipped to its ends; the review says what share was clipped.",
  "myData.choices.region": "Only part of the grid",
  "myData.choices.regionHint": "West, south, east, north, in degrees. Leave it off to keep the whole grid.",
  "myData.choices.regrid": "Regridding",
  "myData.choices.regridHint": "From your grid, about {from}, to the globe’s grid, about {to}. The review gives both exactly, and the difference it makes.",
  "myData.choices.regridHintUnknown": "To the globe’s grid, about {to}. The review gives both resolutions, and the difference it makes.",
  "myData.choices.sent": "Your choices were sent. Processing has started.",
  "myData.choices.south": "South (degrees)",
  "myData.choices.submit": "Process",
  "myData.choices.time": "Time span",
  "myData.choices.timeEnd": "End of the time span",
  "myData.choices.timeHint": "Times are UTC. Filled in with your file’s whole time axis.",
  "myData.choices.title": "Your choices",
  "myData.choices.tolerance": "Require an accuracy",
  "myData.choices.toleranceAbs": "Largest difference allowed",
  "myData.choices.toleranceHint": "For example 99 % of values within 0.1 m/s. The processor picks an encoding that meets it, or stops and says why; a release that misses it cannot be published.",
  "myData.choices.toleranceShare": "Share of values",
  "myData.choices.toleranceWithin": "within",
  "myData.choices.variable": "Variable",
  "myData.choices.west": "West (degrees)",
  "myData.count.one": "{count} dataset",
  "myData.count.other": "{count} datasets",
  "myData.custody": "Custody record",
  "myData.custody.aria": "Download the custody record of {title}",
  "myData.custody.saved": "The custody record was downloaded: the signed log of everything done with this dataset (hashes and actions, no data).",
  "myData.degrees": "{n}°",
  "myData.delete": "Delete",
  "myData.delete.aria": "Delete {title}",
  "myData.delete.cancel": "Keep it",
  "myData.delete.confirm": "Delete for good",
  "myData.delete.custody": "The custody record stays for 10 years: the hashes, the log of what was done, and the certificate that the key was destroyed. It holds no data.",
  "myData.delete.done": "Deleted. The dataset’s key was destroyed, so every copy of its files is unreadable; the files themselves are being removed.",
  "myData.delete.explain": "Deleting destroys this dataset’s encryption key. From that moment every copy of the original file, the stream and the exact values is unreadable, and the files are then removed. This cannot be undone.",
  "myData.delete.title": "Delete this dataset?",
  "myData.delete.typeTitle": "To confirm, type the dataset’s title",
  "myData.details": "Details",
  "myData.details.aria": "Details of {title}",
  "myData.empty": "No data yet. Upload a file to see it on the globe, private to you.",
  "myData.error.badChoices": "The processor did not accept these choices. Check the variable and the numbers.",
  "myData.error.budgetChanged": "The error budget in this release is not the one you reviewed, so it was not published.",
  "myData.error.custody": "The release’s custody record did not pass its checks, so it was not published. The processor has to write the release again.",
  "myData.error.generic": "Something went wrong. Try again.",
  "myData.error.intakeUnreachable": "The processor cannot be reached right now. Your choices were not sent; try again in a few minutes.",
  "myData.error.notConfigured": "Own data is not switched on on this site yet.",
  "myData.error.notEnabled": "This is not switched on yet.",
  "myData.error.notFound": "This dataset or job no longer exists.",
  "myData.error.notPublishable": "This release cannot be published: it has no error budget, or it misses the tolerance you set.",
  "myData.error.partsIncomplete": "Some parts of the file did not arrive. Resume the upload.",
  "myData.error.planRequired": "Your plan does not include own data.",
  "myData.error.quota": "Your storage is full. Delete a dataset first.",
  "myData.error.rateLimited": "Too many requests in the last hour. Wait a few minutes and try again.",
  "myData.error.releaseChanged": "The release changed after it was checked, so it was not published. The page shows where the job is now.",
  "myData.error.role": "Your role does not allow this. The lab’s owner can do it.",
  "myData.error.signedOut": "Sign in again to use your data.",
  "myData.error.sizeMismatch": "What arrived is not the size that was sent, so the upload was refused and destroyed. Upload the file again.",
  "myData.error.toleranceNotMet": "This release misses the tolerance you set, so it cannot be published.",
  "myData.error.toleranceNotYours": "The tolerance in this release is not the one you set, so it was not published.",
  "myData.error.tooLarge": "This file is larger than your plan’s largest file.",
  "myData.error.tooManyJobs": "Three files are already being processed. Wait for one to finish.",
  "myData.error.unreachable": "The site cannot be reached. Check the connection and try again.",
  "myData.error.wrongState": "The job moved on in the meantime. The page now shows where it is.",
  "myData.failure.generic": "Processing stopped ({code}).",
  "myData.failure.hashMismatch": "The file that arrived is not the file this browser sent (its SHA-256 fingerprint differs), so it was destroyed before anything opened it. Upload it again.",
  "myData.failure.toleranceUnreachable": "No encoding meets the tolerance you set. Upload again with a wider tolerance, or none.",
  "myData.failure.tooLarge": "The result would be larger than your plan allows.",
  "myData.failure.unreadable": "The file could not be read.",
  "myData.failure.unsupportedGrid": "This grid is not supported yet.",
  "myData.formats": "NetCDF, GeoTIFF or COG, Zarr (as a .zip), HDF5 or GRIB.",
  "myData.info.private": "Private data: shown only to its lab and the people it is shared with. The original file and the exact values are encrypted with this dataset’s own key; the stream you see (its video) is protected by access tokens only.",
  "myData.intro": "Your own files as private streams on the globe, with exact values kept and every error measured. Only you, and your lab on a Lab plan, can see them.",
  "myData.job.cancel": "Cancel this upload",
  "myData.job.cancelConfirm": "Cancel this upload? Its key is destroyed, so what was sent can never be read again, and it frees one of the three jobs that can be in progress at once.",
  "myData.job.cancelKeep": "Keep it",
  "myData.job.cancelYes": "Yes, cancel it",
  "myData.job.hashBrowser": "SHA-256 fingerprint from this browser: {hash}",
  "myData.job.hashMatch": "The file arrived unchanged: the processor’s SHA-256 fingerprint matches this browser’s ({hash}).",
  "myData.job.hashMismatch": "The processor’s SHA-256 fingerprint differs from this browser’s ({hash}).",
  "myData.job.loading": "Job",
  "myData.job.progressAria": "Processing progress",
  "myData.job.step": "Step: {step}, {percent} %",
  "myData.job.waiting": "Uploaded. Waiting for the processor to take it.",
  "myData.loading": "Loading…",
  "myData.locked.plan": "Bringing your own data comes with the Situation Room plans, and soon as an add-on to Researcher and Lab.",
  "myData.locked.signedOut": "Sign in to use your own data.",
  "myData.meeting.hint": "Everyone in the meeting you are presenting can view this dataset until the meeting ends or you stop. Each viewer's access is logged.",
  "myData.meeting.keep": "Not now",
  "myData.meeting.notLive": "That meeting is not running.",
  "myData.meeting.notPresenter": "Only the meeting's presenter can show a private dataset to it.",
  "myData.meeting.notShown": "The presenter is showing a private dataset that has not been shared with this meeting.",
  "myData.meeting.notice": "Everyone in this meeting, signed in or not, will see “{title}” until the meeting ends ({until}) or until you stop. Each person’s viewing is logged in the dataset’s custody record.",
  "myData.meeting.presenterHint": "The people in your meeting do not see this private dataset yet. To show it to them: My data → Share → Show to this meeting.",
  "myData.meeting.show": "Show to this meeting",
  "myData.meeting.shown": "Everyone in the meeting can now view this dataset.",
  "myData.meeting.stop": "Stop showing to the meeting",
  "myData.meeting.stopped": "The meeting no longer gets this dataset; anyone viewing it loses it within 10 minutes.",
  "myData.meeting.title": "In this meeting",
  "myData.meeting.yes": "Show it to the meeting",
  "myData.members.handedOn": "You handed on the owner's role. You are now a member.",
  "myData.members.intro": "Everyone who holds a seat of this lab's licence. Seats are added and released on the licence; here you choose what each person may do.",
  "myData.members.notHolder": "That person no longer holds a seat of this licence.",
  "myData.members.ownRole": "You cannot change your own role. To leave the owner's role, give it to someone else.",
  "myData.members.roleOf": "Role of {who}",
  "myData.members.save": "Save",
  "myData.members.saved": "Role saved.",
  "myData.members.seen": "Last seen with the licence {date}",
  "myData.members.title": "Lab members",
  "myData.members.you": "{who} (you)",
  "myData.open": "Open",
  "myData.open.aria": "Open {title} on the globe",
  "myData.open.failed": "This dataset could not be opened.",
  "myData.open.notReady": "This dataset is not published yet.",
  "myData.openPub.badConfirm": "Type the dataset's title exactly to confirm.",
  "myData.openPub.done": "The dataset is now open to everyone under CC BY 4.0.",
  "myData.openPub.isOpen": "Published openly under CC BY 4.0: anyone with its address can view and download this release. A later release stays private until you publish it openly again.",
  "myData.openPub.publish": "Publish openly",
  "myData.openPub.sourceFed": "A dataset fed by a continuous source cannot be published openly: its new releases are published by themselves.",
  "myData.openPub.title": "Publish openly (CC BY 4.0)",
  "myData.openPub.typeTitle": "Type the dataset's title to confirm",
  "myData.openPub.warning": "Publishing openly makes this dataset's current release public: anyone may view, download, copy and reuse it, crediting you. You can withdraw it later, but copies already taken cannot be called back.",
  "myData.openPub.withdraw": "Withdraw open publishing",
  "myData.openPub.withdrawn": "The dataset is private again; only the people you shared it with can view it.",
  "myData.plans": "See the plans",
  "myData.quota.aria": "Storage used",
  "myData.quota.largest": "Largest file: {size}.",
  "myData.quota.used": "{used} of {total} used",
  "myData.readOnly": "Your plan has lapsed: your data is read-only. Renew to upload again. Your data is deleted 30 days after the lapse, after two warnings.",
  "myData.regrid.bilinear": "Bilinear",
  "myData.regrid.conservative": "Conservative",
  "myData.regrid.nearest": "Nearest",
  "myData.report.axis": "{name}: {n} from {min} to {max}",
  "myData.report.cadence": "every {hours} h",
  "myData.report.col.name": "Variable",
  "myData.report.col.shape": "Dimensions",
  "myData.report.col.units": "Units",
  "myData.report.estimate": "Estimate",
  "myData.report.format": "Format",
  "myData.report.grid": "Grid",
  "myData.report.lat": "latitude",
  "myData.report.lon": "longitude",
  "myData.report.minutes": "about {n} min",
  "myData.report.steps.one": "{count} time step",
  "myData.report.steps.other": "{count} time steps",
  "myData.report.time": "Time",
  "myData.report.title": "What is in the file",
  "myData.report.variables": "Variables in the file",
  "myData.report.warnings": "Notes",
  "myData.retry": "Try again",
  "myData.review.blocked": "Publishing is off because this release misses your tolerance.",
  "myData.review.blockedNoBudget": "Publishing is off until the error budget has been measured.",
  "myData.review.intro": "Measured by decoding the stream and comparing it with your regridded data.",
  "myData.review.noBudget": "No error budget was reported for this release.",
  "myData.review.protection": "Once published, the stream is protected by access tokens only (the stream itself is not encrypted); your original file and exact values stay encrypted with this dataset’s key.",
  "myData.review.publish": "Publish",
  "myData.review.published": "Published. Open it on the globe from here or from My data.",
  "myData.review.title": "Review",
  "myData.role.member": "Member",
  "myData.role.memberHelp": "Uploads, views and shares their own datasets, adds continuous sources.",
  "myData.role.owner": "Owner",
  "myData.role.ownerHelp": "Everything a member does, plus roles, deleting and open publishing.",
  "myData.role.viewer": "Viewer",
  "myData.role.viewerHelp": "Views the lab's datasets only.",
  "myData.row.lab": "From your lab",
  "myData.row.mine": "Yours",
  "myData.row.open": "open (CC BY)",
  "myData.row.shares.one": "shared with {count}",
  "myData.row.shares.other": "shared with {count}",
  "myData.share": "Share",
  "myData.share.already": "This dataset is already shared with that address.",
  "myData.share.aria": "Share {title}",
  "myData.share.badEmail": "That is not an email address.",
  "myData.share.copied": "Link copied.",
  "myData.share.copy": "Copy",
  "myData.share.days.one": "{count} day",
  "myData.share.days.other": "{count} days",
  "myData.share.emailLabel": "Their email address",
  "myData.share.expired": "Ended",
  "myData.share.forHowLong": "For how long",
  "myData.share.intro": "People you share with can view this dataset in AYNI XR. Its exact values are not available to them, and they cannot change, share or delete it; like anything on a screen, what they see can still be captured. You can withdraw access at any time; it then ends within 10 minutes.",
  "myData.share.invite": "Send invitation",
  "myData.share.inviteHint": "They sign in to AYNI XR with this address (an account is made the first time) and find it under My data → Shared with me. No plan is needed to view.",
  "myData.share.inviteTitle": "Invite someone",
  "myData.share.invited": "Invitation sent to {email}.",
  "myData.share.invitedNoMail": "Invitation saved for {email}, but the email could not be sent: tell them to sign in with that address.",
  "myData.share.linkHint": "Anyone signed in who opens the link can view the dataset until it ends. At most 30 days.",
  "myData.share.linkMade": "Link made. Copy it now: it is shown only once.",
  "myData.share.linkName": "Link",
  "myData.share.linkOnce": "Shown only once. It works until {date} for anyone signed in who has it.",
  "myData.share.linkTitle": "Share by link",
  "myData.share.makeLink": "Make a link",
  "myData.share.noEmail": "Write the email address of the person to invite.",
  "myData.share.nobody": "Nobody else has access yet.",
  "myData.share.notSeen": "not opened yet",
  "myData.share.opened.one": "opened by {count} person",
  "myData.share.opened.other": "opened by {count} people",
  "myData.share.revoke": "Withdraw",
  "myData.share.revokeAria": "Withdraw access for {who}",
  "myData.share.revoked": "Withdrawn",
  "myData.share.revokedDone": "Access withdrawn. It ends within 10 minutes for anyone viewing now.",
  "myData.share.seen": "seen",
  "myData.share.self": "You already have this dataset.",
  "myData.share.someone": "Someone",
  "myData.share.title": "Share “{title}”",
  "myData.share.tooMany": "This dataset has as many active shares as it can have. Withdraw one first.",
  "myData.share.whoTitle": "Who has access",
  "myData.shared.accepted": "“{title}” was shared with you. It is under My data → Shared with me.",
  "myData.shared.askBody": "Shared by {who}, available until {date}.",
  "myData.shared.askNote": "If you open it, it is added to My data → Shared with me, and the person who shared it can see that an account opened the link.",
  "myData.shared.askTitle": "A dataset shared with you",
  "myData.shared.by": "from {who}",
  "myData.shared.chip": "Shared with you",
  "myData.shared.empty": "Nothing has been shared with you.",
  "myData.shared.linkEnded": "This share link has ended or was withdrawn.",
  "myData.shared.linkWrong": "This share link does not work. Ask for a new one.",
  "myData.shared.notNow": "Not now",
  "myData.shared.ok": "OK",
  "myData.shared.openIt": "Open it",
  "myData.shared.ownLab": "This dataset is in your own lab: you already have it under My data, so the link is not needed.",
  "myData.shared.readOnly": "You can view these datasets in AYNI XR. Their exact values are not available to you, and you cannot change, share or delete them.",
  "myData.shared.signInFirst": "Sign in to open the dataset shared with you.",
  "myData.shared.someoneUser": "an AYNI XR user",
  "myData.shared.title": "Shared with me",
  "myData.shared.until": "until {date}",
  "myData.shared.viaInvite": "invitation",
  "myData.shared.viaLink": "link",
  "myData.signIn": "Sign in",
  "myData.source": "Your own data",
  "myData.source.add": "Add source",
  "myData.source.addOpen": "Add a continuous source",
  "myData.source.addTitle": "Add a continuous source",
  "myData.source.added": "Source added. We are testing the key; this takes a few minutes.",
  "myData.source.addedQueued": "Source added. The processing server is busy; it will test the key as soon as it can.",
  "myData.source.alert.credentials": "The read-only key stopped working.",
  "myData.source.alert.drift": "A new release missed your tolerance. The last good release stays live.",
  "myData.source.alert.missed": "Expected new files did not arrive.",
  "myData.source.alert.quota": "Your storage is full: the source is paused.",
  "myData.source.alert.refused": "A release failed its checks and was not published.",
  "myData.source.alert.unreachable": "Your endpoint could not be reached.",
  "myData.source.alert.unreadable": "A new file could not be read.",
  "myData.source.alert.variableMissing": "The variable you chose is not in the files.",
  "myData.source.alert.writable": "The key can write to your bucket, so we refused it and deleted it. Give a read-only key.",
  "myData.source.archive": "whole archive",
  "myData.source.archiveLabel": "The whole archive",
  "myData.source.bad.bucket": "Check the bucket name: 3 to 63 lower-case letters, digits, dots or hyphens.",
  "myData.source.bad.choices": "Check the variable name.",
  "myData.source.bad.credentialsInUrl": "Leave the key out of the address; give it in the key fields.",
  "myData.source.bad.endpoint": "Check the endpoint: an https address such as https://s3.eu-central-1.amazonaws.com.",
  "myData.source.bad.https": "The endpoint must start with https://.",
  "myData.source.bad.internal": "That address is a private or internal one; we only read from public endpoints.",
  "myData.source.bad.keyId": "Check the access key id.",
  "myData.source.bad.path": "Give the endpoint only, without a bucket, path or query; the bucket goes in its own field.",
  "myData.source.bad.port": "That port is not allowed: use 443 or a port from 1024 up.",
  "myData.source.bad.prefix": "Check the prefix: no leading slash and no “..”.",
  "myData.source.bad.region": "Check the region, for example eu-central-1 or auto.",
  "myData.source.bad.schedule": "Check every how many minutes: at least 5, at most 1440.",
  "myData.source.bad.secret": "Check the secret key.",
  "myData.source.bad.title": "Give the source a name.",
  "myData.source.bad.window": "Check the number of recent frames to keep.",
  "myData.source.bucket": "Bucket",
  "myData.source.cancel": "Cancel",
  "myData.source.clear": "Clear alerts",
  "myData.source.cleared": "Alerts cleared.",
  "myData.source.delete": "Delete source",
  "myData.source.deleteAria": "Delete the source {title}",
  "myData.source.deleteConfirm": "Stop reading this bucket and delete the key we hold? The dataset and its releases stay until you delete them.",
  "myData.source.deleteKeep": "Keep it",
  "myData.source.deleteYes": "Delete source",
  "myData.source.deleted": "Source deleted: we no longer hold its key.",
  "myData.source.endpoint": "Endpoint (S3-compatible)",
  "myData.source.endpointHint": "Only the processing server reads it, through a proxy that refuses private addresses. This site never connects to it.",
  "myData.source.every": "every {n} min",
  "myData.source.frames": "Number of recent frames",
  "myData.source.full": "You have as many continuous sources as your plan allows.",
  "myData.source.intro": "Give a key that can only read this prefix. We test that it cannot write and refuse it if it can. The secret is encrypted at once and never shown again.",
  "myData.source.kept": "kept {release}",
  "myData.source.keyHint": "key …{hint}",
  "myData.source.keyId": "Access key id (read only)",
  "myData.source.lastGood": "Live release: {release}",
  "myData.source.lastPoll": "last checked {date}",
  "myData.source.minutes": "Minutes between checks",
  "myData.source.none": "No continuous sources yet.",
  "myData.source.notPolled": "not checked yet",
  "myData.source.notify": "on bucket notifications",
  "myData.source.notifyLabel": "When the bucket notifies us (where the storage offers it)",
  "myData.source.panelIntro": "A bucket that receives new files, such as a forecast every 6 hours, read on a schedule and published as each new release passes your tolerance.",
  "myData.source.pause": "Pause",
  "myData.source.paused": "Source paused.",
  "myData.source.pollEvery": "Check every (minutes, at least 5)",
  "myData.source.prefix": "Prefix",
  "myData.source.prefixHint": "Only files under this prefix are read. Leave it empty for the whole bucket.",
  "myData.source.quota": "{used} of {total} continuous sources in use",
  "myData.source.recent": "last {n} frames",
  "myData.source.recentLabel": "The most recent frames",
  "myData.source.region": "Region",
  "myData.source.resume": "Resume",
  "myData.source.resumed": "Source resumed: we test the key again first.",
  "myData.source.schedule": "When to look for new files",
  "myData.source.scheduleHint": "New files are processed within minutes of being found, not instantly.",
  "myData.source.secret": "Secret access key",
  "myData.source.secretHint": "Encrypted as soon as it arrives; nobody can read it back, you included.",
  "myData.source.state.active": "Running",
  "myData.source.state.broken": "Needs attention",
  "myData.source.state.paused": "Paused",
  "myData.source.state.refused": "Key refused",
  "myData.source.state.testing": "Testing the key",
  "myData.source.title": "Continuous sources",
  "myData.source.titleLabel": "Name",
  "myData.source.tolerance": "Tolerance: 99 % of values within (optional)",
  "myData.source.toleranceHint": "In the variable's units. A release that misses it is not published, and you get an alert.",
  "myData.source.variable": "Variable",
  "myData.source.variableHint": "Its name in the files, for example t2m.",
  "myData.source.window": "What to keep live",
  "myData.state.awaitingChoices": "Waiting for your choices",
  "myData.state.cancelled": "Cancelled",
  "myData.state.checking": "Checking the file",
  "myData.state.expired": "Upload expired",
  "myData.state.failed": "Failed",
  "myData.state.inspecting": "Reading the file",
  "myData.state.interrupted": "Upload interrupted: removed within 24 hours",
  "myData.state.pending": "Not published",
  "myData.state.processing": "Processing",
  "myData.state.published": "Published",
  "myData.state.review": "Ready for review",
  "myData.state.uploaded": "Waiting for the processor",
  "myData.state.uploading": "Uploading",
  "myData.step.checking": "Check",
  "myData.step.choices": "Choose",
  "myData.step.inspecting": "Inspect",
  "myData.step.processing": "Process",
  "myData.step.published": "Published",
  "myData.step.review": "Review",
  "myData.stepUp.action.accountDelete": "delete your account and everything kept for it",
  "myData.stepUp.action.delete": "delete a dataset",
  "myData.stepUp.action.export": "export exact values",
  "myData.stepUp.action.meeting": "show a private dataset to a meeting",
  "myData.stepUp.action.open": "publish a dataset openly",
  "myData.stepUp.action.ownerHandover": "hand on your lab’s owner role",
  "myData.stepUp.action.passkeyAdd": "add a passkey",
  "myData.stepUp.action.passkeyKeep": "cancel the removal of a passkey",
  "myData.stepUp.action.passkeyRemove": "remove a passkey",
  "myData.stepUp.action.role": "change someone's role",
  "myData.stepUp.action.share": "share a dataset",
  "myData.stepUp.action.source": "add a continuous source",
  "myData.stepUp.again": "Send a new code",
  "myData.stepUp.badFormat": "The code has eight digits.",
  "myData.stepUp.cancel": "Cancel",
  "myData.stepUp.codeLabel": "Eight-digit code",
  "myData.stepUp.confirm": "Confirm",
  "myData.stepUp.expired": "That code has expired or was tried too often. Send a new one.",
  "myData.stepUp.locked": "Too many wrong codes today: codes by email are locked for 24 hours, and we have emailed you.",
  "myData.stepUp.needed": "Confirm it is you first.",
  "myData.stepUp.noMail": "We could not send the code. Try again later.",
  "myData.stepUp.passkeyAgain": "Try again",
  "myData.stepUp.passkeyAsk": "Confirm with one of your passkeys. Your device will ask for your fingerprint, face or PIN.",
  "myData.stepUp.passkeyCancelled": "The passkey prompt was closed or timed out. Try again.",
  "myData.stepUp.passkeyUnavailable": "This browser cannot use a passkey here. Use a browser or device where your passkey is.",
  "myData.stepUp.preparing": "Getting ready…",
  "myData.stepUp.sent": "We sent a code to {to}. It works for 10 minutes, in this browser only.",
  "myData.stepUp.title": "Confirm it is you",
  "myData.stepUp.tooMany": "Too many codes asked for. Wait a while and try again.",
  "myData.stepUp.usePasskey": "Use my passkey",
  "myData.stepUp.whyAny": "To {action}, confirm it is you. Then you will not be asked again for 10 minutes in this browser.",
  "myData.stepUp.whyOnce": "To {action}, confirm it is you. This is asked every time, for this action only.",
  "myData.stepUp.wrong": "That code is not right.",
  "myData.stepUp.wrongPasskey": "That passkey was not accepted. Try again, or use another of your passkeys.",
  "myData.steps.aria": "Where the job is",
  "myData.untitled": "Untitled dataset",
  "myData.upload.cancel": "Cancel",
  "myData.upload.cancelled": "The upload was cancelled.",
  "myData.upload.cancelledLater": "The upload was cancelled. What was sent is unreadable without its key and is removed within 24 hours.",
  "myData.upload.cancelledShredded": "The upload was cancelled and its key destroyed: what was sent is unreadable and is being removed.",
  "myData.upload.completing": "All parts sent. Finishing…",
  "myData.upload.done": "Uploaded. The file is being checked.",
  "myData.upload.doneQueued": "Uploaded. The processor will take it as soon as it is free.",
  "myData.upload.empty": "This file is empty.",
  "myData.upload.file": "{name}, {size}",
  "myData.upload.fileLabel": "File",
  "myData.upload.intro": "The file is encrypted in this browser before any of it leaves, and sent in parts. Keep this page open until it is sent: a reload stops the upload.",
  "myData.upload.limit": "NetCDF, GeoTIFF or COG, Zarr (as a .zip), HDF5 or GRIB, up to {size}.",
  "myData.upload.nameLabel": "Title (optional)",
  "myData.upload.noFile": "Choose a file first.",
  "myData.upload.open": "Upload a file",
  "myData.upload.paused": "Paused.",
  "myData.upload.pausedWhy": "The upload paused: {why} Press Resume to carry on from where it stopped.",
  "myData.upload.privacy": "This browser encrypts the file with a key made for this dataset alone and computes its SHA-256 fingerprint; the processor checks it when the file arrives. Your original file and its exact values stay encrypted with that key. The stream made from it for the globe (its video) is not encrypted: it is protected by access tokens, so only you, your lab and the people you share it with can play it.",
  "myData.upload.progressAria": "Upload progress",
  "myData.upload.resume": "Resume",
  "myData.upload.sending": "Encrypting and sending: {percent} % (part {part} of {parts})",
  "myData.upload.start": "Encrypt and upload",
  "myData.upload.starting": "Starting…",
  "myData.upload.title": "Upload a file",
  "myData.upload.unknownType": "This kind of file cannot be read yet. Use NetCDF, GeoTIFF or COG, Zarr (as a .zip), HDF5 or GRIB.",
  "output.following": "Output window: following the controls in the other window",
  "output.sphere.aria": "The main globe as a flat 2:1 picture for a spherical display",
  "palette.dialog.classes": "{title} shows classes in their own colours, which don't change",
  "palette.dialog.clear": "Fully transparent",
  "palette.dialog.close": "Close",
  "palette.dialog.done": "Done",
  "palette.dialog.invert": "Invert",
  "palette.dialog.max": "Maximum",
  "palette.dialog.min": "Minimum",
  "palette.dialog.opaque": "Opaque",
  "palette.dialog.open": "Palette and limits of {title}",
  "palette.dialog.openFixed": "Transparency of {title}",
  "palette.dialog.picture": "{title} is a picture: its colours can't change",
  "palette.dialog.transparency": "Transparency",
  "passkeys.add": "Add a passkey",
  "passkeys.added": "added {date}",
  "passkeys.addedDone": "Passkey “{name}” added.",
  "passkeys.error.already": "This device already has a passkey for your account.",
  "passkeys.error.cancelled": "The passkey prompt was closed or timed out.",
  "passkeys.error.expired": "That took too long. Try again.",
  "passkeys.error.generic": "Something went wrong. Try again.",
  "passkeys.error.refused": "The passkey was not accepted. Try again.",
  "passkeys.error.signedOut": "Sign in first.",
  "passkeys.error.tooMany": "An account can have at most 10 passkeys. Remove one first.",
  "passkeys.intro": "Passkeys confirm risky actions on your own data: sharing, deleting, adding a continuous source, changing roles. With a passkey, AYNI XR no longer emails you confirmation codes. Adding or removing one needs a confirmation first, and we email you when it happens.",
  "passkeys.keep": "Cancel the removal",
  "passkeys.kept": "The removal is cancelled; the passkey stays.",
  "passkeys.lost": "Lost a passkey? Press “I lost it”: we email you a code, and the passkey is removed 72 hours later unless you cancel with a passkey. Every passkey you add is announced by email with a “this wasn’t me” link.",
  "passkeys.lostAria": "I lost the passkey {name}: remove it in 72 hours",
  "passkeys.lostButton": "I lost it",
  "passkeys.nameLabel": "Name for a new passkey",
  "passkeys.namePlaceholder": "For example: work laptop",
  "passkeys.none": "No passkeys yet: confirmations come by email.",
  "passkeys.pending": "Will be removed on {date} (asked for with an emailed code).",
  "passkeys.removalRequested": "The passkey will be removed on {date}. We have emailed you, and will again a day before.",
  "passkeys.remove": "Remove",
  "passkeys.removeAria": "Remove the passkey {name}",
  "passkeys.removed": "Passkey removed.",
  "passkeys.revoke.body": "This link comes from the email we sent when a passkey was added to your account. If you did not add it, remove it now: your account is also signed out everywhere, and this is recorded.",
  "passkeys.revoke.done": "Done: that passkey is removed and your account is signed out everywhere. Sign in again, and tell us at privacy@pachamama-studios.com.",
  "passkeys.revoke.ended": "That link has already been used or has expired.",
  "passkeys.revoke.go": "Remove it and sign out everywhere",
  "passkeys.revoke.keep": "Keep it",
  "passkeys.revoke.signIn": "Sign in again",
  "passkeys.revoke.title": "Remove a passkey you did not add",
  "passkeys.revoke.wrong": "That link does not work. Write to privacy@pachamama-studios.com.",
  "passkeys.synced": "synced to your other devices",
  "passkeys.title": "Passkeys",
  "passkeys.unsupported": "This browser cannot make passkeys.",
  "passkeys.unused": "not used yet",
  "passkeys.used": "last used {date}",
  "plans.locked.compare": "Comparing the dataset with another, in numbers and on the globe, comes with the Research and Situation Room plans.",
  "plans.locked.csv": "Downloading the data as CSV comes with the Education, Research and other plans.",
  "plans.locked.data": "Reading values off the data (pins and the graph, Measure, the value under the pointer) is part of AYNI XR plans, from Plus up.",
  "plans.locked.educationStream": "\"{title}\" is shown on the Education plans only (Teacher, School and District): its provider allows it for teaching. The plans below include it.",
  "plans.locked.figure": "A figure of the view for a paper, the methods paragraph and the reproducibility bundle come with the Research, Media and Situation Room plans.",
  "plans.locked.globes": "Four globes side by side come with the Research, Media and Situation Room plans. Education plans show two, for then-and-now comparisons.",
  "plans.locked.hovmoller": "Recording a line over time (a Hovmöller diagram) comes with the Research and Situation Room plans.",
  "plans.locked.lab": "Lab space, where the seats of one licence share views, pins, baselines and research records, comes with the Lab and Department plans (and Situation Room teams).",
  "plans.locked.lineBox": "Measuring along a line or inside a box comes with the Education, Research and other plans. Plus reads values and pins.",
  "plans.locked.ownData": "Bringing your own data (your files as private streams on the globe, with every error measured) comes with the Researcher and Lab plans.",
  "plans.locked.pins": "Plus places two pins. Six pins come with the Education, Research and other plans.",
  "plans.locked.regionSeries": "Following a region through time, and when its records were, comes with the Research and Situation Room plans.",
  "plans.locked.regionStats": "Statistics over a whole region (the dataset, a latitude band, a named region) come with the Research and Education plans. Draw a Box to measure an area.",
  "plans.locked.research": "Holding a frame as a baseline and reading other frames against it comes with the Research, Media and Situation Room plans.",
  "plans.locked.researchRecord": "Recording a research session (what you looked at, the numbers read and the files exported) comes with the Research and Situation Room plans.",
  "plans.locked.statistics": "Trends, time of emergence and correlation on the pins' series come with the Research and Situation Room plans.",
  "plans.locked.stream": "\"{title}\" is a live stream in the {package} package, which your plan does not include. The plans below add it.",
  "plans.locked.streamDaily": "Today’s streaming on your plan is used up ({cap} a day). It starts again at {time}; a stream that is already playing carries on.",
  "plans.locked.threshold": "Measuring the area over a threshold, frame by frame, comes with the Research and Situation Room plans.",
  "playback.announce.paused": "Playback paused",
  "playback.announce.started": "Playback started",
  "playback.captions.aria": "Toggle closed captions",
  "playback.captions.label": "Closed Captions",
  "playback.error.dateOutsideRange": "Date {date} is outside this dataset's range ({start} to {end})",
  "playback.error.invalidDate": "Invalid date format",
  "playback.error.invalidTimeRange": "Dataset has invalid time range",
  "playback.error.noTimeRange": "Dataset has no time range",
  "playback.error.noVideoDataset": "No video dataset loaded",
  "playback.error.videoNotReady": "Video not ready",
  "playback.fastForward.aria": "Fast-forward to end",
  "playback.modelYearDate": "Model year {year}, {date}",
  "playback.pause.aria": "Pause",
  "playback.play.aria": "Play",
  "playback.playPause.title": "Play / Pause",
  "playback.rewind.aria": "Rewind to start",
  "playback.scrubber.aria": "Playback position",
  "playback.seekingTo": "Seeking to {date}",
  "playback.stepBack.aria": "Step back one frame",
  "playback.stepForward.aria": "Step forward one frame",
  "playback.toolbar.aria": "Playback controls",
  "playback.unmute.aria": "Unmute audio",
  "pricing.box.buy.cancel": "A subscription bought online can be cancelled any time in Your plan → Manage subscription. A full refund or a chargeback ends the plan at once.",
  "pricing.box.buy.invoice": "Sign in at vr.ayni.eu.com, open **Plans and pricing** in the account menu, choose a plan and press **Request an invoice**. We send the invoice, and once it is paid, a licence key for your account. District and Department are priced on request.",
  "pricing.box.buy.online": "Online payment through Paddle, our reseller, is coming. Plus prices include VAT; for the other plans Paddle will add your country’s VAT (none for an EU business with a valid VAT number) and show the total before you pay.",
  "pricing.box.buy.title": "How buying works",
  "pricing.box.credits.body": "Media Desk comes with {desk} credits a year ({hours} hours of 1080p), Newsroom with {newsroom}. Unused credits roll over for {months} months, up to one year’s allowance. The app shows your balance in minutes of video.",
  "pricing.box.credits.hd": "A minute of 1080p video",
  "pricing.box.credits.n": "{n} credits",
  "pricing.box.credits.one": "1 credit",
  "pricing.box.credits.still": "A still",
  "pricing.box.credits.title": "Render credits",
  "pricing.box.credits.topUp": "Top-up, {n} credits (soon)",
  "pricing.box.credits.uhd4k": "A minute of 4K video",
  "pricing.box.credits.uhd8k": "A minute of 8K video",
  "pricing.box.eduResearch.education": "**Education** plans include every live data stream; there is nothing to add on. The research tools and contour lines are not shown in Education. Line, Box and region statistics are in the Tools tab; there is no separate Analyze button in the bar.",
  "pricing.box.eduResearch.ownData": "**Your own data** is coming soon, as an add-on: +€{rAcad} (academic) or +€{rCom} (commercial) on Researcher, +€{lAcad} or +€{lCom} on Lab. With it, Researcher costs €{rAcadTotal} or €{rComTotal} and Lab €{lAcadTotal} or €{lComTotal}.",
  "pricing.box.eduResearch.prices": "**Researcher** costs €{researcher} a year for academic use and €{researcherCom} for commercial use. **Lab**, for up to {labSeats} people, costs €{lab} (academic) or €{labCom} (commercial). Department is priced on request.",
  "pricing.box.eduResearch.students": "There is no student plan: a lab buys a seat for each student. Lab space is on Lab, Department and the Situation room plans.",
  "pricing.box.eduResearch.title": "Education and research",
  "pricing.box.plus.extremes": "**Highest and lowest**: two pins that find the hottest and coldest place, or the wettest and driest, and follow it as the data plays, on land, at sea or everywhere.",
  "pricing.box.plus.highlights": "**{n} climate highlights**, yearly records and projections chosen by us: global temperature since 1850, carbon dioxide and methane, sea ice, sea level, Köppen climate zones under low and high emissions, 50 years of weather-satellite views, and more.",
  "pricing.box.plus.live": "**Every real-time stream and forecast**: clouds, satellite views, rain, temperature, wind, lightning, sea temperature, fires and smoke, air quality, earthquakes, cyclones, the Sun, and more.",
  "pricing.box.plus.notRecord": "**Not the full climate record.** Every other yearly record, reanalysis and projection comes with the Education, Research, Media and Situation room plans.",
  "pricing.box.plus.title": "Plus: Live Earth",
  "pricing.box.plus.who": "For one person, for personal, non-commercial use.",
  "pricing.box.situation.body": "For civil protection and planning. **Every feature of the app**: all data, whole-region statistics, every research tool, lab space, lessons and class sessions, meeting games, your branding, and your own data once it is switched on. Render credits are on the Media plans.",
  "pricing.box.situation.title": "Situation rooms",
  "pricing.cell.askUs": "Ask us",
  "pricing.cell.everything": "Everything",
  "pricing.cell.hidden": "Not shown in Education",
  "pricing.cell.keptDays": "{n} days from the last save",
  "pricing.cell.keptLicence": "For the licence",
  "pricing.cell.no": "Not included",
  "pricing.cell.noLimit": "No limit",
  "pricing.cell.perDay": "{n} a day",
  "pricing.cell.perYear": "{n} a year",
  "pricing.cell.pins": "Pins",
  "pricing.cell.soon": "Soon",
  "pricing.cell.topUp": "{n} for €{eur}",
  "pricing.cell.upTo": "Up to {n}",
  "pricing.cell.upToPerDay": "Up to {n} a day",
  "pricing.cell.withIt": "€{amount} a year with it",
  "pricing.cell.yes": "Included",
  "pricing.chip.all": "Everyone",
  "pricing.chip.education": "Teaching",
  "pricing.chip.label": "Show plans for",
  "pricing.chip.media": "Media",
  "pricing.chip.public": "Just me",
  "pricing.chip.research": "Research",
  "pricing.chip.situation": "Situation rooms",
  "pricing.col.academic": "{name}, academic",
  "pricing.col.commercial": "{name}, commercial",
  "pricing.col.from": "from €{amount}",
  "pricing.col.perSeat": "€{amount} a person with all {n} seats used",
  "pricing.col.perYear": "/ year",
  "pricing.col.price": "€{amount}",
  "pricing.col.sub.allData": "all data",
  "pricing.col.sub.allStreams": "every live data stream",
  "pricing.col.sub.credits": "{n} render credits a year",
  "pricing.col.sub.free": "With a free account",
  "pricing.col.sub.monthly": "VAT included, or €{amount} a month",
  "pricing.col.sub.ownData": "all data; €{amount} with own data (soon)",
  "pricing.col.sub.situation": "for civil protection and planning",
  "pricing.col.yearSaves": "Paying by the year saves {pct}%",
  "pricing.contact": "Questions about plans or prices: [sales@pachamama-studios.com](mailto:sales@pachamama-studios.com).",
  "pricing.credits": "Render credits on top: {n} credits for €{eur}, online once online payment is on. Unused credits are kept for 12 months, up to a year’s allowance.",
  "pricing.cta.free": "Sign up free",
  "pricing.cta.invoice": "Request an invoice",
  "pricing.cta.quote": "Ask for a quote",
  "pricing.fact.invoice": "Paid by invoice today; online payment is coming",
  "pricing.fact.monthly": "Plus can also be paid monthly",
  "pricing.fact.vat": "Prices per year before VAT, except Plus (VAT included)",
  "pricing.group.data": "Data on the globe",
  "pricing.group.khipus": "Khipus and the chatbot",
  "pricing.group.media": "Branding and media",
  "pricing.group.research": "Research tools",
  "pricing.group.together": "Together",
  "pricing.group.view": "View tab",
  "pricing.headline": "Plans and prices, *from free to a whole situation room.*",
  "pricing.intro": "AYNI XR puts Earth's data on a globe you can turn, zoom and walk around, in the browser, in AR and in VR. {n} datasets from NOAA's Science On a Sphere catalogue are free with an account. The plans add live data streams, the values under your pointer, meetings, classes and research tools, each made for a kind of user.",
  "pricing.legal": "[Terms of use]({terms}) · [Refund policy]({refunds}) · [Privacy policy](/privacy)",
  "pricing.legend.hint": "Plans are grouped by who they are for, with the cheapest first in each group. Scroll sideways for the larger plans.",
  "pricing.legend.soon": "Not switched on yet",
  "pricing.otherLanguage": "[Versión en español](/pricing-es)",
  "pricing.pageTitle": "Plans and prices - AYNI XR",
  "pricing.row.activities.label": "Activities",
  "pricing.row.activities.note": "Explore, questions on the globe, hand over the globe",
  "pricing.row.anomalies.label": "Baselines and anomalies",
  "pricing.row.anomalies.note": "Against a climatology, e.g. \"2.1 °C above the 1991–2020 normal\"",
  "pricing.row.branding.label": "Your branding",
  "pricing.row.branding.note": "Logo, lower third and clean output on rendered videos and stills",
  "pricing.row.camera.label": "Camera and microphone, live",
  "pricing.row.camera.note": "In the meetings you host",
  "pricing.row.chatbot.label": "AYNI Chatbot",
  "pricing.row.chatbot.note": "Finds data, moves the globe, reads values; a question that uses tools can count more than once",
  "pricing.row.city.label": "City close-up",
  "pricing.row.city.note": "Street level over Barcelona and Rotterdam, with aerial photos and terrain; the rest of Catalonia and the Netherlands a step further out",
  "pricing.row.contours.label": "Contour lines",
  "pricing.row.contours.note": "Lines of equal value over a dataset",
  "pricing.row.credits.label": "Render credits",
  "pricing.row.credits.note": "Server renders of your videos and stills; unused credits roll over {months} months",
  "pricing.row.csv.label": "CSV downloads",
  "pricing.row.csv.note": "Take the numbers with you",
  "pricing.row.extremes.label": "Highest and lowest",
  "pricing.row.extremes.note": "Two pins that follow the extremes as the data plays, everywhere, on land or at sea, with their track",
  "pricing.row.figures.label": "Publication figures and methods",
  "pricing.row.figures.note": "PNG at 300 dpi and SVG, with a methods paragraph ready to paste",
  "pricing.row.games.label": "Meeting games",
  "pricing.row.games.note": "Trivia, Where on Earth?, team games",
  "pricing.row.globes.label": "Globes side by side",
  "pricing.row.globes.note": "Fewer on some devices",
  "pricing.row.highlights.label": "Climate highlights",
  "pricing.row.highlights.note": "{n} yearly records and projections, e.g. global temperature since 1850, CO₂ and methane, sea ice, sea level",
  "pricing.row.join.label": "Join rooms and meetings by link",
  "pricing.row.join.note": "No account needed; guests watch",
  "pricing.row.khipuKeep.label": "Keep your Khipus",
  "pricing.row.khipuKeep.note": "Saved on your account",
  "pricing.row.khipuPlay.label": "Open and play Khipus",
  "pricing.row.khipuPlay.note": "Guided stories, lessons and records",
  "pricing.row.labSpace.label": "Lab space",
  "pricing.row.labSpace.note": "Shared work for everyone on the licence",
  "pricing.row.layout.label": "Globe layout",
  "pricing.row.layout.note": "How several globes are arranged",
  "pricing.row.lend.label": "Lend data tools to the class",
  "pricing.row.lend.note": "Students use your tools during the class",
  "pricing.row.lessons.label": "Lessons and class sessions",
  "pricing.row.lessons.note": "A library of lessons, classes, students without accounts",
  "pricing.row.lineBox.label": "Line and Box",
  "pricing.row.lineBox.note": "Values along a line; values and statistics inside a box",
  "pricing.row.live.label": "Real-time streams and forecasts",
  "pricing.row.live.note": "Weather, satellite views, ocean, fire and smoke, air quality, earthquakes, cyclones, the Sun",
  "pricing.row.meetings.label": "Host online meetings",
  "pricing.row.meetings.note": "You lead, others follow; up to 8 hours each",
  "pricing.row.overlays.label": "Live overlays at once",
  "pricing.row.overlays.note": "Live layers over a dataset; {n} on phones, tablets and headsets",
  "pricing.row.ownData.label": "Your own data",
  "pricing.row.ownData.note": "Encrypted in your browser, shared with your lab",
  "pricing.row.palette.label": "Colour palette",
  "pricing.row.palette.note": "Palette, invert and limits for each dataset",
  "pricing.row.pins.label": "Pins with their graph",
  "pricing.row.pins.note": "Follow a place through time; the graph says when it was highest and lowest",
  "pricing.row.record.label": "The full climate record",
  "pricing.row.record.note": "Every yearly record, reanalysis and projection",
  "pricing.row.records.label": "Research records",
  "pricing.row.records.note": "Every step saved, with a reproducibility zip",
  "pricing.row.regionSeries.label": "Region through time",
  "pricing.row.regionSeries.note": "A region or a country, by its outline, frame by frame: its mean, highest and lowest, and when the records were",
  "pricing.row.regionStats.label": "Statistics over a whole region",
  "pricing.row.regionStats.note": "A dataset, a named zone or the view",
  "pricing.row.rooms.label": "Rooms with friends",
  "pricing.row.rooms.note": "One shared globe; the size comes from whoever opens the room",
  "pricing.row.sos.label": "NOAA's Science On a Sphere catalogue",
  "pricing.row.sos.note": "{n} datasets, free with an account",
  "pricing.row.streaming.label": "Daily streaming",
  "pricing.row.streaming.note": "Live streams, counted by the app in your browser",
  "pricing.row.threshold.label": "Threshold areas and Hovmöller diagrams",
  "pricing.row.threshold.note": "Where a value is crossed; change over time along a band",
  "pricing.row.topUp.label": "Credit top-up",
  "pricing.row.topUp.note": "{n} credits for €{eur}, bought online",
  "pricing.row.trends.label": "Comparisons and trend tests",
  "pricing.row.trends.note": "Two periods or datasets side by side; is the change significant?",
  "pricing.row.values.label": "Values under the pointer",
  "pricing.row.values.note": "On datasets that carry values",
  "pricing.row.viewBasics.label": "Layer transparency, sun glint, legend place",
  "pricing.row.viewBasics.note": "How each layer and the legend sit on the globe",
  "pricing.rung": "By group, then price",
  "pricing.title": "AYNI XR plans and prices",
  "privacy.announce.off": "Telemetry off. Pending events discarded.",
  "privacy.announce.set": "Telemetry set to {tier}.",
  "privacy.clearVisits.announce": "Visit history cleared.",
  "privacy.clearVisits.confirm": "Clear your local visit history? This empties Browse’s Recent tab and the recently-viewed history on this device. It can’t be undone.",
  "privacy.clearVisits.label": "Clear visit history",
  "privacy.clearVisits.labelCount": "Clear visit history ({count})",
  "privacy.close.aria": "Close privacy settings",
  "privacy.desc": "Choose how much the app reports back. Nothing is reported unless you allow it. You can change this at any time; the change takes effect immediately.",
  "privacy.localNote.visitMemory": "Visit memory (the datasets you’ve opened, used for Browse’s Recent tab and the “new since your last visit” badge) is off until you turn it on. It is stored only on this device — never sent to servers. Turning it off, or clearing site data, removes it.",
  "privacy.policyLink": "Read the full privacy policy →",
  "privacy.radiogroup.aria": "Telemetry tier",
  "privacy.session.hint": "In-memory only · resets on relaunch",
  "privacy.session.label": "Session ID",
  "privacy.tier.essential.desc": "Health and usage events, without your name or an account, so we can keep the app working. Off until you allow it.",
  "privacy.tier.essential.label": "Essential",
  "privacy.tier.off.desc": "No telemetry events are sent. The app works exactly the same.",
  "privacy.tier.off.label": "Off",
  "privacy.tier.research.desc": "Adds panel dwell times, Ayni Chatbot interaction timings, and sanitized stack frames, used to improve the docent and for research on how people explore Earth data. Opt-in.",
  "privacy.tier.research.label": "Research",
  "privacy.title": "Privacy",
  "privacy.visits.announce.off": "Visit memory is off, and what it kept is cleared.",
  "privacy.visits.announce.on": "Visit memory is on. Datasets you open are remembered on this device.",
  "privacy.visits.switch": "Remember the datasets I open, on this device",
  "probe.noData": "No data",
  "probe.roundingOnly": "{reading} (rounding only)",
  "probe.value": "{value} {units}",
  "probe.valueNoUnits": "{value}",
  "probe.valueWithError": "{value} ± {error} {units}",
  "probe.valueWithErrorNoUnits": "{value} ± {error}",
  "reference.aragonite1.label": "Ω = 1: below it, seawater dissolves shells and coral",
  "reference.aragonite1.note": "Below 1, seawater dissolves aragonite, the mineral of corals, pteropods and many shells. The planetary boundary for ocean acidification is set higher, at 80 % of the pre-industrial saturation.",
  "reference.aragonite1.short": "Ω = 1",
  "reference.hidden": "Reference lines hidden",
  "reference.legendAria": "Reference lines: {lines}",
  "reference.offAbove": "(above the graph)",
  "reference.offBelow": "(below the graph)",
  "reference.paris.note": "The Paris Agreement holds global average warming since 1850–1900 well below 2 °C and aims for 1.5 °C. Its limits apply to the world as a whole, not to one place: land and the Arctic warm faster than the average, so a place can pass a line long before the world does.",
  "reference.paris15.label": "1.5 °C: Paris Agreement goal (global average)",
  "reference.paris15.short": "Paris 1.5",
  "reference.paris2.label": "2 °C: Paris Agreement upper limit (global average)",
  "reference.paris2.short": "Paris 2",
  "reference.shown": "Reference lines shown",
  "reference.toggle": "Reference lines",
  "reference.toggleHint": "Boundaries such as the Paris Agreement's 1.5 °C, dashed on the pin graph and marked on the legend",
  "research.baseline.clear": "Clear baseline",
  "research.baseline.comparing": "Compared with the baseline held at {frame} ({region}). Each number shows its change from it.",
  "research.baseline.delta": "{value} vs baseline",
  "research.baseline.hold": "Hold as baseline",
  "research.baseline.holdInstead": "Hold this frame instead",
  "research.baseline.kind": "Baseline",
  "research.baseline.kindAria": "What the baseline is",
  "research.baseline.kindFrame": "One frame",
  "research.baseline.kindPeriod": "A period",
  "research.baseline.locked": "Comparing frames comes with the Research and Situation Room plans.",
  "research.baseline.noChange": "no change",
  "research.baseline.noFrame": "a frame without a date",
  "research.baseline.otherDataset": "The baseline is from {title}.",
  "research.baseline.otherRegion": "The baseline held at {frame} covers {region}. Choose that region, at the same view, to compare.",
  "research.baseline.otherUnits": "The baseline held at {frame} is in {units}, so it cannot be compared with this dataset.",
  "research.baseline.withinStep": "no change beyond the data’s resolution",
  "research.baseline.zonalCaption": "The dashed line is the baseline’s profile.",
  "research.baseline.zonalLargest": "Largest change by latitude",
  "research.bundle.failed": "The bundle could not be made. Try again, or download the parts one by one.",
  "research.bundle.nothing": "There is no dataset on the globe to put in a bundle.",
  "research.bundle.open": "Bundle (.zip)",
  "research.bundle.saved": "Saved {file}: {count} files, each with its SHA-256 in manifest.json. The bundle’s own SHA-256 (also in the research record when one is recording): {sha}",
  "research.bundle.working": "Making the bundle: the figure, every CSV, the citation, the link, the methods…",
  "research.change.aria": "Show the change from the baseline on the globe",
  "research.change.classified": "This dataset is made of classes (such as rain or snow), not amounts, so it has no change to draw.",
  "research.change.coloursAria": "Colours of the change map: palette, invert and range",
  "research.change.coloursTitle": "Colours of the change",
  "research.change.difference": "Change",
  "research.change.floorSteps": "two of the data's steps ({step} each): a baseline that small is mostly rounding",
  "research.change.floorTypical": "2 % of the baseline's typical size (its 95th percentile, {typical}): below it a percentage explodes",
  "research.change.frameOnly": "Drawn when playback stops, for that frame; it hides while playing. The colour range stays fixed, so a colour means the same amount in every frame. Choose While playing to see it move.",
  "research.change.grey": "Grey: data in only one of the two frames.",
  "research.change.greyPercent": "Grey: data in only one of the two frames, or a baseline too close to zero for a percentage.",
  "research.change.greyPeriod": "Grey: data in the frame or in the climatology, not both.",
  "research.change.greyPeriodPercent": "Grey: data in the frame or in the climatology, not both, or a mean too close to zero for a percentage.",
  "research.change.greySigma": "Grey: data in the frame or in the climatology, not both, or a cell with too few years for σ.",
  "research.change.label": "On the globe",
  "research.change.legendDifference": "Change from the baseline ({units})",
  "research.change.legendPercent": "Change from the baseline (%)",
  "research.change.legendSigma": "Standardised change from the baseline (σ)",
  "research.change.live": "While playing",
  "research.change.liveNote": "Drawn by the graphics card on every frame, while playing too. The colour range stays fixed, so a colour means the same amount in every frame.",
  "research.change.liveRefused": "This graphics card cannot draw the change while playing, so it is drawn when playback stops.",
  "research.change.masked": "Grey where the baseline is within ±{floor} of zero: {count} cells, {share} % of the map. The threshold is {rule}.",
  "research.change.nearZeroReading": "no % (baseline within ±{floor} of 0)",
  "research.change.off": "Off",
  "research.change.otherGrid": "The baseline is on another grid, so it cannot be drawn on the globe.",
  "research.change.otherUnits": "The baseline is in other units, so its change cannot be drawn.",
  "research.change.pause": "When paused",
  "research.change.percent": "% change",
  "research.change.percentInterval": "Read with care: a temperature in °C or °F has an arbitrary zero (10 °C to 20 °C is not twice as hot), so a percentage of it depends on the scale. Climate studies give its change in degrees, or in units of the baseline's year-to-year variation (σ).",
  "research.change.percentMisleads": "A quarter or more of this baseline is too close to zero for a percentage (dry ground, for rain), so much of the map is grey. Change shows every place.",
  "research.change.percentNegative": "Read with care: this field goes below zero (an anomaly or a change), so its zero is arbitrary and a percentage depends on where zero sits; it explodes where the baseline is near zero. Climate studies give such fields as a change in their units, or in units of the baseline's year-to-year variation (σ).",
  "research.change.range": "Colour range",
  "research.change.rangeAria": "The colour range of the change on the globe: its lowest and highest ends",
  "research.change.rangeAuto": "Automatic",
  "research.change.rangeInvalid": "The lowest end must be below 0 and the highest above 0, so no change stays white.",
  "research.change.rangeMaxAria": "Highest change, the darkest red, in {units}",
  "research.change.rangeMinAria": "Lowest change, the darkest blue, in {units}",
  "research.change.rangeOwn": "Your own range: each side runs to its own end, and a change beyond an end shows in its darkest colour. It goes back to automatic when you change the reading, the baseline or what you compare with.",
  "research.change.rangeTo": "to",
  "research.change.sigma": "σ change",
  "research.change.sigmaNote": "The colours span ±3σ, the same in every frame. For a roughly bell-shaped variable, beyond 2σ happens in about 1 year in 20 and beyond 3σ in about 1 in 400; with σ estimated from {years} years these are approximate.",
  "research.change.since": "baseline {frame}",
  "research.change.unavailable": "Hold the baseline again to draw it on the globe.",
  "research.change.update": "Update",
  "research.change.updateAria": "When the change on the globe is drawn",
  "research.compare.a": "A: {name}",
  "research.compare.aMinusB": "A − B",
  "research.compare.apart": "The two frames are not on the same date (A {a}, B {b}), so they are not compared. Move to a date both cover.",
  "research.compare.asShown": "As shown",
  "research.compare.b": "B: {name}",
  "research.compare.bias": "Bias (mean A − B)",
  "research.compare.byDate": "Same date",
  "research.compare.centred": "Centred RMS difference",
  "research.compare.classified": "One of the two is made of classes (zones, categories), not amounts, so there is nothing to subtract.",
  "research.compare.converted": "B is converted from {from} to {to} (× {factor}).",
  "research.compare.convertedOffset": "B is converted from {from} to {to} (× {factor}, then + {offset}).",
  "research.compare.datesUnknown": "One of the two has no dates, so it cannot be checked that both show the same moment.",
  "research.compare.delta": "{value} (A − B)",
  "research.compare.deltaPercent": "{value} ((A − B) / B)",
  "research.compare.floorSteps": "two of B's steps ({step} each): a value that small is mostly rounding",
  "research.compare.floorTypical": "2 % of B's typical size (its 95th percentile, {typical}): below it a percentage explodes",
  "research.compare.frames": "Frames",
  "research.compare.framesAria": "How the two frames are matched",
  "research.compare.globeAria": "Show the difference on the globe",
  "research.compare.globeName": "Globe {n}: {name}",
  "research.compare.grey": "Grey: data in only one of the two.",
  "research.compare.greyPercent": "Grey: data in only one of the two, or B too close to zero for a percentage.",
  "research.compare.lead": "The dataset on the globe (A) minus a real-time overlay (B), place by place, on the same date: a model against observations, one scenario against another, a forecast against what happened.",
  "research.compare.leadGlobe": "The main globe (A) minus another globe on screen (B), place by place: one scenario against another, a model against a reanalysis. The same region is read on both, and the difference is drawn on the main globe.",
  "research.compare.legend": "A − B ({units})",
  "research.compare.legendPercent": "(A − B) / B (%)",
  "research.compare.limits": "Limits: a difference smaller than the rounding above is not real. No significance test is made for the difference of two whole maps: neighbouring places are not independent, so a place-by-place test would mislead. While playing, the two frames are taken as they are on screen.",
  "research.compare.liveNote": "Drawn by the graphics card on every frame, while playing too, from the two frames on screen as they are (the dates above are checked when playback stops). The same grid, sums and colours as the paused picture; the colour range stays fixed for this pair.",
  "research.compare.liveRefused": "This graphics card cannot draw the difference while playing, so it is drawn when playback stops.",
  "research.compare.locked": "Comparing datasets comes with the Research and Situation Room plans.",
  "research.compare.meanA": "Mean of A",
  "research.compare.meanB": "Mean of B",
  "research.compare.method": "Both are averaged onto the grid of the coarser one (a cell counts where at least half of it has data), so detail only the finer one resolves does not show as difference. Every statistic is weighted by cell area. The centred RMS difference is what remains once the bias is removed (Taylor 2001); the pattern correlation compares the two maps' shapes.",
  "research.compare.moveB": "Show globe {n} at {date}",
  "research.compare.noGlobes": "Show 2 or 4 globes (the globe layout in Tools) and load a dataset that carries values on another globe to compare it with this one.",
  "research.compare.noOverlap": "The two have no data in the same places.",
  "research.compare.noPercent": "No % of B here: {why}",
  "research.compare.none": "Add a real-time overlay that carries values (Tools → Layers → Real time) to compare the dataset with it.",
  "research.compare.onGlobe": "The comparison is on the globe (Compare tab). Choose a change here to show the baseline's instead.",
  "research.compare.over": "Over {area} where both have data ({share} % of the places either has), on a common grid of {deg}° cells.",
  "research.compare.overRegion": "Region: {region}. The map covers everything; the numbers cover the region.",
  "research.compare.overlayHidden": "The overlay is hidden while its difference is shown.",
  "research.compare.paired": "Same date: A {a}, B {b}.",
  "research.compare.percentOfB": "% of B",
  "research.compare.percentRule": "% of B is (A − B) ÷ |B| × 100. Grey where B is within ±{floor} of zero: {count} cells, {share} % of the map. The threshold is {rule}.",
  "research.compare.pick": "Overlay to compare with",
  "research.compare.pickGlobe": "Globe to compare with",
  "research.compare.primaryName": "{name} (the main globe)",
  "research.compare.primaryNote": "A is always the main globe, the one Analyze reads. To make another globe A, tap its number in its top-left corner, then open Analyze again.",
  "research.compare.r": "Pattern correlation",
  "research.compare.ratio.change": "one of the two is a change or an anomaly, whose zero means no change, not none.",
  "research.compare.ratio.classified": "classes are not amounts.",
  "research.compare.ratio.interval": "a temperature in °C or °F has an arbitrary zero (10 °C to 20 °C is not twice as warm).",
  "research.compare.ratio.negative": "one of the two goes below zero, so its zero does not mean none.",
  "research.compare.ratio.temperature": "a temperature difference is given in degrees, not as a percentage.",
  "research.compare.relativeBias": "Bias as % of B's mean",
  "research.compare.resolution": "Differences under {step} are rounding in the data.",
  "research.compare.resolutionUneven": "One of the two is on a log scale, so its rounding is not one fixed amount.",
  "research.compare.rmsd": "RMS difference",
  "research.compare.shown": "Frames as shown, dates not matched: A {a}, B {b}.",
  "research.compare.sidesNote": "Weighted by area, B in A's units. Each is read over its own places with data at its own resolution (A {areaA}, B {areaB}), so the two may cover slightly different places; the statistics below use one common grid.",
  "research.compare.sidesTitle": "{region}, side by side",
  "research.compare.source": "Compare with",
  "research.compare.sourceAria": "What to compare the dataset with",
  "research.compare.sourceGlobe": "Another globe",
  "research.compare.sourceOverlay": "A real-time overlay",
  "research.compare.stat.mean": "Mean",
  "research.compare.stat.median": "Median",
  "research.compare.stat.p10": "10th percentile",
  "research.compare.stat.p90": "90th percentile",
  "research.compare.statistic": "Statistic",
  "research.compare.title": "Compare with the overlay",
  "research.compare.units": "These are in different units ({a} and {b}) with no known conversion between them, so they cannot be subtracted.",
  "research.compare.waiting": "Waiting for the overlay's frame.",
  "research.compare.warnChange": "Read with care: one is a change or anomaly and the other a value, so their difference mixes two kinds of number.",
  "research.compare.warnSubject": "Read with care: the two titles name different things. Being in the same units does not make them the same quantity, and their difference may mean nothing.",
  "research.compare.whenPaused": "Drawn for the frame on screen; it hides while playing and is drawn again when playback stops. The colour range stays fixed for this pair.",
  "research.correlation.button": "Correlation",
  "research.correlation.cycle": "Caution: values less than a year apart share seasonal or daily cycles, which make r larger.",
  "research.correlation.detrended": "Without their trends: r = {r} ({p}). Two series that both rise correlate for that reason alone; this says whether they also vary together.",
  "research.correlation.lag": "Strongest {lag} {unit} later in {who}: r = {r} ({p}, corrected for trying {tried} lags).",
  "research.correlation.method": "Significance uses the effective number of independent values of two persistent series (Bretherton et al. 1999). Correlation does not show cause.",
  "research.correlation.off": "Correlations hidden.",
  "research.correlation.on": "Correlations shown.",
  "research.correlation.pair": "{a} and {b}",
  "research.correlation.raw": "Pearson r = {r} ({p}); Spearman ρ = {rho}; about {neff} independent values.",
  "research.correlation.region": "Correlation between pins",
  "research.correlation.step": "step",
  "research.correlation.steps": "steps",
  "research.correlation.year": "year",
  "research.correlation.years": "years",
  "research.emergence.above": "Emerged in {year}: from then on, the {window}-year mean stays more than {k} σ above the baseline.",
  "research.emergence.below": "Emerged in {year}: from then on, the {window}-year mean stays more than {k} σ below the baseline.",
  "research.emergence.button": "Emergence",
  "research.emergence.endAria": "Last year of the baseline period",
  "research.emergence.ensemble": "This dataset is a multi-model mean or median, which varies far less from year to year than any real climate. Measured against its own variability, emergence comes far too early. Enter σ from observations or from a single model run.",
  "research.emergence.method": "Time of emergence (Hawkins & Sutton 2012): the first year after which the centred running mean stays beyond k standard deviations of natural variability until the last year it can be computed (half a window before the end). It uses later years, so it describes the past, not the present.",
  "research.emergence.noBaseline": "Fewer than 20 values in {start}–{end}: choose a longer baseline period.",
  "research.emergence.noise": "Natural variability (σ, {units}), if known",
  "research.emergence.noiseAria": "Natural variability as a standard deviation, from observations or one model run; empty to measure it from the baseline period",
  "research.emergence.noiseAuto": "from the baseline",
  "research.emergence.noiseBaseline": "σ = {sigma}: the year-to-year variability of {start}–{end} with its trend removed ({n} values).",
  "research.emergence.noiseGiven": "σ = {sigma}, as entered; baseline mean from {start}–{end} ({n} values).",
  "research.emergence.noiseQuantum": "σ = {sigma}: one step of the data, since the variability of {start}–{end} is smaller than the data can resolve.",
  "research.emergence.not": "Not emerged by {end}: the {window}-year mean does not stay more than {k} σ from the baseline.",
  "research.emergence.off": "Time of emergence hidden.",
  "research.emergence.on": "Time of emergence shown.",
  "research.emergence.period": "Baseline period",
  "research.emergence.region": "Time of emergence",
  "research.emergence.short": "Needs at least 30 years of values.",
  "research.emergence.startAria": "First year of the baseline period",
  "research.emergence.subAnnual": "Needs yearly values: these are closer together, so a seasonal cycle would count as noise.",
  "research.emergence.to": "to",
  "research.figure.double": "Two columns ({mm} mm, {px} px wide)",
  "research.figure.drawing": "Drawing the figure…",
  "research.figure.flat": "Equal Earth map of the whole frame",
  "research.figure.globe": "The globe, as shown",
  "research.figure.locked": "A figure of the view, the methods paragraph and the reproducibility bundle come with the Research and Situation Room plans.",
  "research.figure.map": "Map",
  "research.figure.meta": "{w} × {h} px at {dpi} dpi, {mm} mm wide; the map is {mw} × {mh} px.",
  "research.figure.metaEnlarged": "This screen could render the globe at only {w} × {h} px, so the map is enlarged from that; the file says so.",
  "research.figure.metaGrid": "The data frame is {w} × {h} grid cells.",
  "research.figure.noFrame": "This dataset has no values to draw on a flat map.",
  "research.figure.noGlobe": "The globe could not be captured here. Try the Equal Earth map.",
  "research.figure.noPins": "Pins (none placed)",
  "research.figure.note": "The map is a picture (raster) in both files; in the SVG the title, colour bar, pins and caption are text and shapes you can edit. The PNG opens at its printed size (300 dpi) and carries its caption. The figure is in English, like the citation in its caption.",
  "research.figure.open": "Figure",
  "research.figure.paused": "Playback is paused, so the figure and the methods describe one frame.",
  "research.figure.pins": "Pins, with their names",
  "research.figure.png": "Download PNG",
  "research.figure.previewAria": "Preview of the figure: {title}",
  "research.figure.saved": "Saved {file}",
  "research.figure.single": "One column ({mm} mm, {px} px wide)",
  "research.figure.size": "Size, at 300 dpi",
  "research.figure.svg": "Download SVG",
  "research.figure.tab.figure": "Figure",
  "research.figure.tab.methods": "Methods",
  "research.figure.tabs": "Figure or methods",
  "research.figure.title": "Figure and methods",
  "research.figure.titleLabel": "Title",
  "research.hov.aria": "Distance along the line runs across, time runs downward. Arrow keys move through the cells; Enter plays from that row’s frame.",
  "research.hov.barAria": "Colours from {min} to {max}",
  "research.hov.change": "Change from baseline",
  "research.hov.changeNote": "Change from the baseline held at {frame}: now minus the baseline at each point, in {units}. The colours run from −{limit} to +{limit}, set from the frames recorded when you chose it, so a colour means the same amount in every row.",
  "research.hov.changeWaiting": "No change to show yet: no point has both a value and the baseline’s.",
  "research.hov.csv": "Download the diagram as CSV",
  "research.hov.distanceAxis": "Distance along the line",
  "research.hov.from": "Start: {where}",
  "research.hov.lead": "Each frame the dataset plays becomes a row along this line, the way pins fill their graph. Play the dataset; click a row to go to its frame.",
  "research.hov.limits": "One point every {spacing} along the line (one per grid cell crossed, as in the profile above), so anything narrower is not resolved. Values are rounded: one step is {step}. Frames that play too fast to be read stay empty until the next lap.",
  "research.hov.limitsUneven": "One point every {spacing} along the line (one per grid cell crossed, as in the profile above), so anything narrower is not resolved. Values are rounded on an uneven scale, so the step depends on the value. Frames that play too fast to be read stay empty until the next lap.",
  "research.hov.locked": "Recording a line over time comes with the Research and Situation Room plans.",
  "research.hov.noData": "No data",
  "research.hov.noLine": "Draw a line, then play the dataset: each frame becomes a row of a distance × time diagram (a Hovmöller diagram).",
  "research.hov.notRead": "Not played yet",
  "research.hov.periodChangeNote": "Each row against the {span} climatology of its own frame’s month (or month and hours): now minus that mean at each point, in {units}. The colours run from −{limit} to +{limit}, set from the rows recorded when you chose it.",
  "research.hov.periodHours": "Data a few hours apart: each row is compared with the same month at the same UTC hours, so the daily cycle is not read as change.",
  "research.hov.periodThinned": "The climatology keeps one texel in {factor} each way, so each point is compared with the average of its cell.",
  "research.hov.png": "Download the diagram as PNG",
  "research.hov.progress": "{read} of {total} frames recorded.",
  "research.hov.progressShared": "{read} of {total} rows recorded. The window’s {frames} frames share them; each row keeps the newest frame read.",
  "research.hov.readout.cell": "{distance} along · {time} · {value}",
  "research.hov.readout.noData": "{distance} along · {time} · no data",
  "research.hov.readout.unread": "{distance} along · {time} · not played yet",
  "research.hov.readoutHint": "Point at the diagram to read a value; click a row to go to its frame.",
  "research.hov.restart": "Start again",
  "research.hov.roledescription": "Hovmöller diagram",
  "research.hov.seeked": "Playback moved to {time}.",
  "research.hov.showAria": "Show the values or their change from the baseline",
  "research.hov.sigma": "σ change",
  "research.hov.sigmaNote": "Each row against the {span} climatology of its own frame’s month (or month and hours): (value − that mean) ÷ its σ. The colours run from −3σ to +3σ.",
  "research.hov.still": "This dataset has a single frame, so there is no time to record. The line’s profile above shows it.",
  "research.hov.timeDown": "Time runs downward, first frame at the top, as in Hovmöller’s diagrams (1949).",
  "research.hov.title": "Line over time (Hovmöller)",
  "research.hov.to": "End: {where}",
  "research.hov.values": "Values",
  "research.hov.waiting": "Waiting for a frame to read.",
  "research.hov.when.along": "{distance} along the line ({where})",
  "research.hov.when.shared": "This stream has more frames than the diagram has rows, so a row holds the last frame read into it: another frame may hold a higher or lower value.",
  "research.hov.when.title": "Highest and lowest on the line, and when",
  "research.lab.baselineDefaultFrame": "Baseline: the frame {frame}",
  "research.lab.baselineDefaultPeriod": "Baseline: the period {span}",
  "research.lab.baselineFrame": "{title}: one frame, {frame}, over {region}",
  "research.lab.baselineHeld": "The frame {frame} is held as your baseline, measured again from the data on your screen.",
  "research.lab.baselineHeldUnsure": "A frame is held as your baseline, but the frame {frame} could not be confirmed on screen: check the date under Analyze.",
  "research.lab.baselineOpened": "Analyze is open on Baseline with the shared region; this dataset cannot be held or read as shared, so check it there.",
  "research.lab.baselinePeriod": "{title}: the period {span} ({grouping}), over {region}",
  "research.lab.baselineReading": "Reading the period {span} from the data: play it through, or press Read the missing frames in Analyze. The climatology is computed again in your browser.",
  "research.lab.by": "Shared by {name}",
  "research.lab.byFormer": "Shared by a former member",
  "research.lab.byMember": "Shared by a lab member",
  "research.lab.byYou": "Shared by you",
  "research.lab.cancel": "Cancel",
  "research.lab.cannotOpen": "“{title}” could not be opened: its dataset is not available here.",
  "research.lab.close": "Close Lab space",
  "research.lab.copied": "a copy",
  "research.lab.copiedOk": "“{title}” is copied as yours: it stays if its author deletes theirs or leaves the lab.",
  "research.lab.copy": "Copy as mine",
  "research.lab.copyLink": "Copy link",
  "research.lab.count": "{n} of {max} items",
  "research.lab.delete": "Delete",
  "research.lab.deleteConfirm": "Delete? Press again",
  "research.lab.deleted": "Deleted from the lab.",
  "research.lab.edit": "Edit",
  "research.lab.editedOk": "Saved.",
  "research.lab.empty": "Nothing has been shared in this lab yet.",
  "research.lab.error.forbidden": "Only its author or the lab’s owner can do that.",
  "research.lab.error.full": "This lab’s space is full (64 MB). Delete some records first.",
  "research.lab.error.invalid": "That cannot be shared as it is: check the title.",
  "research.lab.error.nameMismatch": "This record has a name on it that is not yours, so it can only be shared without names.",
  "research.lab.error.notFound": "That is no longer in this lab.",
  "research.lab.error.notResearch": "That saved record cannot be shared: it is not a research record AYNI XR can open.",
  "research.lab.error.plan": "Your licence has no Lab space, or your seat is no longer part of this lab.",
  "research.lab.error.rateLimited": "Too many changes this hour. Try again in a few minutes.",
  "research.lab.error.readOnly": "Your licence has ended: nothing new can be shared.",
  "research.lab.error.signedOut": "Sign in to use Lab space.",
  "research.lab.error.tooLarge": "Too large to share: a research record may be up to 2 MB with its CSVs.",
  "research.lab.error.tooMany": "This lab holds the most it may (500 items). Delete some first.",
  "research.lab.error.unavailable": "Lab space is not available right now. Try again later.",
  "research.lab.giveUp": "Give up being the owner",
  "research.lab.giveUpConfirm": "Give it up? Press again",
  "research.lab.intro": "Everything here is kept on AYNI’s server for everyone who holds a seat of your lab’s licence, with the name of whoever shared it. It is kept while the licence runs and 30 days after, then deleted.",
  "research.lab.joined": "Joined {date}",
  "research.lab.kind.baseline": "Baseline",
  "research.lab.kind.pins": "Pins",
  "research.lab.kind.record": "Record",
  "research.lab.kind.view": "View",
  "research.lab.linkCopied": "Link copied.",
  "research.lab.linkNotCopied": "The link could not be copied.",
  "research.lab.loading": "Loading…",
  "research.lab.locked": "Lab space comes with the Lab and Department plans: the seats of one licence share their work.",
  "research.lab.makeOwner": "Make owner",
  "research.lab.makeOwnerConfirm": "Make owner? Press again",
  "research.lab.members": "Members holding a seat ({n})",
  "research.lab.membersNote": "Only you see this list. Anyone with your licence key can take a seat; if someone here should not be, free their seat in your licence.",
  "research.lab.nameConfirm": "This record has your name on every entry. Share it without names (the others see what you did, not who), or with your name on it? With your name, the lab sees it while you hold a seat; copies others make carry no name.",
  "research.lab.nameConfirmAsk": "Choose: share without names, or with your name.",
  "research.lab.newMembers": "New members since you last looked: {n}. Open Lab space to see who joined.",
  "research.lab.newTag": "new",
  "research.lab.noFrame": "a frame without a date",
  "research.lab.noName": "(no name on the account)",
  "research.lab.noRecords": "No saved research records",
  "research.lab.noteLabel": "Note (optional)",
  "research.lab.open": "Open",
  "research.lab.openPanel": "Open Lab space",
  "research.lab.openedView": "“{title}” is open.",
  "research.lab.opening": "Opening “{title}”…",
  "research.lab.owner": "You look after this lab space (the first seat still held): you can delete anything in it.",
  "research.lab.ownerHanded": "Someone else looks after this lab space now.",
  "research.lab.ownerTag": "owner",
  "research.lab.pinsDefault": "Pins on {title}",
  "research.lab.pinsOn": "On {title}: {places}",
  "research.lab.placedPins": "Pins placed: {n}, in place of the pins you had.",
  "research.lab.readOnly": "Your licence has ended. You can open, download and delete what is here until {date}; nothing new can be shared.",
  "research.lab.recordLabel": "A research record saved to your account",
  "research.lab.recordSize": "A research record, {kb} KB with its CSVs",
  "research.lab.save": "Save",
  "research.lab.shareBaseline": "Share the baseline",
  "research.lab.sharePins": "Share these pins",
  "research.lab.shareRecord": "Share the record",
  "research.lab.shareView": "Share this view",
  "research.lab.shareWithName": "Share with my name",
  "research.lab.shareWithoutNames": "Share without names",
  "research.lab.shared": "Shared in this lab",
  "research.lab.sharedNamed": "“{title}” is shared with your lab, with your name on it.",
  "research.lab.sharedOk": "“{title}” is shared with your lab.",
  "research.lab.title": "Lab space",
  "research.lab.titleLabel": "Title",
  "research.lab.titlePlaceholder": "Optional: a title is made from what you share",
  "research.lab.toolsNote": "Share views, pins, baselines and research records with everyone who holds a seat of your lab’s licence, and open what they shared.",
  "research.lab.withName": "with the author’s name",
  "research.lab.you": "you",
  "research.methods.copied": "Methods copied",
  "research.methods.copy": "Copy",
  "research.methods.download": "Download",
  "research.methods.label": "Methods paragraph and references",
  "research.methods.none": "Load a dataset to describe what was done.",
  "research.methods.note": "Written from what AYNI XR did in this session: what is measured, held and switched on now, never what it assumes. A figure is described once you have downloaded one. In English, like the citation.",
  "research.methods.open": "Methods",
  "research.period.anomalyCaption": "Place by place, where both the frame and the climatology have data, each place against the mean of its own month. A frame's extremes and percentiles are not compared with a field of means.",
  "research.period.anomalyTitle": "Against the {span} climatology ({group})",
  "research.period.anomalyTitlePlain": "Against the {span} climatology",
  "research.period.beyond2": "Area beyond ±2σ",
  "research.period.compared": "Compared over",
  "research.period.comparingAnnual": "Compared with the mean of {span} ({read} of {total} frames read).",
  "research.period.comparingMonthly": "Compared with the {span} climatology ({read} of {total} frames read): each frame against the mean of its own calendar month.",
  "research.period.comparingWindow": "Compared with the mean of the window, {span} ({read} of {total} frames read).",
  "research.period.floored": "In {count} cells ({share} % of those with σ) σ was raised to one step of the data: there the spread is below what the data’s steps resolve, so σ change understates how unusual a value is.",
  "research.period.frames": "{total} frames to read.",
  "research.period.from": "From",
  "research.period.heldInstead": "The baseline now is the period {span}. Holding a frame replaces it.",
  "research.period.howAnnual": "Each frame is compared with the mean of {span}. σ is the spread of the values from year to year.",
  "research.period.howDaily": "Each frame is compared with the mean of its calendar month over {span}. σ is the spread of that month's daily values across the period, day to day and year to year, about the trend.",
  "research.period.howMonthly": "Each frame is compared with the mean of its own calendar month over {span}, as climate normals are made (WMO): a January with the Januaries. σ is the spread of that month from year to year.",
  "research.period.howSubdaily": "Each frame is compared with the mean of its calendar month at the same UTC hours over {span}, so the daily cycle is not read as change. σ is the spread of those values across the period, day to day and year to year, about the trend.",
  "research.period.howTooFine": "This dataset has more than eight frames a day: each frame is compared with the mean of the whole window, {span}, which includes the daily cycle. There is no σ change.",
  "research.period.howWindow": "This dataset covers {span}, too short for calendar months: each frame is compared with the mean of the whole window. A window has no year-to-year spread, so there is no σ change.",
  "research.period.legendLabel": "{span} climatology",
  "research.period.meanChange": "Mean change",
  "research.period.meanSigma": "Mean σ change",
  "research.period.method": "A cell has a mean where it has data in at least 80 % of its frames, filled or interpolated frames counting as missing (the WMO guideline; its rule on consecutive missing years is not applied). σ is {spread} about the period's own linear trend (after Hawkins & Sutton 2012, here with a linear trend over the period), never below one step of the data; it needs at least {min} values in the cell. It also contains the data's rounding and streaming noise.",
  "research.period.methodWindow": "A cell has a mean where it has data in at least 80 % of the frames.",
  "research.period.noAxis": "A period needs a dataset with a time axis of frames (the streams). Hold one frame instead.",
  "research.period.noSigma": "σ change needs a period with at least {min} years.",
  "research.period.otherCalendar": "The frame on the globe cannot be placed in the {span} climatology's calendar (another time step), so nothing is compared.",
  "research.period.otherGrid": "The {span} climatology is on another grid, so it cannot be compared with this dataset.",
  "research.period.otherUnits": "The {span} climatology is in {units}, so it cannot be compared with this dataset.",
  "research.period.overlap": "Only {overlap} years of 1991–2020 are in this dataset. It has {total} years, so a full 30-year period such as {suggest} is possible; 1991–2020 keeps results comparable with published ones.",
  "research.period.paused": "Reading is paused: the period is of {title}. Go back to it to go on.",
  "research.period.playHint": "Play the dataset through {span}, or press Read the missing frames: each frame is read once. Nothing is compared until every frame has been read, or until you use the frames read once every month has 80 % of its frames; the baseline then stays as it is while you use it.",
  "research.period.progress": "{read} of {total} frames read",
  "research.period.short": "Climate normals use 30 years (WMO); with {years} years the mean and σ are less steady.",
  "research.period.sigmaTooShort": "σ change needs at least {min} years; this period has {years}. Change and % change are available.",
  "research.period.skipped": "{count} frames the publisher filled, interpolated, estimated or lists as missing are not read; they count as missing.",
  "research.period.span": "{from}–{to}",
  "research.period.spreadDaily": "the spread of that month's daily values across the period (day to day and year to year)",
  "research.period.spreadSubdaily": "the spread of the values of that month and those UTC hours across the period (day to day and year to year)",
  "research.period.spreadYearly": "the year-to-year standard deviation",
  "research.period.start": "Start reading",
  "research.period.step": "Read the missing frames",
  "research.period.stop": "Stop reading",
  "research.period.thinned": "To stay within 256 MB of memory, the climatology keeps one texel in {factor} each way, and the frame is read at the same texels, so the change is drawn at that resolution. Pins compare their own place with their cell.",
  "research.period.thisMonth": "This frame is read against {month}.",
  "research.period.to": "to",
  "research.period.tooFew": "Too few frames: each calendar month (or year) needs at least two in the period. Choose a longer period, or hold one frame.",
  "research.period.tooMany": "Too many frames in one group to count (over 65,535): choose a shorter period.",
  "research.period.useEarly": "Use the {read} frames read",
  "research.period.zonalCaption": "The dashed line is the climatology's mean over the places that have data in both; the largest change is over those places too.",
  "research.record.attributed": "Put my name on the record ({name})",
  "research.record.attributedNoName": "Put my name on the record (your account has no name)",
  "research.record.attributedNote": "Off by default. When ticked, your account name goes on every event of this record and is kept with it when you save it; untick it to keep the record anonymous.",
  "research.record.attributedOff": "This record is anonymous.",
  "research.record.attributedOn": "Your name will be on this record.",
  "research.record.back": "← Back",
  "research.record.cannotOpen": "{title} cannot be opened here (no longer available, or not in your plan). The record’s numbers are still shown.",
  "research.record.cleared": "A new, empty record.",
  "research.record.close": "Close the research record",
  "research.record.counts": "views: {steps} · events: {events} · files kept: {files}",
  "research.record.delete": "Delete",
  "research.record.deleteConfirm": "Press again to delete",
  "research.record.deleted": "Record deleted.",
  "research.record.download": "Download (.zip)",
  "research.record.downloadShort": "Download",
  "research.record.downloaded": "Downloaded {file}.",
  "research.record.ended": "Your plan no longer keeps records: these stay until the date shown, to open, download or delete.",
  "research.record.error.full": "Your account’s space for records (16 MB) is full. Delete one to save this.",
  "research.record.error.invalid": "The record could not be saved as it is. Download it instead.",
  "research.record.error.list": "Your saved records could not be listed.",
  "research.record.error.notFound": "That record is no longer kept.",
  "research.record.error.plan": "Your plan does not keep records on your account. Download it instead.",
  "research.record.error.signedOut": "Sign in to save records to your account.",
  "research.record.error.tooLarge": "This record is too large to save to your account. Download it instead.",
  "research.record.error.tooMany": "Your account keeps 200 records at most. Delete one to save this.",
  "research.record.error.unavailable": "Saving is not available right now. Download the record to keep it.",
  "research.record.ev.analysis": "Statistics on the pins",
  "research.record.ev.baseline": "Baseline",
  "research.record.ev.change": "Change",
  "research.record.ev.cite": "Citation",
  "research.record.ev.compare": "Compare",
  "research.record.ev.dataset": "Opened {title}",
  "research.record.ev.export": "Exported {file} (SHA-256 {hash}…)",
  "research.record.ev.figure": "Figure",
  "research.record.ev.hovmoller": "Line over time",
  "research.record.ev.methods": "Methods paragraph",
  "research.record.ev.note": "Note",
  "research.record.ev.pinAdd": "Pin placed at {where}",
  "research.record.ev.pinMove": "Pin moved to {where}",
  "research.record.ev.pinRead": "Pin at {where} read {value} ({frame})",
  "research.record.ev.pinRemove": "Pin removed",
  "research.record.ev.pinValue": "pin at {where}: {value}",
  "research.record.ev.regionSeries": "Region through time",
  "research.record.ev.stats": "Statistics",
  "research.record.ev.threshold": "Area over a threshold",
  "research.record.ev.view": "View at {frame}.",
  "research.record.filesBad": "CSV files missing or not matching their SHA-256: {n}.",
  "research.record.filesOk": "Its CSV files match their SHA-256 ({n}).",
  "research.record.full": "This record is full (120 views or 400 events). Save or download it, then start a new one.",
  "research.record.go": "Open this view",
  "research.record.indicator": "Recording · views: {steps}",
  "research.record.indicatorAria": "Open the research record",
  "research.record.integrityBad": "This record has been changed since it was made: its content hash or its chain of events does not match.",
  "research.record.integrityNone": "This record carries no hash to check.",
  "research.record.integrityOk": "Unchanged since it was made: its content hash and its chain of events match.",
  "research.record.intro": "While it records, each view you stop on becomes a step with its link and citation, and what you do there is noted: pins and their values, statistics, baselines, comparisons, trends, and every file you export with its SHA-256. It records nothing else: no names, no chat, no voice or camera.",
  "research.record.loading": "Loading…",
  "research.record.locked": "Recording a research session comes with the Research and Situation Room plans.",
  "research.record.new": "Start a new record",
  "research.record.newConfirm": "Press again to discard this record",
  "research.record.next": "Next view",
  "research.record.noData": "no data",
  "research.record.noFrame": "no date",
  "research.record.noneSaved": "None saved yet.",
  "research.record.notSigned": "Not signed: AYNI’s signatures come later.",
  "research.record.nothingYet": "Nothing recorded yet.",
  "research.record.off": "Not recording.",
  "research.record.open": "Open",
  "research.record.openPanel": "Records…",
  "research.record.opened": "Step {n} is on the globe; its numbers read the same now.",
  "research.record.openedChanged": "Step {n} is on the globe; some numbers read differently now: the data has changed since it was recorded.",
  "research.record.opening": "Opening the view of step {n}…",
  "research.record.paused": "Not recording. In this record: {counts}.",
  "research.record.prev": "Previous view",
  "research.record.recent": "Latest in this record",
  "research.record.recording": "Recording: {counts}.",
  "research.record.replayAttributed": "It carries its author’s name.",
  "research.record.replayMeta": "Views: {steps}, recorded from {started}. The numbers are shown as they were recorded.",
  "research.record.rereadChanged": "{what}: recorded {recorded}, reads {now} now. The data has changed since this was recorded.",
  "research.record.rereadNothing": "No numbers on this view to read again.",
  "research.record.rereadPin": "Pin at {where}",
  "research.record.rereadRegion": "Mean over {region}",
  "research.record.rereadSame": "{what}: {recorded}, the same now.",
  "research.record.rereadUnreadable": "{what}: recorded {recorded}; it cannot be read again here.",
  "research.record.save": "Save to my account",
  "research.record.saved": "Saved research records",
  "research.record.savedMeta": "Saved {saved} · kept until {kept}",
  "research.record.savedOk": "Saved to your account; kept until {kept}.",
  "research.record.start": "Record this session",
  "research.record.started": "Recording this session. Nothing about you is kept unless you put your name on the record.",
  "research.record.step": "Step {n}",
  "research.record.stop": "Stop recording",
  "research.record.stopped": "Recording stopped. The record stays until you save it, download it or start a new one.",
  "research.record.title": "Research record",
  "research.record.titleLabel": "Title",
  "research.record.titlePlaceholder": "e.g. Figure 2: summer heat over Vienna",
  "research.record.toolsNote": "Keeps the views you look at, in order, with the numbers you read and the files you export, each with its citation. Nothing is recorded until you switch it on.",
  "research.record.viaChatbot": "{what} (via the chatbot)",
  "research.rs.chartAria": "The region's mean, highest and lowest value in each frame read, across the dataset's time axis. Arrow keys move through the frames; Enter plays from that frame.",
  "research.rs.classified": "This dataset's values are classes, not amounts, so it has no mean, highest or lowest.",
  "research.rs.csv": "Download the series and its records as CSV",
  "research.rs.high": "Highest value",
  "research.rs.highMean": "Highest mean",
  "research.rs.key": "Green: the mean (weighted by area). Orange: the highest cell. Blue: the lowest cell. Dots: the record high and low.",
  "research.rs.lead": "The mean, highest and lowest value of {region} in each frame, measured as the dataset plays, the way pins fill their graph. Underneath: when the records were, and where.",
  "research.rs.limits": "Measured on the dataset's own grid ({width} × {height} cells), with no regridding: a cell counts whole, so nothing smaller than a cell is resolved, and a record is the value of one cell. Values are rounded: one step is {step}.",
  "research.rs.limitsUneven": "Measured on the dataset's own grid ({width} × {height} cells), with no regridding: a cell counts whole, so nothing smaller than a cell is resolved, and a record is the value of one cell. Values are rounded on an uneven scale (log or stepped).",
  "research.rs.locked": "Following a region through time comes with the Research and Situation Room plans.",
  "research.rs.low": "Lowest value",
  "research.rs.lowMean": "Lowest mean",
  "research.rs.noAxis": "This dataset has no list of frame dates (the streams have one), so it cannot be followed through time. The statistics above are for the frame on the globe.",
  "research.rs.readout": "{time} · mean {mean} · highest {max} · lowest {min}",
  "research.rs.resets": "Changing the region starts the series again. Frames played too fast to be read stay empty until the next lap, or until you read the missing frames.",
  "research.rs.start": "Follow through time",
  "research.rs.stop": "Stop following",
  "research.rs.title": "Region through time",
  "research.rs.when.all": "Over every frame of the dataset.",
  "research.rs.when.title": "Records in {region}, and when",
  "research.rs.whereCells": "at {where} (and {count} more cells with the same value that frame)",
  "research.thr.above": "Above",
  "research.thr.axisPercent": "% of area with data",
  "research.thr.baselineFrame": "Compared with the frame held as the baseline ({frame}): now minus the baseline in each cell. Cells without the baseline’s value are left out.",
  "research.thr.baselinePeriod": "Compared with the {span} climatology: each frame against the mean of its own calendar month (and its σ for σ change), the month taken from the frame’s place on the time axis, cell by cell. Cells without a mean (or σ) are left out.",
  "research.thr.baselinePeriodAll": "Compared with the mean of {span}, cell by cell (and with its σ for σ change). Cells without a mean (or σ) are left out.",
  "research.thr.baselinePeriodHours": "Compared with the {span} climatology: each frame against the mean of its own calendar month at the same UTC hours (and its σ for σ change), so the daily cycle is not read as change, cell by cell. Cells without a mean (or σ) are left out.",
  "research.thr.below": "Below",
  "research.thr.cellsOf": "{over} of {total}",
  "research.thr.chartAria": "The area over the threshold in each frame read, across the dataset’s time axis. Arrow keys move through the frames; Enter plays from that frame.",
  "research.thr.classified": "This dataset’s values are classes, not amounts, so there is no threshold to measure an area against.",
  "research.thr.comparatorAria": "Above or below the threshold",
  "research.thr.csv": "Download the series as CSV",
  "research.thr.filledNow": "The publisher filled or interpolated this frame, so it is measured here but left out of the series.",
  "research.thr.lead": "The area of this region where the data is above (or below) a value. On a stream it is measured in each frame as the dataset plays, the way pins fill their graph.",
  "research.thr.limits": "Measured on the dataset’s own grid ({width} × {height} cells), with no regridding or reprojection: a cell counts whole, so nothing smaller than a cell is resolved. Cell areas are exact on a sphere with the Earth’s surface area (radius 6,371.0072 km, WGS84’s authalic radius). Values are rounded: one step is {step}, so a cell within one step of the threshold may be on either side of it.",
  "research.thr.limitsUneven": "Measured on the dataset’s own grid ({width} × {height} cells), with no regridding or reprojection: a cell counts whole, so nothing smaller than a cell is resolved. Cell areas are exact on a sphere with the Earth’s surface area (radius 6,371.0072 km, WGS84’s authalic radius). Values are rounded on an uneven scale: the step depends on the value, and a cell within one step of the threshold may be on either side of it.",
  "research.thr.locked": "Measuring the area over a threshold through time comes with the Research and Situation Room plans.",
  "research.thr.metric.area": "km²",
  "research.thr.metric.percent": "% of the area with data",
  "research.thr.metricAria": "Draw the area, or its share of the area with data",
  "research.thr.mode.difference": "Change",
  "research.thr.mode.sigma": "σ change",
  "research.thr.mode.value": "Value",
  "research.thr.modeAria": "What is compared with the threshold",
  "research.thr.noAxis": "This dataset has no list of frame dates (the streams have one), so only the frame on the globe is measured. Pause on another frame to measure it.",
  "research.thr.noCompare": "No cell of this region has both a value and the baseline’s on this frame.",
  "research.thr.noData": "No cell of this region has data on this frame.",
  "research.thr.percent": "{value} %",
  "research.thr.placeholder": "e.g. {value}",
  "research.thr.progress": "{read} of {total} frames read.",
  "research.thr.prompt": "Type a threshold to measure the area over it. The box suggests this region’s 90th percentile on this frame.",
  "research.thr.range": "Between {low} and {high} once the data’s step is allowed for: {cells} cells lie within one step of the threshold.",
  "research.thr.rangeNone": "No cell lies within one step of the threshold, so the data’s step does not change this area.",
  "research.thr.readout.cell": "{time} · {area} · {share} of the area with data · {over} of {cells} cells",
  "research.thr.readout.noData": "{time} · no data in the region",
  "research.thr.readout.skipped": "{time} · filled by the publisher, not measured",
  "research.thr.readout.unread": "{time} · not read yet",
  "research.thr.readoutHint": "Point at the graph to read a frame; click to play from it.",
  "research.thr.resets": "Changing the threshold, the comparison or the region starts the series again. Frames played too fast to be read stay empty until the next lap.",
  "research.thr.restart": "Start again",
  "research.thr.roledescription": "graph",
  "research.thr.seeked": "Playback moved to {time}.",
  "research.thr.seriesTitle": "Through time",
  "research.thr.sigmaNote": "σ change is (value − the climatology’s mean for that frame) ÷ σ, {spread} about the period’s linear trend (after Hawkins & Sutton 2012). σ is never below one step of the data, so where the spread is smaller σ change understates. For a roughly bell-shaped variable, above 2 happens about 2 times in 100 by chance. Hobday et al. (2016) define a marine heatwave by the 90th percentile lasting five days or more; this measures the area in each frame and does not test how long it lasts.",
  "research.thr.sigmaUnits": "σ",
  "research.thr.skipped": "{count} frames the publisher filled, interpolated, estimated or lists as missing are not measured.",
  "research.thr.stat.area": "Area",
  "research.thr.stat.cells": "Cells over",
  "research.thr.stat.noCompare": "Cells not compared",
  "research.thr.stat.noData": "Cells without data",
  "research.thr.stat.share": "Of the area with data",
  "research.thr.step": "Read the missing frames",
  "research.thr.stop": "Stop reading",
  "research.thr.thinned": "The climatology keeps one texel in {factor} each way (memory), so each cell is compared at the texel its climatology cell was read at: the change is measured at that resolution, each cell keeping its own area.",
  "research.thr.title": "Area over a threshold",
  "research.thr.valueAria": "Threshold, in {units}",
  "research.thr.when.largest": "Largest",
  "research.thr.when.smallest": "Smallest",
  "research.thr.when.title": "When the area was largest and smallest",
  "research.trend.button": "Trend",
  "research.trend.cycle": "Caution: these values are less than a year apart, so a seasonal or daily cycle is likely in them; the tests assume none, so treat these numbers as descriptive.",
  "research.trend.disagree": "Unclear: the two tests disagree (least squares {pOls}; Mann–Kendall {pMk}), so no trend is claimed.",
  "research.trend.down": "Falling: both tests find a downward trend at 5 % (least squares {pOls}; Mann–Kendall {pMk}).",
  "research.trend.lowIndependent": "Caution: fewer than ten independent values.",
  "research.trend.manyTies": "Caution: many equal values (the data’s steps) pull Sen’s slope towards zero; read least squares.",
  "research.trend.method": "A trend is called rising or falling only when two tests agree: least squares with its interval widened for autocorrelation (Santer et al. 2000, with the Nychka et al. 2000 correction for short series), and the Mann–Kendall test with the Hamed–Rao correction. Mann–Kendall alone finds too many trends in persistent series, so it is never used alone.",
  "research.trend.n": "{n} values, about {neff} of them independent.",
  "research.trend.none": "No significant trend at 5 % (least squares {pOls}; Mann–Kendall {pMk}).",
  "research.trend.off": "Trends hidden.",
  "research.trend.ols": "Least squares {slope} {per} (95 %: {low} to {high}), R² {r2}; the interval allows for autocorrelation.",
  "research.trend.olsTooFew": "Least squares {slope} {per}; too few independent values for an interval.",
  "research.trend.on": "Trends shown on the graph.",
  "research.trend.partial": "Only part of the dataset has played: the trend describes what has been read. Let it play through for the whole period.",
  "research.trend.per.day": "per day",
  "research.trend.per.decade": "per decade",
  "research.trend.per.hour": "per hour",
  "research.trend.per.year": "per year",
  "research.trend.region": "Trends of the pins",
  "research.trend.sen": "Sen’s slope {slope} {per} (robust to outliers; the dashed line); Kendall’s τ-b {tau}.",
  "research.trend.tooFew": "Fewer than {min} values read: let the dataset play to fill the graph.",
  "research.trend.up": "Rising: both tests find an upward trend at 5 % (least squares {pOls}; Mann–Kendall {pMk}).",
  "room.chip.connecting": "Shared session {code} · connecting…",
  "room.chip.follower": "Shared session {code} · following · {count} here",
  "room.chip.invite": "Invite",
  "room.chip.invite.title": "Invite people to this session",
  "room.chip.lead": "Shared session {code} · you lead · {count} here",
  "room.note.aria": "What the presenter's Khipu shows",
  "room.note.kind": "The presenter's Khipu",
  "room.note.pins": "Pins: {list}",
  "satellites.approximate": "Approximate positions. Not for collision warnings.",
  "satellites.card.close": "Close",
  "satellites.card.datasets": "Data from this satellite",
  "satellites.card.datasetsNone": "No dataset in the catalog is built from it.",
  "satellites.card.elements": "Orbit measured",
  "satellites.card.height": "Height",
  "satellites.card.ids": "Catalogue",
  "satellites.card.inclination": "Inclination",
  "satellites.card.launched": "Launched",
  "satellites.card.load": "Load",
  "satellites.card.locked": "In AYNI XR plans. Press to see them.",
  "satellites.card.notTracked": "Not tracked, so not drawn.",
  "satellites.card.orbit": "Orbit",
  "satellites.card.orbitRange": "Lowest – highest",
  "satellites.card.owner": "Owner",
  "satellites.card.period": "One orbit",
  "satellites.card.purpose": "Purpose",
  "satellites.card.retired": "Retired {year}; no longer tracked, so not drawn.",
  "satellites.card.showsSun": "Its datasets show the Sun.",
  "satellites.card.speed": "Speed",
  "satellites.card.standIn": "stand-in",
  "satellites.card.window": "{from} – {to}",
  "satellites.card.windowFrom": "from {from}",
  "satellites.card.windowTo": "until {to}",
  "satellites.category.debris": "Debris",
  "satellites.colourBy.country": "Country",
  "satellites.colourBy.label": "Colour by",
  "satellites.colourBy.needsCatalogue": "Country appears once the satellite catalogue is published.",
  "satellites.colourBy.orbit": "Orbit",
  "satellites.colourBy.purpose": "Purpose",
  "satellites.country.CIS": "Russia",
  "satellites.country.ESA": "Europe (ESA, EUMETSAT)",
  "satellites.country.FR": "France",
  "satellites.country.IND": "India",
  "satellites.country.JPN": "Japan",
  "satellites.country.PRC": "China",
  "satellites.country.UK": "United Kingdom",
  "satellites.country.US": "United States",
  "satellites.country.other": "Other",
  "satellites.event.came": "Came down",
  "satellites.event.close": "Close this event",
  "satellites.event.datasets": "Data from its satellites",
  "satellites.event.live": "Still in orbit: its orbit is on the globe.",
  "satellites.event.noOrbit": "This object has left the data, and its last orbit is not available yet.",
  "satellites.event.noPlace": "not published for this object",
  "satellites.event.noteEstimated": "The line is the last orbit measured. Where it came down is worked out from it, so only about right.",
  "satellites.event.noteGiven": "The line is the last orbit measured before it came down.",
  "satellites.event.place": "{lat}, {lon}",
  "satellites.event.placeAbout": "about {lat}, {lon}",
  "satellites.event.show": "Show on the globe",
  "satellites.event.source": "Source",
  "satellites.event.working": "Working out its last orbit…",
  "satellites.events.close": "Hide space events",
  "satellites.events.kind.asatTest": "Anti-satellite test",
  "satellites.events.kind.breakup": "Break-up",
  "satellites.events.kind.collision": "Collision",
  "satellites.events.kind.launch": "Launch",
  "satellites.events.kind.milestone": "Milestone",
  "satellites.events.kind.notable": "Notable",
  "satellites.events.kind.reentry": "Re-entry",
  "satellites.events.title": "Space events",
  "satellites.fold.close": "Hide the satellite settings",
  "satellites.fold.open": "Show the satellite settings",
  "satellites.fov": "Field of view",
  "satellites.fov.tip": "The circle each satellite behind the data (and the selected one) can see, out to its horizon",
  "satellites.height.compact": "Compact",
  "satellites.height.label": "Height in VR and AR",
  "satellites.height.short": "Height",
  "satellites.height.tip": "True scale puts the geostationary ring 6.6 globe widths out; compact keeps every orbit within reach.",
  "satellites.height.true": "True scale",
  "satellites.hemi.e": "E",
  "satellites.hemi.n": "N",
  "satellites.hemi.s": "S",
  "satellites.hemi.w": "W",
  "satellites.legend.hint": "Press a colour to hide or show it.",
  "satellites.mapHeight.ground": "On the ground",
  "satellites.mapHeight.label": "Height on the globe",
  "satellites.mapHeight.tip": "On the ground: the point under each satellite. Compact or true scale: each one floats at its height, on its real orbit (the flat map always shows them on the ground).",
  "satellites.note": "Every tracked satellite, moving in real time, with a fading trail behind it.",
  "satellites.off": "Off",
  "satellites.on": "On",
  "satellites.orbit.geo": "Geosynchronous (GEO)",
  "satellites.orbit.heo": "Highly elliptical (HEO)",
  "satellites.orbit.high": "Beyond GEO",
  "satellites.orbit.leo": "Low Earth orbit (LEO)",
  "satellites.orbit.meo": "Medium Earth orbit (MEO)",
  "satellites.otherBody": "Satellites orbit the Earth. This dataset shows another body, so none are drawn; they come back with the next dataset of the Earth.",
  "satellites.passes.title": "Passing over you",
  "satellites.purpose.communications": "Communications",
  "satellites.purpose.debris": "Debris",
  "satellites.purpose.earthObservation": "Earth observation",
  "satellites.purpose.humanSpaceflight": "Human spaceflight",
  "satellites.purpose.military": "Military",
  "satellites.purpose.navigation": "Navigation",
  "satellites.purpose.other": "Other",
  "satellites.purpose.science": "Science",
  "satellites.purpose.technology": "Technology and education",
  "satellites.purpose.weather": "Weather",
  "satellites.show.all": "All active",
  "satellites.show.cosmos": "Kosmos 2251 debris",
  "satellites.show.fengyun": "Fengyun-1C debris",
  "satellites.show.highlights": "Highlights",
  "satellites.show.highlights.tip": "Space stations, weather, Earth observation, navigation and the geostationary belt",
  "satellites.show.iridium": "Iridium 33 debris",
  "satellites.show.label": "Show",
  "satellites.show.starlink": "Starlink",
  "satellites.show.withDatasets": "With datasets",
  "satellites.show.withDatasets.tip": "Every satellite that provides data for a dataset in the catalog. Press one for its datasets.",
  "satellites.sky.above": "{count} above your horizon, {lit} in sunlight",
  "satellites.sky.button": "Sky above me",
  "satellites.sky.catalogPass": "{name} passes at {time} ({el}°): it gives {dataset}",
  "satellites.sky.e": "E",
  "satellites.sky.fullVr": "Fully VR",
  "satellites.sky.fullVrCredit": "Sky: NASA Goddard Scientific Visualization Studio star map; stars: Yale Bright Star Catalogue.",
  "satellites.sky.fullVrTip": "Hide the room and float in space: the Milky Way, the stars and the Sun all around you, and the satellites on their orbits around the globe, turning with the clock.",
  "satellites.sky.hint": "Point at a dot and press the trigger for its card.",
  "satellites.sky.hintPhone": "Tap a dot for its card.",
  "satellites.sky.locating": "Finding your location…",
  "satellites.sky.n": "N",
  "satellites.sky.nextPass": "{name} next over you: {time}, up to {el}°",
  "satellites.sky.noPass": "{name} does not climb over 10° here in the next day.",
  "satellites.sky.north": "Face north and press the trigger to set the directions.",
  "satellites.sky.northPhone": "Point the phone north and tap the screen to set the directions.",
  "satellites.sky.overheadNow": "{name} is over you now ({el}°): it gives {dataset}",
  "satellites.sky.pointRises": "{name} rises at {time}, {dir}",
  "satellites.sky.pointUp": "{name}: {el}° up, {dir}",
  "satellites.sky.s": "S",
  "satellites.sky.setNorth": "Set north",
  "satellites.sky.tip": "In AR: the satellites over your head right now, drawn on the real sky.",
  "satellites.sky.w": "W",
  "satellites.sky.where": "Where are you? Allow your location, or tap your place on the globe. It stays on this device.",
  "satellites.sources.dated": "Not drawn for this date: its orbit is known for today only.",
  "satellites.sources.datedNominal": "Drawn at its nominal longitude for this date: its orbit is known for today only.",
  "satellites.sources.hint": "Satellites behind this data: {count}. Switch Satellites on to see them pulse.",
  "satellites.sources.notTracked": "not tracked",
  "satellites.sources.standby": "Stand-in: used only when the main satellite is missing; not drawn now.",
  "satellites.sources.tip": "The satellites this data is built from, pulsing on the globe; a frame may lack one of them. Press one to follow it.",
  "satellites.sources.title": "Data from",
  "satellites.status.asOf": "orbits as of {time}",
  "satellites.status.count": "{shown} of {total} objects shown",
  "satellites.status.error": "Satellites could not load: {error}",
  "satellites.status.loading": "Loading satellites…",
  "satellites.status.stale": "The orbital data is more than 6 hours old, so positions drift further from the truth.",
  "satellites.time.label": "Satellite time",
  "satellites.time.live": "Live",
  "satellites.time.offset": "{time} ({offset})",
  "satellites.time.pause": "Pause",
  "satellites.time.play": "Play",
  "satellites.time.scrub": "Move up to a day either way",
  "satellites.time.speed": "Speed",
  "satellites.title": "Satellites",
  "satellites.toggle": "Show satellites",
  "satellites.trails": "Trails",
  "satellites.unit.deg": "{value}°",
  "satellites.unit.km": "{value} km",
  "satellites.unit.kmRange": "{low}–{high} km",
  "satellites.unit.kmh": "{value} km/h",
  "satellites.unit.min": "{value} min",
  "share.button.aria": "Share",
  "share.copied": "Link copied",
  "share.site.shared": "Link to AYNI XR shared",
  "share.site.text": "Explore live Earth data in 3D, VR and AR.",
  "share.site.title": "AYNI XR",
  "situation.age.days.one": "1 day old",
  "situation.age.days.other": "{count} days old",
  "situation.age.hours.one": "1 h old",
  "situation.age.hours.other": "{count} h old",
  "situation.age.minutes.one": "1 min old",
  "situation.age.minutes.other": "{count} min old",
  "situation.board.changed": "changed {date}",
  "situation.board.default": "the standard board",
  "situation.board.edit": "Change the board",
  "situation.board.play": "Play the board",
  "situation.board.reset": "Back to the standard board",
  "situation.board.resetDone": "The walls show the standard board again.",
  "situation.board.saveAs": "Save as the room's board",
  "situation.board.saved": "Saved: the walls show it from their next round.",
  "situation.board.show": "Show the situation",
  "situation.board.shown": "The situation is on the globes.",
  "situation.board.steps.one": "1 view",
  "situation.board.steps.other": "{count} views",
  "situation.board.title": "The board",
  "situation.briefing.anonymousNotice": "The record keeps what was shown and decided, without names.",
  "situation.briefing.board": "The board",
  "situation.briefing.decisions.one": "1 decision",
  "situation.briefing.decisions.other": "{count} decisions",
  "situation.briefing.discard": "Discard it",
  "situation.briefing.discarded": "The briefing was discarded; nothing was kept.",
  "situation.briefing.download": "Download (.zip)",
  "situation.briefing.finish": "Finish the briefing",
  "situation.briefing.finished": "Briefing finished: {n} steps shown.",
  "situation.briefing.meeting": "Start a meeting for it",
  "situation.briefing.meetingOn": "Meeting invitations",
  "situation.briefing.next": "Next: {title}",
  "situation.briefing.pack": "Briefing pack (print or PDF)",
  "situation.briefing.recording": "Recording the briefing · step {step} of {total}",
  "situation.briefing.save": "Save the record",
  "situation.briefing.second": "Second screen",
  "situation.briefing.secondBlocked": "The browser blocked the second screen. Allow pop-ups for this site and try again.",
  "situation.briefing.shown.one": "1 step shown",
  "situation.briefing.shown.other": "{count} steps shown",
  "situation.briefing.start": "Start the briefing",
  "situation.briefing.template": "The 72-hour briefing",
  "situation.briefing.title": "Briefing",
  "situation.briefing.wallOff": "Take the meeting off the walls",
  "situation.briefing.wallOffDone": "The walls go back to the board.",
  "situation.briefing.wallOn": "Show this meeting on the walls",
  "situation.briefing.wallOnDone": "The walls join the meeting at their next step.",
  "situation.briefing.which": "Brief from",
  "situation.briefing.withName": "Put my name on the record",
  "situation.briefing.withNameNotice": "Your display name will be on every step of the record, for whoever the record is shared with.",
  "situation.clock": "{utc} UTC · {local} local time",
  "situation.close": "Close the Situation room",
  "situation.decision.label": "What was decided?",
  "situation.decision.note": "Kept in the briefing's record and pack.",
  "situation.done": "Done",
  "situation.error.empty": "That file has no points, lines or areas to show.",
  "situation.error.failed": "That did not work. Try again.",
  "situation.error.invalid": "That could not be read.",
  "situation.error.notFound": "That is no longer there.",
  "situation.error.plan": "The Situation room comes with the Situation Room plans.",
  "situation.error.rate": "Too many requests. Wait a moment and try again.",
  "situation.error.signIn": "Sign in to use the Situation room.",
  "situation.error.tooLarge": "That is too large.",
  "situation.error.tooMany": "The room already has the most it can keep.",
  "situation.error.tooManyFeatures": "That layer has too many features (20,000 at most).",
  "situation.error.unavailable": "The Situation room is not available right now.",
  "situation.fresh.archive": "Not live",
  "situation.fresh.fresh": "On time",
  "situation.fresh.late": "Late",
  "situation.fresh.none": "No dataset on the globes yet.",
  "situation.fresh.stale": "Stale",
  "situation.fresh.summary.fresh": "Data up to date.",
  "situation.fresh.summary.late": "Some data is late: a release is missing.",
  "situation.fresh.summary.stale": "Some data is stale: two or more releases are missing.",
  "situation.fresh.summary.unknown": "Checking how old the data is…",
  "situation.fresh.title": "How old the data is",
  "situation.fresh.unknown": "Age unknown",
  "situation.layers.add": "Add a layer (GeoJSON, KML, KMZ)",
  "situation.layers.added": "{title} added ({n} features).",
  "situation.layers.delete": "Remove",
  "situation.layers.deleted": "The layer was removed.",
  "situation.layers.failed": "could not be loaded",
  "situation.layers.features.one": "1 feature",
  "situation.layers.features.other": "{count} features",
  "situation.layers.how": "Up to {n} layers of {mb} MB each, private to this licence and its screens. Only each feature's name and description are kept.",
  "situation.layers.none": "No layers yet. Add your own sites, areas or routes.",
  "situation.layers.notSupported": "Use a GeoJSON, KML or KMZ file.",
  "situation.layers.reading": "Reading {name}…",
  "situation.layers.title": "Your layers",
  "situation.layers.unreadable": "That file could not be read.",
  "situation.loading": "Loading the room…",
  "situation.pack.by": "by {name}",
  "situation.pack.decision": "Decision",
  "situation.pack.decisions": "Decisions",
  "situation.pack.hash": "Record SHA-256: {hash}",
  "situation.pack.noDecision": "No decision was recorded.",
  "situation.pack.noPicture": "No picture",
  "situation.pack.when": "From {from} to {to}",
  "situation.reload": "Try again",
  "situation.rename": "Rename",
  "situation.title": "Situation room",
  "situation.wall.named": "Situation room · {name}",
  "situation.wall.offline": "Offline: showing the last board",
  "situation.wall.pairHow": "In AYNI XR, open Tools → Situation room → Wall displays, and type this code.",
  "situation.wall.pairRetry": "Cannot reach AYNI right now. Trying again…",
  "situation.wall.pairTitle": "Pair this screen with your Situation room",
  "situation.walls.badCode": "A code has six letters and numbers, like ABC-234.",
  "situation.walls.code": "Code",
  "situation.walls.defaultName": "Screen {n}",
  "situation.walls.full": "The room has {n} screens, the most it pairs. Unpair one first.",
  "situation.walls.how": "On the screen's browser, open {url}. It shows a code: type it here.",
  "situation.walls.name": "Screen name",
  "situation.walls.namePlaceholder": "Main wall",
  "situation.walls.never": "never connected",
  "situation.walls.none": "No screen paired yet.",
  "situation.walls.pair": "Pair",
  "situation.walls.paired": "{name} is paired. It starts the board in a few seconds.",
  "situation.walls.pairing": "Pairing {code}…",
  "situation.walls.seen": "seen {age}",
  "situation.walls.title": "Wall displays",
  "situation.walls.unknownCode": "No screen is showing that code. Codes last ten minutes.",
  "situation.walls.unpair": "Unpair",
  "situation.walls.unpaired": "The screen was unpaired; it shows a new code.",
  "speed.announce": "Playing at {rate}",
  "speed.badge.aria": "Playing at {rate}. Back to normal speed",
  "speed.group.aria": "Playback speed",
  "speed.note.ceiling": "Up to {rate} while a real-time layer is on",
  "speed.note.locked": "The presenter sets the speed",
  "speed.note.still": "This dataset does not move",
  "speed.step.aria": "Play at {rate}",
  "speed.step.normal": "Normal speed ({rate})",
  "speed.value": "{rate}×",
  "stream.denied.plan": "Your plan does not include this stream. The plans below add it.",
  "stream.denied.signIn": "Sign in to play streams. The catalogue, thumbnails and legends are open to everyone; the live streams play with a free account and the plan that includes them.",
  "studio.amount": "How much (degrees, or zoom levels)",
  "studio.approvalSent": "Sent to your team’s editors. No credits are held until an editor approves it.",
  "studio.approve": "Approve ({credits} credits)",
  "studio.approved": "Approved: the video is being rendered.",
  "studio.aspect": "Shape",
  "studio.aspect.portrait": "4:5 portrait",
  "studio.aspect.square": "1:1 square",
  "studio.aspect.tall": "9:16 vertical",
  "studio.aspect.wide": "16:9 landscape",
  "studio.balance": "You have {credits} credits.",
  "studio.brand": "Brand",
  "studio.brand.accent": "Accent colour",
  "studio.brand.delete": "Delete the kit",
  "studio.brand.deleted": "Brand kit deleted; shots that used it keep their copy.",
  "studio.brand.invalid": "The kit needs a name, and the logo must be a PNG, JPEG or WebP image.",
  "studio.brand.logo": "Logo (PNG, JPEG or WebP)",
  "studio.brand.lowerThird": "Lower third",
  "studio.brand.name": "Name",
  "studio.brand.new": "New brand kit",
  "studio.brand.none": "No brand kit",
  "studio.brand.note": "The logo goes at the top right and the lower third just above the data credit.",
  "studio.brand.save": "Save the kit",
  "studio.brand.saved": "Brand kit saved.",
  "studio.brand.tooMany": "You can keep up to 20 brand kits.",
  "studio.button.aria": "Open the Studio to make a video of this view",
  "studio.button.label": "Studio",
  "studio.close": "Close the Studio",
  "studio.confirm": "Order the video ({credits} credits)",
  "studio.copied": "Embed code copied.",
  "studio.copy": "Copy",
  "studio.creditNote": "Every video carries the data credit, as the data licences require.",
  "studio.dataMove": "Data",
  "studio.dataMove.basemap": "Through the plain Earth",
  "studio.dataMove.crossfade": "Crossfade",
  "studio.dataMove.cut": "Change at once",
  "studio.dataMove.timeRun": "Run through the dates",
  "studio.dataMove.wipe": "Wipe",
  "studio.decline": "Decline",
  "studio.declined": "Declined.",
  "studio.download": "Download",
  "studio.during": "While it holds",
  "studio.during.orbit": "Orbit",
  "studio.during.pullOut": "Pull out",
  "studio.during.pushIn": "Push in",
  "studio.during.still": "Still",
  "studio.effects": "Effects",
  "studio.effects.note": "Effects never change the data inside the focus: they work on what is around it.",
  "studio.embed": "Embed code",
  "studio.embedNote": "Put the file and its poster on your own site, then replace https://YOUR-SITE in this code with their address. Nothing loads from AYNI.",
  "studio.endCard.madeWith": "Made with AYNI XR · Pachamama Studios",
  "studio.endCard.title": "Data",
  "studio.error.editorOnly": "Only an editor can do that.",
  "studio.error.generic": "Something went wrong; try again.",
  "studio.error.insufficientCredits": "Not enough credits for this video.",
  "studio.error.lastEditor": "The team needs at least one editor.",
  "studio.error.newsroomOnly": "8K and ProRes come with the Newsroom plan.",
  "studio.error.notConfigured": "Rendering is not open yet.",
  "studio.error.planRequired": "Videos come with the Media Desk and Newsroom plans.",
  "studio.error.save": "The shot could not be saved.",
  "studio.error.unauthorized": "Sign in to save and order.",
  "studio.error.voiceMissing": "This video's voice-over is no longer kept (recordings go 30 days after upload). Remove it, or add it again.",
  "studio.feel": "Feel",
  "studio.feel.gentle": "Gentle",
  "studio.feel.linear": "Even",
  "studio.feel.snappy": "Snappy",
  "studio.finish": "Finishing",
  "studio.finish.animatedBrand": "Animate the logo and lower third",
  "studio.finish.endCard": "End card with every data credit",
  "studio.finish.motionBlur": "Motion blur on moves (twice the credits)",
  "studio.finish.reframe": "Keep each stop in frame in other shapes",
  "studio.format": "File",
  "studio.format.gif": "GIF for the web (up to 20 s)",
  "studio.format.hevc": "MP4 (H.265, smaller)",
  "studio.format.mp4": "MP4 (H.264)",
  "studio.format.png": "Still image (PNG)",
  "studio.format.prores": "ProRes 4444 (Newsroom)",
  "studio.formatNote": "A still costs 1 credit. A GIF is 1080p at 15 frames a second. Transparent space leaves out the stars and the atmosphere, for ProRes and PNG only.",
  "studio.fps": "Frames per second",
  "studio.fx.arrowAdd": "Start an arrow at the view’s centre",
  "studio.fx.arrowColor": "Colour",
  "studio.fx.arrowLabel": "Label",
  "studio.fx.arrowPoint": "Add the view’s centre to it",
  "studio.fx.arrowStarted": "Arrow started: move the globe and add the next point.",
  "studio.fx.arrows": "Arrows",
  "studio.fx.blur": "Depth blur",
  "studio.fx.calloutAdd": "Add a callout at the view’s centre",
  "studio.fx.calloutLabel": "Label",
  "studio.fx.calloutValue": "Show the value there",
  "studio.fx.callouts": "Callouts",
  "studio.fx.card": "Title card",
  "studio.fx.cardSeconds": "Card for (seconds)",
  "studio.fx.colour": "Colour {n}",
  "studio.fx.compare": "Compare with another date (a line moves across)",
  "studio.fx.compareAt": "The other date",
  "studio.fx.counter": "Value counter at the view’s centre",
  "studio.fx.counterLabel": "Counter label",
  "studio.fx.dim": "Dim outside",
  "studio.fx.edge": "Glowing edge",
  "studio.fx.grain": "Film grain (video only)",
  "studio.fx.grey": "Grey outside",
  "studio.fx.moved": "The spotlight is on the view’s centre.",
  "studio.fx.points": "{n} points",
  "studio.fx.radius": "Radius (degrees)",
  "studio.fx.spotHere": "Centre it here",
  "studio.fx.spotlight": "Spotlight at the view’s centre",
  "studio.fx.vignette": "Vignette",
  "studio.intro": "Make a video of the globe from stops: each is a place, a date and what the globe shows, and the video moves from one to the next as you set it.",
  "studio.keep": "Keep until {date} ({credits} credit)",
  "studio.kept": "The video is kept until your licence’s term ends.",
  "studio.keptUntil": "until {date}",
  "studio.move": "Camera",
  "studio.move.auto": "auto",
  "studio.move.cut": "Cut (at once)",
  "studio.move.fly": "Fly (rises, travels, comes down)",
  "studio.move.glide": "Glide (a level move)",
  "studio.move.path": "Along a path",
  "studio.move.seconds": "Takes (seconds)",
  "studio.ordered": "Ordered. The video is being rendered; it appears below when it is ready.",
  "studio.orders": "Your videos",
  "studio.ordersEmpty": "No videos yet.",
  "studio.output": "Video",
  "studio.path.add": "Add the view’s centre to the path",
  "studio.path.clear": "Clear the path",
  "studio.play.note": "While the Studio is open, playing the data is recorded: the date it starts from and the date it stops on become stops, and the video runs through the dates for as long as it played.",
  "studio.play.recorded": "Recorded: played from {from} to {to} in {seconds} s, as stop {n}.",
  "studio.poster": "Poster",
  "studio.preview": "Preview",
  "studio.previewNote": "A quick preview here in the browser; the video itself is rendered on a server, frame by frame.",
  "studio.price": "This video costs {credits} credits.",
  "studio.price.perGlobe": "Stops with several globes cost once per globe they show.",
  "studio.resolution": "Resolution",
  "studio.save": "Save and get a quote",
  "studio.saved": "Saved to your Khipus. The quote is ready.",
  "studio.shotTitle": "Title",
  "studio.status.awaitingApproval": "Waiting for an editor",
  "studio.status.delivered": "Ready",
  "studio.status.expired": "Expired",
  "studio.status.failed": "Failed, credits returned",
  "studio.status.quoted": "Quote",
  "studio.status.rendering": "Rendering…",
  "studio.stillAt": "Still at (seconds)",
  "studio.stop.arrive": "Getting here",
  "studio.stop.down": "Move later",
  "studio.stop.firstNote": "The video opens on the first stop, so it has no way in.",
  "studio.stop.hold": "Holds for (seconds)",
  "studio.stop.n": "Stop {n}",
  "studio.stop.remove": "Remove",
  "studio.stop.show": "Show on the globe",
  "studio.stop.title": "Title",
  "studio.stop.up": "Move earlier",
  "studio.stop.use": "Use the globe now",
  "studio.stop.used": "The stop takes what the globe shows now.",
  "studio.stopPreview": "Stop",
  "studio.stops": "Stops",
  "studio.stops.add": "Add the view as a stop",
  "studio.stops.added": "Stop {n} added.",
  "studio.stops.empty": "Add a stop: move the globe and the date to where the video starts and press Add the view as a stop. Each stop is a place, a date and what the globe shows.",
  "studio.stops.length": "Length: {seconds} s, from the stops",
  "studio.stops.noCamera": "That Khipu has no step with a camera to film.",
  "studio.stops.open": "Open one of my Khipus",
  "studio.stops.openApply": "Open",
  "studio.stops.openNone": "Choose a Khipu",
  "studio.stops.opened": "Opened as a new video: its steps are the stops. The Khipu itself is unchanged.",
  "studio.stops.same": "That view is already stop {n}.",
  "studio.stops.timeline": "Timeline of the stops",
  "studio.team": "Team",
  "studio.team.approval": "Orders need an editor’s approval",
  "studio.team.approvalOn": "Your orders wait for an editor’s approval.",
  "studio.team.editor": "Editor",
  "studio.team.note": "Editors approve orders and name other editors. The first person on the team to use the Studio is its first editor.",
  "studio.team.saved": "Team settings saved.",
  "studio.template": "Start from a template",
  "studio.template.after": "After",
  "studio.template.applied": "Stops set from the template; adjust them as you like.",
  "studio.template.apply": "Use",
  "studio.template.before": "Before",
  "studio.template.beforeAfter": "Before and after: the first date, then the last",
  "studio.template.needsDates": "This template needs a dataset with dates.",
  "studio.template.needsPins": "Put at least two pins on the globe first (Tools → Data).",
  "studio.template.none": "Choose…",
  "studio.template.pinJourney": "A journey through the pins on the globe",
  "studio.template.timeLapse": "Time-lapse here, from the first date to the last",
  "studio.template.turn": "Turn the globe past this place",
  "studio.template.zoomIn": "Zoom in on this place",
  "studio.title": "Studio",
  "studio.transparent": "Transparent space (for keying)",
  "studio.voice": "Voice-over",
  "studio.voice.added": "Voice-over added: {name}.",
  "studio.voice.badAudio": "That file is not a recording we can use: MP3, M4A, WAV, OGG, WebM or AAC.",
  "studio.voice.file": "Recording (MP3, M4A, WAV, OGG; up to 25 MB)",
  "studio.voice.needRights": "First confirm that the recording is yours to use.",
  "studio.voice.note": "It plays under the video from the start, with soft fades, and stops where the video ends; GIFs and stills have no sound. We keep it 30 days after you upload it, only to make your videos.",
  "studio.voice.remove": "Remove the voice-over",
  "studio.voice.removed": "Voice-over removed and the recording deleted.",
  "studio.voice.rights": "I own this recording, or have the rights to use it in this video",
  "studio.voice.tooLarge": "That recording is over 25 MB.",
  "studio.voice.uploading": "Uploading the recording…",
  "studio.wipe": "Wipe along",
  "studio.wipe.meridian": "a meridian",
  "studio.wipe.terminator": "the day–night line",
  "timeline.aria": "Dataset timeline",
  "timeline.base.close": "Close {title} and its overlays",
  "timeline.base.closed": "{title} closed",
  "timeline.base.closedWithOverlays": "{title} and its overlays closed",
  "timeline.base.hidden": "{title} hidden on the globe",
  "timeline.base.hide": "Hide {title} on the globe",
  "timeline.base.lock": "The dataset always stays below the overlays",
  "timeline.base.show": "Show {title} on the globe",
  "timeline.base.shown": "{title} shown on the globe",
  "timeline.hover.band": "{text} · {names}",
  "timeline.hover.bandAbout": "{name} (about)",
  "timeline.hover.estimated": "{date} · estimated",
  "timeline.hover.filled": "{date} · repeated frame",
  "timeline.hover.missing": "{date} · no data",
  "timeline.hover.uncovered": "{date} · no data from this stream",
  "timeline.overlay.aria": "Dates of the real-time overlay, {title}",
  "timeline.overlay.close": "Take {title} off the globe",
  "timeline.overlay.hide": "Hide {title} on the globe",
  "timeline.overlay.move": "Move {title}: hold and drag up or down, or use the arrow keys",
  "timeline.overlay.moved": "{title}: layer {n} of {count}, counting from the top",
  "timeline.overlay.show": "Show {title} on the globe",
  "tools.actions.aboutPage": "About AYNI XR",
  "tools.actions.clear": "Clear pins, lines and boxes",
  "tools.actions.credits": "Credits…",
  "tools.actions.manual": "User manual",
  "tools.actions.meeting": "Start a meeting…",
  "tools.actions.outputWindow": "Open an output window",
  "tools.actions.outputWindow.hint": "The globes alone, in a second window for the projector; the controls stay here.",
  "tools.actions.privacy": "Privacy settings…",
  "tools.actions.sphereOutput": "Open a sphere output (2:1)",
  "tools.actions.sphereOutput.hint": "The main globe as one flat 2:1 picture, the format Science On a Sphere and other spherical displays play: capture this window on the sphere’s computer.",
  "tools.analyze.aria": "Analyze: statistics of the dataset on screen",
  "tools.analyze.label": "Analyze",
  "tools.announce.analyzeOpened": "Analysis panel opened",
  "tools.announce.autoRotate.off": "Auto-rotation disabled",
  "tools.announce.autoRotate.on": "Auto-rotation enabled",
  "tools.announce.boxStarted": "Box: click two opposite corners on the globe",
  "tools.announce.cleared": "Pins, lines, boxes and markers cleared",
  "tools.announce.creditsOpened": "Credits opened",
  "tools.announce.datasetInfo.off": "Dataset info hidden",
  "tools.announce.datasetInfo.on": "Dataset info shown",
  "tools.announce.labels.off": "Labels off",
  "tools.announce.labels.on": "Labels on",
  "tools.announce.layout": "Layout: {label}",
  "tools.announce.legend.off": "Legend hidden",
  "tools.announce.legend.on": "Legend shown",
  "tools.announce.lineStarted": "Line: click where it starts, then where it ends",
  "tools.announce.meetingOpened": "Meeting panel opened",
  "tools.announce.outputWindow": "Output window opened. Drag it to the projector and make it full screen with F11.",
  "tools.announce.outputWindowBlocked": "The browser blocked the window. Allow pop-ups for this site and try again.",
  "tools.announce.privacyOpened": "Privacy settings opened",
  "tools.announce.shared": "Dataset shared",
  "tools.announce.sphereOutput": "Sphere output opened: the main globe as a 2:1 picture. Capture that window on the sphere’s computer.",
  "tools.announce.studioOpened": "Studio opened",
  "tools.announce.terrain.off": "3D terrain off",
  "tools.announce.terrain.on": "3D terrain on",
  "tools.browse.aria": "Browse datasets",
  "tools.browse.label": "Browse",
  "tools.close.aria": "Close tools",
  "tools.data.chart.aria": "Graph of {count} pins from {start} to {end}, values from {min} to {max}",
  "tools.data.chart.empty": "The graph appears once a pin has read a value.",
  "tools.data.chart.filling": "The graph fills in as the dataset plays: {pct}% of its frames read so far.",
  "tools.data.chart.still": "A still image has no time to graph; each pin shows its value above.",
  "tools.data.csv": "Download CSV",
  "tools.data.csv.aria": "Download the pins' values as a CSV file",
  "tools.data.csv.done": "The pins' values were downloaded as a CSV file.",
  "tools.data.csv.globeNote": "Rows named \"globe N\" are the same pins read on globe N, which shows {datasets}; their time column is globe 1's date.",
  "tools.data.csvPlan": "CSV download: in the plans with exports",
  "tools.data.graph.away": "The graph is out on the globe.",
  "tools.data.graph.backAnnounce": "Graph back in Tools.",
  "tools.data.graph.bringBack": "Bring it back",
  "tools.data.graph.close": "Close (the graph goes back to Tools)",
  "tools.data.graph.dock": "Back to Tools",
  "tools.data.graph.dragHint": "Drag the graph out onto the globe",
  "tools.data.graph.dropHere": "Drop it here to keep it in Tools",
  "tools.data.graph.globeKey": "{name} · globe {n} ({rule})",
  "tools.data.graph.move": "Move the graph: drag, or use the arrow keys",
  "tools.data.graph.noPins": "Pin places on the globe to draw their graph.",
  "tools.data.graph.notRead": "not read yet",
  "tools.data.graph.outAnnounce": "Graph moved onto the globe. Drag its title bar to move it and its corner to resize it; Escape puts it back.",
  "tools.data.graph.popOut": "Pop the graph out onto the globe",
  "tools.data.graph.resize": "Resize the graph: drag, or use the arrow keys",
  "tools.data.graph.seekHint": "Click to play from here",
  "tools.data.graph.seeked": "Playback moved to {time}",
  "tools.data.graph.title": "Pin graph",
  "tools.data.intro": "Pin up to six places on the globe to read their values and follow them in time.",
  "tools.data.pins.added": "Pin dropped at {where}.",
  "tools.data.pins.aria": "Pins",
  "tools.data.pins.clear": "Clear all",
  "tools.data.pins.cleared": "All pins removed.",
  "tools.data.pins.extremes": "Mark highest & lowest",
  "tools.data.pins.extremesNone": "Nothing to mark: no values in this frame, or no room for another pin.",
  "tools.data.pins.extremesPlaced": "Pins placed on the highest and lowest values. They follow the data as it changes.",
  "tools.data.pins.follow": "Follow as the data changes",
  "tools.data.pins.followOff": "The highest and lowest pins stay where they are.",
  "tools.data.pins.followOn": "The highest and lowest pins follow the data.",
  "tools.data.pins.full": "Six pins is the most. Remove one to add another.",
  "tools.data.pins.fullPlan": "Your plan holds {count} pins. Remove one to add another, or see the plans for more.",
  "tools.data.pins.highest": "Highest",
  "tools.data.pins.lowest": "Lowest",
  "tools.data.pins.mode": "Pin on globe",
  "tools.data.pins.modeOff": "Pin mode off.",
  "tools.data.pins.name": "Pin {n}",
  "tools.data.pins.noDataset": "Load a dataset to place pins.",
  "tools.data.pins.nothing": "Nothing to read here",
  "tools.data.pins.picking": "Click the globe to drop a pin. Drag a pin to move it.",
  "tools.data.pins.picture": "This dataset is a picture: its colours carry no numbers, so pins cannot read it. Pins read the value-encoded streams, such as the real-time ones.",
  "tools.data.pins.plan": "Pins and the graph read real values, which is part of AYNI XR plans (from Plus up).",
  "tools.data.pins.remove": "Remove {name}",
  "tools.data.pins.removed": "Pin removed.",
  "tools.data.pins.rename": "Rename {name}",
  "tools.data.pins.renameField": "Name for this pin (left empty: {own})",
  "tools.data.pins.renamed": "Pin renamed {name}.",
  "tools.data.pins.renamedOwn": "The pin is called {name} again.",
  "tools.data.pins.seePlans": "See the plans",
  "tools.data.pins.shared": "Shared · follows the presenter",
  "tools.data.pins.surface.all": "Everywhere",
  "tools.data.pins.surface.changed": "Looking for the highest and lowest: {where}.",
  "tools.data.pins.surface.credit": "Land and sea: ICGC land cover map and coastline (CC BY 4.0) in Catalonia; © ESA WorldCover project 2021 / Contains modified Copernicus Sentinel data (2021) processed by ESA WorldCover consortium, along its borders; Natural Earth elsewhere. Lakes, rivers and the shore count as neither.",
  "tools.data.pins.surface.group": "Where to look for the highest and lowest",
  "tools.data.pins.surface.land": "Land only",
  "tools.data.pins.surface.loading": "Preparing the land and sea map…",
  "tools.data.pins.surface.none": "There is no land and sea map for this dataset yet, so the pins look everywhere.",
  "tools.data.pins.surface.pending": "Preparing the land and sea map; the pins appear when it is ready.",
  "tools.data.pins.surface.sea": "Sea only",
  "tools.data.pins.track": "Show track",
  "tools.data.pins.trackOff": "Track hidden.",
  "tools.data.pins.trackOn": "Track shown.",
  "tools.data.when.at": "at {where}",
  "tools.data.when.highest": "Highest",
  "tools.data.when.lowest": "Lowest",
  "tools.data.when.note": "Over the frames read: a frame not played yet may hold a higher or lower value. Press a date to play from it.",
  "tools.data.when.noteUndated": "Over the frames read; the times are playback times, as this dataset has no dates. Press a time to play from it.",
  "tools.data.when.partial": "From {read} of {total} frames read so far.",
  "tools.data.when.seek": "Play from {time}",
  "tools.data.when.ties": "and {count} other frames with the same value",
  "tools.data.when.tiesOne": "and 1 other frame with the same value",
  "tools.data.when.title": "Highest and lowest, and when",
  "tools.language.aria": "Choose language",
  "tools.layers.aria": "Map layers",
  "tools.layers.overlay": "Overlay",
  "tools.layers.overlay.cap": "Up to {count} at once; another replaces the first one you added.",
  "tools.layers.overlay.none": "None",
  "tools.layers.overlay.note": "Lines on top of the data: borders, coastlines or labels.",
  "tools.layers.pkg.atmosphere": "Atmosphere",
  "tools.layers.pkg.climate": "Climate",
  "tools.layers.pkg.fireAq": "Fire & AQ",
  "tools.layers.pkg.hazards": "Hazards",
  "tools.layers.pkg.ocean": "Ocean",
  "tools.layers.rt": "Real time",
  "tools.layers.rt.capMany": "Up to {count} play at once; another replaces the first one you added.",
  "tools.layers.rt.capOne": "One plays at a time on this device: it cannot play more at once.",
  "tools.layers.rt.capPlan": "Your plan plays one at a time; another replaces it.",
  "tools.layers.rt.datesLoading": "dates…",
  "tools.layers.rt.educationOnly": "\"{title}\" plays on the Education plans only (Teacher, School and District): its provider allows it for teaching, so it is not played over this dataset.",
  "tools.layers.rt.hidden": "{count} more streams have no dates in common with {title}, so they are not listed.",
  "tools.layers.rt.liveBadge": "LIVE",
  "tools.layers.rt.noMatch": "No stream matches “{query}”.",
  "tools.layers.rt.none": "None",
  "tools.layers.rt.note": "A live stream played over the dataset, on the same date.",
  "tools.layers.rt.outOfRangeNamed": "Hidden: {title} covers {start} – {end}, and the dataset is showing another date.",
  "tools.layers.rt.package": "{name} package",
  "tools.layers.rt.search": "Search {count} streams",
  "tools.layers.rt.searchAria": "Search real-time streams",
  "tools.layers.rt.topicOther": "Other",
  "tools.layers.tint": "Overlay colour",
  "tools.layers.tint.black": "Black",
  "tools.layers.tint.source": "Original colours",
  "tools.layers.tint.white": "White",
  "tools.layers.tintOf": "Colour of {name}",
  "tools.layout.aria": "Globe layout",
  "tools.layout.four": "Four globes in a grid",
  "tools.layout.four.unavailable": "Four globes need a larger screen",
  "tools.layout.planLocked": "More globes side by side come with other plans",
  "tools.layout.single": "Single globe",
  "tools.layout.twoHorizontal": "Two globes side-by-side",
  "tools.layout.twoVertical": "Two globes stacked",
  "tools.measure.aria": "Measure",
  "tools.measure.box": "Box",
  "tools.measure.line": "Line",
  "tools.measure.lineBoxPlan": "Line and Box come with the Education, Research and other plans",
  "tools.measure.noDataset": "Load a dataset to measure it.",
  "tools.measure.picture": "This dataset is a picture: its colours carry no numbers to measure. The value-encoded streams, such as the real-time ones, can be measured.",
  "tools.measure.region": "Region for the statistics",
  "tools.measure.stats": "Statistics",
  "tools.measure.statsPlan": "Statistics over a whole region come with the Research and Education plans. Box gives the numbers for an area you draw.",
  "tools.measure.title": "Measure",
  "tools.menu.aria": "Tools and settings",
  "tools.opacity.hidden": "The dataset is hidden: press to show it again",
  "tools.opacity.hide": "Hide the dataset on the globe",
  "tools.palette.announce": "Palette: {label}",
  "tools.palette.aria": "Colours",
  "tools.palette.classes": "This dataset shows classes, so its colours stay as published.",
  "tools.palette.group": "The same colours as every other {group} dataset, so they compare at a glance. Reset colours returns to them.",
  "tools.palette.groupName.temperature": "temperature",
  "tools.palette.groupOther": "The same colours as other datasets of this kind, so they compare at a glance. Reset colours returns to them.",
  "tools.palette.invalid": "The lower limit has to be below the upper one.",
  "tools.palette.invert": "Invert palette",
  "tools.palette.inverted.off": "Palette the right way round",
  "tools.palette.inverted.on": "Palette inverted",
  "tools.palette.limits": "Colour limits",
  "tools.palette.limitsHint": "The palette runs from the lower limit to the upper one; values beyond take its end colours.",
  "tools.palette.max": "Upper colour limit",
  "tools.palette.min": "Lower colour limit",
  "tools.palette.none": "Load a dataset that carries values to change its colours. Pictures keep the colours they were made with.",
  "tools.palette.resetDone": "Colours reset",
  "tools.palette.saved": "Your colours are kept for this dataset. Signed in, they follow your account.",
  "tools.palette.title": "Colours",
  "tools.palette.to": "to",
  "tools.plan.free": "Plan: Free",
  "tools.plan.named": "Plan: {plan}",
  "tools.plan.seePlans": "See the plans",
  "tools.plan.signIn": "Sign in",
  "tools.plan.signedOut": "Not signed in",
  "tools.plan.yourPlan": "Your plan",
  "tools.popover.title": "Tools",
  "tools.section.about": "About",
  "tools.section.about.aria": "About",
  "tools.section.data.aria": "Data tools",
  "tools.section.language": "Language",
  "tools.section.language.aria": "Language",
  "tools.section.layout": "Layout",
  "tools.section.layout.aria": "Layout",
  "tools.section.meeting": "Meeting",
  "tools.section.meeting.aria": "Meeting",
  "tools.section.view": "Display",
  "tools.section.view.aria": "Display",
  "tools.share.text": "Check out \"{title}\" on AYNI",
  "tools.specular.announce": "Sun glint: {label}",
  "tools.specular.aria": "Sun glint over water",
  "tools.specular.comfortable": "Comfortable",
  "tools.specular.default": "Default",
  "tools.specular.none": "None",
  "tools.specular.section": "Sun glint",
  "tools.specular.section.aria": "Sun glint over water",
  "tools.tab.data": "Data",
  "tools.tab.layers": "Layers",
  "tools.tab.more": "More",
  "tools.tab.view": "View",
  "tools.tabs.aria": "Tools sections",
  "tools.toggle.aria": "Tools and settings",
  "tools.toggle.label": "Tools",
  "tools.toggles.datasetInfo": "Dataset info",
  "tools.toggles.labels": "Labels",
  "tools.toggles.legend": "Legend",
  "tools.toggles.terrain": "3D terrain",
  "tools.uiScale.announce": "UI size: {label}",
  "tools.uiScale.aria": "UI size",
  "tools.uiScale.comfortable": "Comfortable",
  "tools.uiScale.compact": "Compact",
  "tools.uiScale.default": "Default",
  "tools.uiScale.section": "Display",
  "tools.uiScale.section.aria": "Display size",
  "undo.action": "Undo",
  "vector.inspect.link": "Source page ↗",
  "vector.legend.aria": "Legend of {title}",
  "viewport.driver.label": "{name} drives",
  "viewport.driver.you": "You drive this globe",
  "viewport.loadInto.done": "{title} loaded into globe {n}",
  "viewport.openBeside.done": "{title} opened in globe {n}",
  "viewport.openBeside.locked": "A second globe comes with other plans",
  "viewport.panel.addDataset": "+ Add a dataset",
  "viewport.panel.datasetChip.aria": "Globe {n}: {title}. Change its dataset",
  "viewport.panel.emptyChip.aria": "Globe {n} is empty. Load a dataset into it",
  "viewport.panel.pill.aria": "Switch to panel {n}",
  "viewport.panel.pill.title": "Globe {n}: make it the main one (its date and transport)",
  "viewport.panel.streamFailed": "Stopped updating",
  "viewport.panel.timeMismatch": "Showing {date}",
  "viewport.time.changed": "Globe {n} now shows: {label}",
  "viewport.time.chip.aria": "Date of globe {n}: {label}. Change it",
  "viewport.time.days": "{n} d",
  "viewport.time.fixed": "Held on {date}",
  "viewport.time.follow": "Same date",
  "viewport.time.menu.apply": "Apply",
  "viewport.time.menu.custom": "Another offset",
  "viewport.time.menu.fixed": "A fixed date",
  "viewport.time.menu.offsetLabel": "Offset from globe 1",
  "viewport.time.menu.title": "Date of globe {n}, against globe 1",
  "viewport.time.menu.unit.days": "days",
  "viewport.time.menu.unit.months": "months",
  "viewport.time.menu.unit.years": "years",
  "viewport.time.menu.unitLabel": "Unit",
  "viewport.time.months": "{n} mo",
  "viewport.time.preset.daysAhead.one": "{n} day later",
  "viewport.time.preset.daysAhead.other": "{n} days later",
  "viewport.time.preset.daysBack.one": "{n} day earlier",
  "viewport.time.preset.daysBack.other": "{n} days earlier",
  "viewport.time.preset.monthsAhead.one": "{n} month later",
  "viewport.time.preset.monthsAhead.other": "{n} months later",
  "viewport.time.preset.monthsBack.one": "{n} month earlier",
  "viewport.time.preset.monthsBack.other": "{n} months earlier",
  "viewport.time.preset.yearsAhead.one": "{n} year later",
  "viewport.time.preset.yearsAhead.other": "{n} years later",
  "viewport.time.preset.yearsBack.one": "{n} year earlier",
  "viewport.time.preset.yearsBack.other": "{n} years earlier",
  "viewport.time.years": "{n} yr",
  "vr.browse.allKinds": "All kinds",
  "vr.browse.allThemes": "All themes",
  "vr.browse.count": "{count} datasets",
  "vr.browse.empty": "No datasets here",
  "vr.browse.keyDone": "Done",
  "vr.browse.keySpace": "Space",
  "vr.browse.noMatch": "Nothing matches “{query}”",
  "vr.browse.noRecent": "Nothing opened yet. Datasets you open appear here.",
  "vr.browse.scrollHint": "Scroll with the thumbstick, a drag or the bar",
  "vr.browse.showing": "Showing",
  "vr.browse.title": "Browse",
  "vr.controllerTooltip.grip": "Grip: move",
  "vr.controllerTooltip.pin": "A / X: drop a pin",
  "vr.controllerTooltip.thumbstick": "Left stick: size · right: zoom",
  "vr.controllerTooltip.trigger": "Trigger: rotate",
  "vr.data.full": "Six pins is the most. Remove one to add another.",
  "vr.data.fullPlan": "Your plan holds {count} pins. Remove one to add another.",
  "vr.data.graphWaiting": "The graph fills in as the dataset plays.",
  "vr.data.noPins": "No pins yet.",
  "vr.data.none": "Load a dataset to place pins.",
  "vr.data.picture": "This dataset is a picture: its colours carry no numbers, so pins cannot read it. Pins read the value-encoded streams, such as the real-time ones.",
  "vr.data.pinHint": "Aim at the globe and press A or X · {count} of {max}",
  "vr.data.pinTitle": "Drop a pin",
  "vr.data.plan": "Pins and the graph read real values, which is part of AYNI XR plans (from Plus up). See the plans in the browser.",
  "vr.data.renameCancel": "Cancel",
  "vr.data.renameHint": "Type its name. Left empty, it is {own} again.",
  "vr.data.renameTitle": "Rename the pin",
  "vr.data.title": "Data",
  "vr.dock.browse": "Browse",
  "vr.dock.buffering": "Buffering…",
  "vr.dock.data": "Data",
  "vr.dock.exit": "Exit",
  "vr.dock.help": "Help",
  "vr.dock.layers": "Layers",
  "vr.dock.locked": "The presenter has the controls",
  "vr.dock.noDataset": "Choose a dataset in Browse",
  "vr.dock.speed": "{speed}×",
  "vr.dock.spin": "Spin",
  "vr.dock.spinRate": "Spin {rate}×",
  "vr.dock.still": "A still picture: nothing to play",
  "vr.dock.view": "View",
  "vr.enter.ar.label": "Enter AR",
  "vr.enter.ar.short": "AR",
  "vr.enter.ar.title": "Enter passthrough AR mode (globe appears in your room)",
  "vr.enter.aria": "Enter immersive VR mode",
  "vr.enter.label": "Enter VR",
  "vr.enter.title": "Enter immersive VR mode",
  "vr.error.failed": "Failed to enter {mode}",
  "vr.error.unsupported": "Immersive AR/VR isn't available on this device or browser.",
  "vr.help.exit.key": "Leave",
  "vr.help.exit.text": "Exit on the dock. The Meta button on the right controller leaves too.",
  "vr.help.exit.textOther": "Exit on the dock. Your headset’s own button leaves too.",
  "vr.help.exit.textWolvic": "Exit on the dock. The menu button on the left controller leaves too.",
  "vr.help.grip.key": "Grip on the globe",
  "vr.help.grip.text": "Carry it somewhere else.",
  "vr.help.more": "The full user manual is in the browser: Help → User manual.",
  "vr.help.spin.key": "Spin on the dock",
  "vr.help.spin.text": "Turns the globe by itself; each press goes round ½×, 1×, 2×, 4× and off.",
  "vr.help.tap.key": "A or X, aiming at the globe",
  "vr.help.tap.text": "Drops a pin there, up to six.",
  "vr.help.thumbstick.key": "Left thumbstick",
  "vr.help.thumbstick.text": "The globe's size, up to 5×; over a list, scrolls it.",
  "vr.help.title": "Using AYNI in the headset",
  "vr.help.trigger.key": "Trigger on the globe",
  "vr.help.trigger.text": "Drag to turn it.",
  "vr.help.twoTriggers.key": "Both triggers on the globe",
  "vr.help.twoTriggers.text": "Turn it and change its size.",
  "vr.help.zoom.key": "Right thumbstick",
  "vr.help.zoom.text": "Zooms in where it points; zoomed in, the trigger drags the map.",
  "vr.intro.f1.text": "The same panels as here, as sheets over the camera.",
  "vr.intro.f1.title": "Browse, layers and colours",
  "vr.intro.f2.text": "Turn on pin mode in Data and tap the globe, up to six times.",
  "vr.intro.f2.title": "Read values with pins",
  "vr.intro.f3.text": "Drag to spin and tilt. The slider on the right sets the size.",
  "vr.intro.f3.title": "One finger to turn it",
  "vr.intro.kicker": "Augmented reality",
  "vr.intro.needs": "A table or open floor works best. Needs Chrome on Android with Google Play Services for AR.",
  "vr.intro.notNow": "Not now",
  "vr.intro.start": "Start AR",
  "vr.intro.subtitle": "{title} comes with you, with its layers and colours.",
  "vr.intro.subtitleEmpty": "Choose a dataset there with Browse.",
  "vr.intro.title": "Put this globe in your room",
  "vr.khipu.following": "Following the presenter",
  "vr.khipu.media.one": "1 picture or link: see it outside the headset",
  "vr.khipu.media.other": "{count} pictures or links: see them outside the headset",
  "vr.khipu.more": "More text outside the headset",
  "vr.layers.none": "Layers load with a dataset.",
  "vr.layers.rtOrder": "Trigger on ⠿ and move up or down to change the order. The top one is drawn on top.",
  "vr.layers.rtTwo": "Two streams play three videos at once. If it stutters, keep one.",
  "vr.layers.title": "Layers",
  "vr.layers.upTo": "Up to {count}",
  "vr.loading.building": "Building scene…",
  "vr.loading.dataset": "Loading dataset…",
  "vr.loading.ready": "Ready",
  "vr.marker.hint.aligned": "Aligned. The green outline should sit on the marker's edge; if not, scan again",
  "vr.marker.hint.noCamera": "The camera picture is not available",
  "vr.marker.hint.noSurface": "Move the phone slowly so it can find the surface",
  "vr.marker.hint.notLevel": "Lay the marker flat on a table or the floor",
  "vr.marker.hint.offMarker": "Put the dot in the middle of the screen on the marker",
  "vr.marker.hint.searching": "Point the phone at the AYNI XR marker",
  "vr.marker.hint.steadying": "Marker found. Hold still",
  "vr.marker.noCameraAccess": "No camera access, so this phone can't scan the room's marker. Place still puts the globe on a table.",
  "vr.marker.scan": "Scan marker",
  "vr.marker.stop": "Stop scanning",
  "vr.notice.dismiss": "Dismiss",
  "vr.notice.loadFailed": "{title} could not be loaded. Try another dataset, or try again later.",
  "vr.notice.lockedEducationStream": "{title} is for the Education plans only. See the plans in the browser.",
  "vr.notice.lockedStream": "{title} needs the {package} package. See the plans in the browser.",
  "vr.notice.meetingSound.off": "The presenter is live. Press the speaker button on the dock to hear them.",
  "vr.notice.meetingSound.on": "The presenter is live and the sound is on. The speaker button on the dock turns it off.",
  "vr.notice.plansLater": "The plans are shown in the browser after you leave.",
  "vr.notice.presenter": "The presenter has the controls.",
  "vr.notice.streamPlan": "Your plan does not include this real-time data. See the plans in the browser.",
  "vr.notice.streamSignIn": "Sign in to play real-time data: press Exit and sign in in the browser.",
  "vr.phone.aimFirst": "Aim at a table or the floor until the ring shows, then tap Place.",
  "vr.phone.closeSheet": "Close",
  "vr.phone.dock": "AR tools",
  "vr.phone.exit": "Leave AR",
  "vr.phone.following": "Following the lead's globe",
  "vr.phone.help": "Help",
  "vr.phone.helpTitle": "Using AR",
  "vr.phone.hint": "One finger: spin and tilt",
  "vr.phone.legend": "Legend: tap for colours",
  "vr.phone.live": "LIVE",
  "vr.phone.mute": "Mute audio",
  "vr.phone.noLayers": "No layers to choose for this dataset.",
  "vr.phone.noPlace": "This phone can't find surfaces in this AR session, so the globe stays where it is.",
  "vr.phone.place": "Place",
  "vr.phone.speed": "Playback speed",
  "vr.phone.tip.browse": "Browse, Layers and View work as in the browser.",
  "vr.phone.tip.exit": "Leave AR with ✕ at the top.",
  "vr.phone.tip.pins": "In Data, turn on Pin on globe, then tap the globe to drop a pin.",
  "vr.phone.tip.place": "Place puts the globe on a table or the floor: aim at it and tap Place. It stays resting there at any size.",
  "vr.phone.tip.size": "The slider on the right sets its size.",
  "vr.phone.tip.spin": "Drag one finger on the globe to spin and tilt it.",
  "vr.phone.tools": "Tools",
  "vr.place.broughtHere": "Your globe was behind you or across the room, so it is in front of you now. Place puts it on a surface again.",
  "vr.place.headsetHeight": "Step 2 of 2: look up or down to set the height, then press the trigger.",
  "vr.place.headsetPosition": "Step 1 of 2: look at the floor or a table and press the trigger. A press on the dock cancels.",
  "vr.placement.aim": "Aim at a table or the floor, then tap Place",
  "vr.placement.cancel": "Cancel placement",
  "vr.placement.place": "Place",
  "vr.placement.replace": "Re-place",
  "vr.view.limitsNote": "Colour limits are set in the browser, in Tools → View.",
  "vr.view.picture": "This dataset is a picture: its colours were made with it and can't be changed here.",
  "vr.view.title": "View",
  "vr.voice.error": "Couldn’t hear that. Tap the mic to try again.",
  "vr.voice.listening": "Listening…",
  "vr.voice.listeningHint": "Ask Ayni Chatbot about the data, then tap the mic to send.",
  "vr.voice.speaker": "Ayni Chatbot",
  "vr.voice.thinking": "Thinking…",
  "vr.zoom.closest": "closest here",
  "vr.zoom.level": "Zoom {level}",
  "vr.zoomSlider.aria": "Zoom the globe",
  "vr.zoomSlider.label": "Zoom",
  "vr.zoomSlider.title": "Drag to zoom in or out",
  "xr.buy.already": "Your account already has a subscription. Change or cancel it in Manage subscription.",
  "xr.buy.continue": "Continue to payment",
  "xr.buy.done.body": "Payment received. Paddle emails you the receipt. The plan goes on your account and shows in Your plan.",
  "xr.buy.done.mine": "Open Your plan",
  "xr.buy.done.title": "Thank you",
  "xr.buy.error.academicEmail": "The academic price needs a university or research-institute email address. Sign in with one, choose Commercial, or request an invoice and tell us about your institution.",
  "xr.buy.error.hasLicence": "Your account already holds a licence for another plan. Remove it in Your plan first, or write to us.",
  "xr.buy.error.tooMany": "Too many attempts. Try again in an hour.",
  "xr.buy.error.tooManyLicences": "Your account already holds five licences, the most it can. Remove one in Your plan first.",
  "xr.buy.error.unavailable": "Online payment is not available right now. Try again later.",
  "xr.buy.error.unreachable": "The payment could not be opened. Check the connection and try again.",
  "xr.buy.opening": "Opening the payment…",
  "xr.buy.paddle": "Paddle, our reseller, takes the payment and adds your country's VAT; its checkout opens over this page. Cancel any time in Your plan → Manage subscription.",
  "xr.buy.seatsNote": "For up to {n} people: each signs in with their own account and enters the licence key, which we send you after the payment.",
  "xr.buy.signInFirst": "Sign in first: the plan goes on your account, on every device you sign in on.",
  "xr.buy.summary": "You are buying",
  "xr.cap.analysisFull": "statistics over any region",
  "xr.cap.chatbot": "Ayni Chatbot",
  "xr.cap.classroom": "class sessions",
  "xr.cap.data": "values, pins and graphs",
  "xr.cap.exportsAll": "every CSV export",
  "xr.cap.games": "games in meetings",
  "xr.cap.globes4": "four globes side by side",
  "xr.cap.host100": "meetings of up to 100 people",
  "xr.cap.host40": "meetings of up to 40 people",
  "xr.cap.host500": "meetings of up to 500 people",
  "xr.cap.khipuKeep": "Khipus kept until the licence ends",
  "xr.cap.lessons": "the lesson library",
  "xr.cap.live": "camera and microphone, live",
  "xr.cap.ownData": "your own data as private streams",
  "xr.cap.research": "the research tools (compare with a baseline frame; trends, time of emergence and correlation on pins)",
  "xr.mine.aLicence": "AYNI XR",
  "xr.mine.activate": "Activate",
  "xr.mine.activated": "Activated. Welcome.",
  "xr.mine.activating": "Activating…",
  "xr.mine.addAnother": "Add another key",
  "xr.mine.added": "Added, and in use now.",
  "xr.mine.addedKept": "Added. The licence in use stays the same.",
  "xr.mine.already": "That licence is already on your account.",
  "xr.mine.billing.cancels": "Cancelled: it ends on {date} and does not renew.",
  "xr.mine.billing.chargeback": "Payment disputed on {date}: the plan has ended.",
  "xr.mine.billing.ended": "Ended on {date}.",
  "xr.mine.billing.keyFailed": "The key could not be fetched. Try again in a moment.",
  "xr.mine.billing.keyNone": "There is no key to share yet: the licence is still being issued. Try again in a few minutes.",
  "xr.mine.billing.keyNote": "Give this key to the people the licence covers ({seats} in all, you included): each signs in and enters it in Your plan.",
  "xr.mine.billing.licencePending": "Your subscription is paid; its licence is being added to your account.",
  "xr.mine.billing.manage": "Manage subscription",
  "xr.mine.billing.manageNote": "Cancel, change the card or download invoices on Paddle's page.",
  "xr.mine.billing.pastDue": "The last payment did not go through. Update your card in Manage subscription before {date}, or the plan stops then.",
  "xr.mine.billing.paused": "Paused: nothing is charged and the plan is stopped.",
  "xr.mine.billing.portalFailed": "Paddle's page could not be opened. Try again in a moment.",
  "xr.mine.billing.renewsMonth": "Monthly; renews on {date}",
  "xr.mine.billing.renewsYear": "Yearly; renews on {date}",
  "xr.mine.billing.revoked": "Refunded on {date}: the plan has ended.",
  "xr.mine.billing.showKey": "Show the key to share",
  "xr.mine.billing.title": "Subscription",
  "xr.mine.error.invalidKey": "That licence key was not recognised.",
  "xr.mine.error.licenseExpired": "This licence has ended.",
  "xr.mine.error.licenseRevoked": "This licence was revoked.",
  "xr.mine.error.licenseSuspended": "This licence is suspended.",
  "xr.mine.error.redeemExpired": "That key was not activated in time.",
  "xr.mine.error.seatTaken": "Every seat on this licence is in use, so another account took this one.",
  "xr.mine.error.signedOut": "Your session has ended. Sign in again.",
  "xr.mine.error.tooMany": "This account already holds the most licences it can. Remove one first.",
  "xr.mine.error.transferLimit": "That key has moved between browsers too often this month.",
  "xr.mine.error.unknown": "The key could not be activated. Try again in a moment.",
  "xr.mine.error.unreachable": "The licence server could not be reached. Check the connection and try again.",
  "xr.mine.error.wrongProduct": "That key is for another AYNI product.",
  "xr.mine.expired": "This licence has ended.",
  "xr.mine.extras": "Extras on this licence: {list}",
  "xr.mine.full": "This account holds {max} licences, the most it can. Remove one to add another.",
  "xr.mine.holder": "Licensed to {name}",
  "xr.mine.inUse": "In use",
  "xr.mine.key": "Key ending {hint}",
  "xr.mine.keyLabel": "Licence key",
  "xr.mine.keyPlaceholder": "AYNI-XXXXX-XXXXX-XXXXX-XXXXX",
  "xr.mine.lease": "The licence server has not been reached in a while; it is checked again automatically.",
  "xr.mine.licencesTitle": "Your licences: {count} of {max}",
  "xr.mine.noPlan": "This licence has no AYNI XR plan on it.",
  "xr.mine.none": "Your account has no licence yet. Free use needs none: the catalogue, joining rooms and meetings, and rooms with friends.",
  "xr.mine.notCurrent": "That licence is not current, so it cannot be used.",
  "xr.mine.packages": "Live data: {list}",
  "xr.mine.packagesAll": "Live data: every package",
  "xr.mine.packagesNone": "Live data: none",
  "xr.mine.remove": "Remove from my account",
  "xr.mine.removed": "The licence was taken off your account, and its seat is free again.",
  "xr.mine.renews": "Paid until {date}",
  "xr.mine.seePlans": "See the plans",
  "xr.mine.signInFirst": "Sign in to add your licence key. Your account then holds the licence on every device you sign in on, using one seat.",
  "xr.mine.signedInAs": "Signed in as {email}",
  "xr.mine.startMeeting": "Start a meeting",
  "xr.mine.streamToday": "Streamed today: {used} of {cap}",
  "xr.mine.switchBlocked": "Finish presenting your meeting before you switch licences.",
  "xr.mine.switched": "You are now using your {plan} licence. What is on screen stays, except anything this plan does not include.",
  "xr.mine.switching": "Switching…",
  "xr.mine.title": "Your plan",
  "xr.mine.use": "Use this one",
  "xr.mine.useNow": "Use it now",
  "xr.package.atmosphere.desc": "Clouds, satellite views, rain, temperature, wind, lightning and forecasts, with regional sets for Spain, the Netherlands and the United States.",
  "xr.package.atmosphere.name": "Atmosphere & Weather",
  "xr.package.climate.desc": "Climate projections under four scenarios, observed change, greenhouse gases, ice, drought, water on land and vegetation.",
  "xr.package.climate.name": "Climate",
  "xr.package.fireAq.desc": "Active fires, burned area, smoke and aerosols, black carbon, nitrogen dioxide, sulphur dioxide, ozone and PM2.5.",
  "xr.package.fireAq.name": "Fire, Smoke & Air Quality",
  "xr.package.ocean.desc": "Sea temperature and heatwaves, currents, coral bleaching, sea level and ocean acidification, observed and projected.",
  "xr.package.ocean.name": "Ocean",
  "xr.plan.department.name": "Department",
  "xr.plan.district.name": "District",
  "xr.plan.lab.name": "Lab",
  "xr.plan.mediaDesk.name": "Media Desk",
  "xr.plan.newsroom.name": "Newsroom",
  "xr.plan.plus.name": "Plus",
  "xr.plan.researcher.name": "Researcher",
  "xr.plan.school.name": "School",
  "xr.plan.situationOrg.name": "Situation Room Organisation",
  "xr.plan.situationTeam.name": "Situation Room Team",
  "xr.plan.situationTeamPlus.name": "Situation Room Team Plus",
  "xr.plan.teacher.name": "Teacher",
  "xr.plan.venue.name": "Venue",
  "xr.plans.academicEmail": "Academic prices need a university or research-institute email address: the checkout reads the address you sign in with. Otherwise ask us.",
  "xr.plans.buy": "Buy",
  "xr.plans.byQuote": "By quote",
  "xr.plans.cap.activities": "Explore, questions on the globe, hand over the globe",
  "xr.plans.cap.allPackages": "Every live data package",
  "xr.plans.cap.anomalies": "Anomalies against a climatology (such as 2.1 °C above the 1991–2020 normal) and publication figures (PNG at 300 dpi, SVG)",
  "xr.plans.cap.branding": "Your branding, clean output for keying",
  "xr.plans.cap.chatDaily": "Ayni Chatbot: {n} questions a day",
  "xr.plans.cap.chatbot": "Ayni Chatbot: finds data, moves the globe, reads values and follows pins",
  "xr.plans.cap.credits": "{n} render credits a year for high-quality video and images",
  "xr.plans.cap.creditsRollover": "Unused credits are kept for 12 months, up to a year’s allowance",
  "xr.plans.cap.dataBasic": "Values, pins and graphs; Line and Box; the pins as CSV",
  "xr.plans.cap.dataBoxAll": "Values, pins and graphs; Line and Box; every CSV export",
  "xr.plans.cap.dataFull": "Values, pins and graphs; Line, Box and statistics over any region; every CSV export",
  "xr.plans.cap.dataFullPins": "Values, pins and graphs; Line, Box and statistics over any region; the pins as CSV",
  "xr.plans.cap.dataPins": "Values under the pointer, {n} pins and their graph",
  "xr.plans.cap.globeOne": "One globe",
  "xr.plans.cap.globes": "Up to {n} globes side by side",
  "xr.plans.cap.hazards": "Every live data package, with hazards and alerts",
  "xr.plans.cap.host": "Host meetings of up to {n} people",
  "xr.plans.cap.khipus": "Khipus: open, play and download stories, lessons and records; save a meeting as one",
  "xr.plans.cap.khipusKept": "Keep up to {n} Khipus, until the licence ends plus {days} days",
  "xr.plans.cap.khipusPlay": "Khipus: open and play stories, lessons and records (none are kept)",
  "xr.plans.cap.live": "Your camera and microphone, live",
  "xr.plans.cap.liveHighlights": "Live Earth: every real-time stream and forecast, and 27 climate highlights (yearly records and projections)",
  "xr.plans.cap.overlayOne": "One real-time overlay at a time",
  "xr.plans.cap.overlays": "Up to {n} real-time overlay at a time",
  "xr.plans.cap.personal": "For one person, personal and non-commercial use",
  "xr.plans.cap.research": "Research tools: hold a frame as a baseline and read every other frame against it, in numbers and as a change map on the globe; test the pins' series for a trend, its time of emergence and their correlation",
  "xr.plans.cap.rooms": "Rooms of up to {n} people, in person",
  "xr.plans.cap.streamDaily": "Streams: {amount} a day",
  "xr.plans.close": "Close",
  "xr.plans.footer": "Prices are per year, in euros, excluding VAT; Plus includes VAT. Payment is by invoice; online payment is coming.",
  "xr.plans.footerOnline": "Prices are in euros, excluding VAT; Plus includes VAT. Plus and the Education and Research plans can be paid online through Paddle, which adds your country’s VAT at checkout to the others; every plan can also be paid by invoice.",
  "xr.plans.free.current": "Always free",
  "xr.plans.free.globes": "One globe at a time",
  "xr.plans.free.join": "Join any room or meeting, with no account",
  "xr.plans.free.name": "Free",
  "xr.plans.free.price": "€0",
  "xr.plans.free.rooms": "Rooms with friends, up to 5 people",
  "xr.plans.free.sos": "The Science On a Sphere catalogue",
  "xr.plans.free.who": "Anyone",
  "xr.plans.fromPerYear": "From €{amount} / year",
  "xr.plans.held": "Your licences:",
  "xr.plans.heldInUse": "{plan} (in use)",
  "xr.plans.highlights.body": "Live Earth is every real-time stream and forecast: weather, air, fires, oceans, ice, hazards and the Sun. The 27 climate highlights are yearly records and projections: global temperature since 1850, carbon dioxide and methane, sea ice and sea level, climate zones under low and high emissions, burned land, where people live, decades of storms and earthquakes, and 50 years of weather satellites. The full climate record comes with the other plans.",
  "xr.plans.highlights.title": "Live Earth and the climate highlights",
  "xr.plans.interval.aria": "Billing period",
  "xr.plans.interval.month": "Monthly",
  "xr.plans.interval.year": "Yearly",
  "xr.plans.lead": "A free account gives you the whole Science On a Sphere catalogue; joining a room or a meeting needs no account at all. Plans are for presenting, live data and reading values off it.",
  "xr.plans.orInvoice": "Or request an invoice",
  "xr.plans.ownDataSoon": "With your own data streaming (coming soon): €{academic} academic, €{commercial} commercial, a year",
  "xr.plans.packages.title": "What the live data covers",
  "xr.plans.perMonth": "or €{amount} / month",
  "xr.plans.perMonthVat": "or €{amount} / month, VAT included",
  "xr.plans.perMonthVatMain": "€{amount} / month, VAT included",
  "xr.plans.perYear": "€{amount} / year",
  "xr.plans.perYearVat": "€{amount} / year, VAT included",
  "xr.plans.quoteRequest": "Ask for a quote",
  "xr.plans.request": "Request an invoice",
  "xr.plans.researchPrices": "€{academic} / year for academic use · €{commercial} / year for commercial use",
  "xr.plans.seats.many": "Up to {n} people",
  "xr.plans.seats.one": "1 person",
  "xr.plans.seats.quote": "As many as you need",
  "xr.plans.segments.aria": "Who it is for",
  "xr.plans.situationPilot": "Pilot projects: ask us.",
  "xr.plans.title": "Plans for AYNI XR",
  "xr.plans.use.academic": "Academic",
  "xr.plans.use.aria": "Use",
  "xr.plans.use.commercial": "Commercial",
  "xr.plans.withVatMonth": "{amount} a month with your country's VAT",
  "xr.plans.withVatYear": "{amount} a year with your country's VAT",
  "xr.request.back": "Back to the plans",
  "xr.request.challengeFailed": "The check did not pass. Please try the check again.",
  "xr.request.country": "Country",
  "xr.request.done.body": "Your reference is {ref}. We will email the invoice to {email}; your licence key follows once it is paid.",
  "xr.request.done.title": "Request received",
  "xr.request.email": "Email for the invoice",
  "xr.request.failed": "The request could not be sent. Try again in a moment.",
  "xr.request.message": "Anything we should know (optional)",
  "xr.request.missing": "Fill in the organisation, your name, an email and the country.",
  "xr.request.name": "Your name",
  "xr.request.notice": "We keep these details to prepare your invoice and licence, as the privacy policy explains.",
  "xr.request.noticeLink": "Privacy policy",
  "xr.request.organisation": "Organisation",
  "xr.request.po": "Purchase order number (optional)",
  "xr.request.seats": "People who will present",
  "xr.request.send": "Send the request",
  "xr.request.sending": "Sending…",
  "xr.request.summary": "You are asking for",
  "xr.request.title": "Request an invoice",
  "xr.request.vat": "VAT number (optional)",
  "xr.segment.education.lead": "Middle and high schools: teachers present and run lessons; students watch and answer, free and without accounts.",
  "xr.segment.education.name": "Education",
  "xr.segment.media.lead": "Reporters, weather presenters and AV studios: broadcast-quality footage with the data, your branding, and server renders paid with credits.",
  "xr.segment.media.name": "Media",
  "xr.segment.public.lead": "The Science On a Sphere catalogue is free. Plus adds Live Earth, 27 climate highlights and the values on the data, for personal use.",
  "xr.segment.public.name": "Everyone",
  "xr.segment.research.lead": "Scientists, modellers, universities and agencies: the data and the tools to read it, compare it and present it.",
  "xr.segment.research.name": "Research",
  "xr.segment.situation.lead": "Civil protection, disaster management, policy and planning: the latest real-time data and forecasts, briefings and decisions on the record.",
  "xr.segment.situation.name": "Situation rooms",
  "xr.segment.venue.lead": "Science centres, planetariums, aquariums and visitor centres: shared AR in the hall, public events and school groups.",
  "xr.segment.venue.name": "Museums",
  "zip.action.cancel": "Cancel",
  "zip.action.start": "Start download",
  "zip.action.zipDownload": "Download as .zip",
  "zip.action.zipDownload.aria": "Download {title} as a zip archive",
  "zip.action.zipDownload.title": "Download this dataset as a .zip archive",
  "zip.asset.caption": "Captions",
  "zip.asset.colorTable": "Color table",
  "zip.asset.frames": "Source frames ({count})",
  "zip.asset.legend": "Legend",
  "zip.asset.manifest": "manifest.json",
  "zip.asset.primary": "Primary data",
  "zip.asset.thumbnail": "Thumbnail",
  "zip.assets.aria": "Assets to include in the archive",
  "zip.cancelled.announce": "Zip download cancelled.",
  "zip.completed.announce": "Saved {filename} ({size}).",
  "zip.completed.withFailures.announce": "Saved {filename} ({size}); {count} asset(s) failed and were recorded in manifest.json.",
  "zip.dialog.close.aria": "Close download dialog",
  "zip.dialog.loading": "Resolving assets…",
  "zip.dialog.title": "Download dataset",
  "zip.error.datasetMissing": "Dataset is no longer available.",
  "zip.error.downloadFailed": "Download failed: {reason}",
  "zip.progress.done": "Finished.",
  "zip.progress.fetching": "Fetching assets…",
  "zip.progress.fetchingNamed": "Fetching {file}…",
  "zip.progress.packaging": "Packaging into zip…",
  "zip.progress.starting": "Starting…",
  "zip.size.alwaysIncluded": "always included",
  "zip.size.approxPrefix": "≈",
  "zip.size.estimating": "Estimating size…",
  "zip.size.overCap": "This archive would exceed the {cap} cap. Uncheck some assets to reduce the size.",
  "zip.size.overWarn": "This archive is larger than {warn}. Browser tabs can run out of memory on multi-GB downloads.",
  "zip.size.total": "Estimated total: {size}",
  "zip.size.unknown": "size unknown",
  "zip.source.external": "Asset hosted externally; see manifest for source URLs.",
  "zip.source.library": "Downloaded from AYNI’s library of NOAA Science On a Sphere datasets, as published. Credit NOAA Science On a Sphere and the dataset’s creators.",
  "zip.source.libraryAyni": "Downloaded from AYNI’s library, as AYNI made it from its source. Credit {org}.",
  "zip.source.publisher": "Downloaded as source data from the publisher upload.",
} as const

export const enMessages: Readonly<Record<string, string>> = enLiteral

/**
 * Literal-key union when entries exist; widens to `string` while
 * `en.json` is empty so callers aren't blocked.
 */
export type MessageKey = keyof typeof enLiteral extends never
  ? string
  : keyof typeof enLiteral

/** Lazy loaders, one per locale. English resolves synchronously. */
export const localeLoaders: Readonly<
  Record<Locale, () => Promise<Readonly<Record<string, string>>>>
> = {
  "ca": () => import('./messages.ca').then((m) => m.default),
  "en": async () => enMessages,
  "es": () => import('./messages.es').then((m) => m.default),
}
